webpackJsonp([1],{

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_dist_vue_min_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_dist_vue_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_dist_vue_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Landing__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Landing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Landing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TraCuuHoSo__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TraCuuHoSo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_TraCuuHoSo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ChiTietHoSo__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ChiTietHoSo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ChiTietHoSo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TraCuuHomePage__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TraCuuHomePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_TraCuuHomePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ChiTietHoSoHomePage__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ChiTietHoSoHomePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ChiTietHoSoHomePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_TraCuuThuTuc__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_TraCuuThuTuc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_TraCuuThuTuc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ChiTietThuTuc__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ChiTietThuTuc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_ChiTietThuTuc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_DanhGiaCanBo__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_DanhGiaCanBo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_DanhGiaCanBo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ChiTietDanhGiaCanBo__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ChiTietDanhGiaCanBo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_ChiTietDanhGiaCanBo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_DanhGiaChatLuongDichVu__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_DanhGiaChatLuongDichVu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_DanhGiaChatLuongDichVu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_HoSoKetQua__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_HoSoKetQua___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_HoSoKetQua__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_HoSoTiepNhan__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_HoSoTiepNhan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_HoSoTiepNhan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_DanhSachCanBo__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_DanhSachCanBo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_DanhSachCanBo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_CheckPassword__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_CheckPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_CheckPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_CheckPasswordHP__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_CheckPasswordHP___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_CheckPasswordHP__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_ChiTietHoSoQR__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_ChiTietHoSoQR___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_ChiTietHoSoQR__);



















var routes = [{ path: '/', name: 'TraCuuHoSo', component: __WEBPACK_IMPORTED_MODULE_3__components_TraCuuHoSo___default.a, props: false }, { path: '/tra-cuu-ho-so', name: 'TraCuuHoSo', component: __WEBPACK_IMPORTED_MODULE_3__components_TraCuuHoSo___default.a, props: false }, { path: '/ho-so/:index', name: 'ChiTietHoSo', component: __WEBPACK_IMPORTED_MODULE_4__components_ChiTietHoSo___default.a, props: true }, { path: '/tra-cuu-ho-so-homepage', name: 'TraCuuHomePage', component: __WEBPACK_IMPORTED_MODULE_5__components_TraCuuHomePage___default.a, props: false }, { path: '/thong-tin-ho-so/:index', name: 'ChiTietHoSoHomePage', component: __WEBPACK_IMPORTED_MODULE_6__components_ChiTietHoSoHomePage___default.a, props: true }, { path: '/tra-cuu-thu-tuc', name: 'TraCuuThuTuc', component: __WEBPACK_IMPORTED_MODULE_7__components_TraCuuThuTuc___default.a, props: false }, { path: '/tra-cuu-thu-tuc/:index', name: 'ChiTietThuTuc', component: __WEBPACK_IMPORTED_MODULE_8__components_ChiTietThuTuc___default.a, props: true }, { path: '/danh-gia-can-bo', name: 'DanhGiaCanBo', component: __WEBPACK_IMPORTED_MODULE_9__components_DanhGiaCanBo___default.a, props: false }, { path: '/danh-sach-can-bo/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_ChiTietDanhGiaCanBo___default.a, props: true }, { path: '/danh-gia-cldv', name: 'DanhGiaChatLuongDichVu', component: __WEBPACK_IMPORTED_MODULE_11__components_DanhGiaChatLuongDichVu___default.a, props: false }, { path: '/ho-so-co-ket-qua', name: 'HoSoKetQua', component: __WEBPACK_IMPORTED_MODULE_12__components_HoSoKetQua___default.a, props: false }, { path: '/tiep-nhan-ho-so', name: 'HoSoTiepNhan', component: __WEBPACK_IMPORTED_MODULE_13__components_HoSoTiepNhan___default.a, props: false }, { path: '/danh-sach-can-bo', name: 'DanhSachCanBo', component: __WEBPACK_IMPORTED_MODULE_14__components_DanhSachCanBo___default.a, props: false }, { path: '/ma-truy-cap', name: 'CheckPassword', component: __WEBPACK_IMPORTED_MODULE_15__components_CheckPassword___default.a, props: false }, { path: '/ma-truy-cap-ho-so', name: 'CheckPasswordHP', component: __WEBPACK_IMPORTED_MODULE_16__components_CheckPasswordHP___default.a, props: false }, { path: '/tra-cuu-thong-tin-ho-so/:index', name: 'ChiTietHoSoQR', component: __WEBPACK_IMPORTED_MODULE_17__components_ChiTietHoSoQR___default.a, props: true }];

__WEBPACK_IMPORTED_MODULE_0_vue_dist_vue_min_js___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: routes
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(532),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "D:\\FDS\\frontend-opencps-v2.1\\onegate_21_kios_bng\\src\\components\\Captcha.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Captcha.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-738ec94e", Component.options)
  } else {
    hotAPI.reload("data-v-738ec94e", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(521),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "D:\\FDS\\frontend-opencps-v2.1\\onegate_21_kios_bng\\src\\components\\ChiTietDanhGiaCanBo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ChiTietDanhGiaCanBo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-16bb497c", Component.options)
  } else {
    hotAPI.reload("data-v-16bb497c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(537),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "D:\\FDS\\frontend-opencps-v2.1\\onegate_21_kios_bng\\src\\components\\ChiTietHoSo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ChiTietHoSo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a934592c", Component.options)
  } else {
    hotAPI.reload("data-v-a934592c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(540),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "D:\\FDS\\frontend-opencps-v2.1\\onegate_21_kios_bng\\src\\components\\ChiTietHoSoHomePage.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ChiTietHoSoHomePage.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e68a7ad0", Component.options)
  } else {
    hotAPI.reload("data-v-e68a7ad0", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(534),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "D:\\FDS\\frontend-opencps-v2.1\\onegate_21_kios_bng\\src\\components\\ChiTietThuTuc.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ChiTietThuTuc.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7e6cf8a8", Component.options)
  } else {
    hotAPI.reload("data-v-7e6cf8a8", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(535),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "D:\\FDS\\frontend-opencps-v2.1\\onegate_21_kios_bng\\src\\components\\pagination2.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] pagination2.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-96f97b52", Component.options)
  } else {
    hotAPI.reload("data-v-96f97b52", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__support_json__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__support_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__support_json__);







__WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js___default.a.use(__WEBPACK_IMPORTED_MODULE_3_toastr___default.a);
var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: {
    initData: __WEBPACK_IMPORTED_MODULE_5__support_json___default.a.initData,
    endPoint: '/o/rest/v2',

    originality: '',
    groupIdSite: '',
    totalEmployee: 0,
    filterDossierKey: {
      dossierNo: '',
      applicantIdNo: '',
      secretCode: ''
    },
    workingUnitSelect: null,
    employeeSelected: '',
    loading: false,
    dossierDetail: {},
    index: 0,
    activeDetailService: false,
    applicantIdNoSearch: '',
    dossierNoSearch: '',
    fullScreen: false,
    isMobile: false
  },
  actions: {
    loadInitResource: function loadInitResource(_ref) {
      var commit = _ref.commit,
          state = _ref.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (window.themeDisplay !== null && window.themeDisplay !== undefined) {
          state.initData['groupId'] = window.themeDisplay.getScopeGroupId();
          state.initData['user'] = {
            'userName': window.themeDisplay.getUserName(),
            'userEmail': '',
            'userId': window.themeDisplay.getUserId()
          };
        } else {
          state.initData['groupId'] = 0;
          state.initData['user'] = {
            'userName': '',
            'userEmail': '',
            'userId': 20103
          };
        }
        resolve(state.initData);
      });
    },
    loadingDataHoSo: function loadingDataHoSo(_ref2, filter) {
      var commit = _ref2.commit,
          state = _ref2.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            headers: {
              groupId: state.initData.groupId
            },
            params: {
              start: filter.page * 10 - 10,
              end: filter.page * 10,
              dossierNo: filter.dossierNo ? filter.dossierNo : '',
              applicantIdNo: filter.applicantIdNo ? filter.applicantIdNo : ''
            }
          };
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(state.endPoint + '/dossiers', param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadingDataHoSoKQ: function loadingDataHoSoKQ(_ref3, filter) {
      var commit = _ref3.commit,
          state = _ref3.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            headers: {
              groupId: filter['groupId'] ? filter['groupId'] : state.initData.groupId
            },
            params: {
              step: '300,310,400',
              fromReleaseDate: filter.fromDate ? filter.fromDate : '',
              toReleaseDate: filter.toDate ? filter.toDate : '',
              keyword: filter.keyword ? filter.keyword : ''
            }
          };

          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(state.endPoint + '/dossiers/publish/searchDossiers', param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject([]);
          });
        });
      });
    },
    loadingDataHoSoTN: function loadingDataHoSoTN(_ref4, filter) {
      var commit = _ref4.commit,
          state = _ref4.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            headers: {
              groupId: filter['groupId'] ? filter['groupId'] : state.initData.groupId
            },
            params: {
              fromReceiveDate: filter.fromDate,
              toReceiveDate: filter.toDate,
              keyword: filter.keyword ? filter.keyword : ''
            }
          };
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(state.endPoint + '/dossiers', param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    getDomainLists: function getDomainLists(_ref5, data) {
      var commit = _ref5.commit,
          state = _ref5.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            headers: {
              groupId: state.initData.groupId
            }
          };
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(state.endPoint + '/serviceinfos/statistics/domains', param).then(function (response) {
            var serializable = response.data;
            if (serializable.data) {
              var dataReturn = serializable.data;
              resolve(dataReturn);
            } else {
              resolve([]);
            }
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    getDomainListsPublic: function getDomainListsPublic(_ref6, filter) {
      var commit = _ref6.commit,
          state = _ref6.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            headers: {
              groupId: state.initData.groupId
            },
            params: {
              start: filter.page * 10 - 10,
              end: filter.page * 10
            }
          };

          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(state.endPoint + '/serviceconfigs/pubish/' + filter.administrationCode + '/domains', param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    getGovAgency: function getGovAgency(_ref7, data) {
      var commit = _ref7.commit,
          state = _ref7.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            headers: {
              groupId: state.initData.groupId
            }
          };
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(state.endPoint + '/serviceinfos/statistics/agencies', param).then(function (response) {
            var serializable = response.data;
            if (serializable.data) {
              var dataReturn = serializable.data;
              resolve(dataReturn);
            } else {
              resolve([]);
            }
          }).catch(function (xhr) {
            console.log(xhr);
          });
        });
      });
    },
    agencies: function agencies(_ref8) {
      var commit = _ref8.commit,
          state = _ref8.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var groupIdCurrent = '';
          var groupIdArr = [];
          var groupIds = state.groupIdSite;
          if (groupIds) {
            groupIdArr = groupIds.split(',');
          }
          if (groupIdArr.length === 0) {
            groupIdCurrent = window.themeDisplay ? window.themeDisplay.getScopeGroupId() : '';
          }
          if (groupIdArr.length === 1) {
            groupIdCurrent = groupIdArr[0];
          }
          var filter = {
            groupId: groupIdCurrent
          };
          store.dispatch('getGovAgency', filter).then(function (result) {
            console.log('agencies', result);
            resolve(result);
          }).catch(function (reject) {
            resolve([]);
          });
        });
      });
    },
    getGovAgencyDictItem: function getGovAgencyDictItem(_ref9, data) {
      var commit = _ref9.commit,
          state = _ref9.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            headers: {
              groupId: state.initData.groupId
            }
          };
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(state.endPoint + '/dictcollections/GOVERNMENT_AGENCY/dictitems', param).then(function (response) {
            var serializable = response.data;
            if (serializable.data) {
              var dataReturn = serializable.data;
              resolve(dataReturn);
            } else {
              resolve([]);
            }
          }).catch(function (xhr) {
            console.log(xhr);
          });
        });
      });
    },
    getLevelLists: function getLevelLists(_ref10, data) {
      var commit = _ref10.commit,
          state = _ref10.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            headers: {
              groupId: state.initData.groupId
            }
          };
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(state.endPoint + '/serviceinfos/statistics/levels', param).then(function (response) {
            var serializable = response.data;
            if (serializable.data) {
              var dataReturn = serializable.data;
              resolve(dataReturn);
            } else {
              resolve([]);
            }
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    getServiceLists: function getServiceLists(_ref11, filter) {
      var commit = _ref11.commit,
          state = _ref11.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            headers: {
              groupId: state.initData.groupId
            },
            params: {
              start: filter.page * 10 - 10,
              end: filter.page * 10,
              administration: filter.administration ? filter.administration : '',
              keyword: filter.keyword ? filter.keyword : '',
              level: filter.level ? filter.level : 0,
              domain: filter.domain ? filter.domain : ''
            }
          };
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(state.endPoint + '/serviceinfos', param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    getServiceDetail: function getServiceDetail(_ref12, filter) {
      var commit = _ref12.commit,
          state = _ref12.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            headers: {
              groupId: state.initData.groupId
            }
          };
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(state.endPoint + '/serviceinfos/' + filter.index, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    getDossierDetail: function getDossierDetail(_ref13, filter) {
      var commit = _ref13.commit,
          state = _ref13.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            headers: {
              groupId: state.initData.groupId
            }
          };
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(state.endPoint + '/dossiers/' + filter.dossierId, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    getDossierDetailPass: function getDossierDetailPass(_ref14, filter) {
      var commit = _ref14.commit,
          state = _ref14.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            headers: {
              groupId: state.initData.groupId,
              secretCode: filter.password
            },
            params: {}
          };
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(state.endPoint + '/dossiers/' + filter.dossierId, param).then(function (response) {
            var serializable = response.data;
            console.log('response', response);
            resolve(response);
          }).catch(function (error) {
            console.log('error', error);
            reject(error);
          });
        });
      });
    },
    getDetailDossierQR: function getDetailDossierQR(_ref15, filter) {
      var commit = _ref15.commit,
          state = _ref15.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            headers: {
              groupId: state.initData.groupId
            },
            params: {
              secretKey: filter.secretKey
            }
          };
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(state.endPoint + '/dossiers/' + filter.dossierId, param).then(function (response) {
            var serializable = response.data;
            console.log('response', response);
            resolve(response);
          }).catch(function (error) {
            console.log('error', error);
            reject(error);
          });
        });
      });
    },
    getListHistoryProcessingItems: function getListHistoryProcessingItems(_ref16, filter) {
      var commit = _ref16.commit,
          state = _ref16.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            headers: {
              groupId: state.initData.groupId
            }
          };
          var listHistoryProcessing = [];

          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(state.endPoint + '/dossierlogs/' + filter.dossierId + '/logs', param).then(function (response) {
            var serializable = response.data;
            for (var key in serializable.data) {
              if (serializable.data[key].notificationType === 'PROCESS_TYPE') {
                listHistoryProcessing.push(serializable.data[key]);
              }
            }
            resolve(listHistoryProcessing);
          }).catch(function (error) {
            reject(error);
          });
        });
      });
    },
    loadDossierActions: function loadDossierActions(_ref17, data) {
      var commit = _ref17.commit,
          state = _ref17.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var config = {
            headers: {
              groupId: state.initData.groupId
            }
          };
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(state.endPoint + '/dossiers/' + data.dossierId + '/sequences', config).then(function (response) {
            resolve(response.data);
          }).catch(function (xhr) {
            reject(xhr);
          });
        });
      });
    },
    loadDossierTemplates: function loadDossierTemplates(_ref18, filter) {
      var commit = _ref18.commit,
          state = _ref18.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            headers: {
              groupId: state.initData.groupId
            }
          };
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(state.endPoint + '/dossiertemplates/' + filter.dossierTemplateNo, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable.dossierParts);
          }).catch(function (reject) {
            console.log(reject);
          });
        });
      });
    },
    loadEmployees: function loadEmployees(_ref19, filter) {
      var commit = _ref19.commit,
          state = _ref19.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result1) {
          var param = {
            headers: {
              groupId: state.initData.groupId
            },
            params: {
              start: filter.start,
              end: filter.end
            }
          };
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(state.endPoint + '/employees/publish/' + filter.agencyCode, param).then(function (result) {
            if (result.data) {
              var employees = result.data.data;
              if (employees && employees.length > 0) {
                for (var key in employees) {
                  employees[key].imgSrc = '';
                  employees[key].score = 0;
                  employees[key].totalVoting = 0;
                }
              }
              var dataOutput = [result.data.total, employees];
              resolve(dataOutput);
            } else {
              resolve([]);
            }
          }).catch(function (xhr) {
            reject(xhr);
          });
        });
      });
    },
    loadEmployeesMotcua: function loadEmployeesMotcua(_ref20, filter) {
      var commit = _ref20.commit,
          state = _ref20.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function () {
          var param = {
            headers: {
              groupId: state.initData.groupId
            },
            params: {
              start: filter.start,
              end: filter.end
            }
          };
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(state.endPoint + '/employees', param).then(function (result) {
            if (result.data) {
              var employees = result.data.data;
              if (employees && employees.length > 0) {
                for (var key in employees) {
                  employees[key].imgSrc = '';
                  employees[key].score = 0;
                  employees[key].totalVoting = 0;
                }
              }
              var dataOutput = [result.data.total, employees];
              resolve(dataOutput);
            } else {
              resolve([]);
            }
          }).catch(function (xhr) {
            reject(xhr);
          });
        });
      });
    },
    loadImageEmployee: function loadImageEmployee(_ref21, filter) {
      var commit = _ref21.commit,
          state = _ref21.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result1) {
          var param = {
            headers: {
              groupId: state.initData.groupId
            }
          };
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('/o/v1/opencps/users/avatar/org.opencps.usermgt.model.Employee/' + filter['employeeId'], param).then(function (response) {
            var seriable = response.data;
            resolve(seriable);
          }).catch(function (xhr) {
            reject(xhr);
          });
        });
      });
    },
    loadVoting: function loadVoting(_ref22, data) {
      var commit = _ref22.commit,
          state = _ref22.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result1) {
          var param = {
            headers: {
              groupId: state.initData.groupId
            }
          };
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(state.endPoint + '/postal/votings/' + data.className + '/' + data.classPk, param).then(function (result) {
            if (result.data) {
              resolve(result.data.data);
            } else {
              resolve([]);
            }
          }).catch(function (xhr) {
            reject(xhr);
          });
        });
      });
    },
    submitVoting: function submitVoting(_ref23, data) {
      var commit = _ref23.commit,
          state = _ref23.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result1) {
          var params = new URLSearchParams();
          var config = {
            headers: {
              'groupId': state.initData.groupId
            }
          };
          params.append('className', data.className);
          params.append('classPk', data.classPk);
          params.append('selected', data.selected);
          if (data.className === 'dossier') {
            params.append('votingCode', data.votingCode ? data.votingCode : '');
          }

          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(state.endPoint + '/postal/votings/' + data.votingId + '/results', params, config).then(function (result) {
            resolve(result.data);
          }).catch(function (xhr) {
            __WEBPACK_IMPORTED_MODULE_3_toastr___default.a.clear();
            __WEBPACK_IMPORTED_MODULE_3_toastr___default.a.error('Gửi đánh giá thất bại');
            reject(xhr);
          });
        });
      });
    },
    checkPermisionVoting: function checkPermisionVoting(_ref24, filter) {
      var commit = _ref24.commit,
          state = _ref24.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function () {
          var config = {
            headers: {
              'groupId': state.initData.groupId
            },
            params: {
              applicantIdNo: filter.applicantIdNo,
              dossierNo: filter.dossierNo
            }
          };
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(state.endPoint + '/votings/checkpermission', config).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    getWorkingUnit: function getWorkingUnit(_ref25, filter) {
      var commit = _ref25.commit,
          state = _ref25.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            headers: {
              groupId: state.initData.groupId
            }
          };

          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(state.endPoint + '/dictcollections/GOVERNMENT_AGENCY/dictitems', param).then(function (response) {
            var serializable = response.data;
            if (serializable.data) {
              var dataReturn = serializable.data;
              resolve(dataReturn);
            } else {
              resolve([]);
            }
          }).catch(function (error) {
            reject(error);
          });
        });
      });
    },
    getEmployee: function getEmployee(_ref26, filter) {
      var commit = _ref26.commit,
          state = _ref26.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = void 0;
          param = {
            employeeName: filter.employeeName,
            start: filter.start,
            end: filter.end
          };
          var configs = {
            headers: {
              groupId: state.initData.groupId
            },
            params: param
          };

          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(state.endPoint + '/employees/publish/' + filter.workingunit, configs).then(function (response) {
            var serializable = response.data;
            commit('setTotalEmployee', serializable.total);
            if (serializable.data) {
              var dataReturn = serializable.data;
              for (var key in dataReturn) {
                dataReturn[key]['totalEvaluation'] = 0;
                dataReturn[key]['veryGoodCount'] = 0;
                dataReturn[key]['perVeryGood'] = 0;
                dataReturn[key]['goodCount'] = 0;
                dataReturn[key]['perGood'] = 0;
                dataReturn[key]['badCount'] = 0;
                dataReturn[key]['perBad'] = 0;
              }
              resolve(dataReturn);
            } else {
              commit('setTotalEmployee', 0);
              resolve([]);
            }
          }).catch(function (error) {
            commit('setTotalEmployee', 0);
            reject(error);
          });
        });
      });
    }
  },
  mutations: {
    setIndex: function setIndex(state, payload) {
      state.index = payload;
    },
    setInitData: function setInitData(state, payload) {
      state.initData = payload;
    },
    setDossierDetail: function setDossierDetail(state, payload) {
      state.dossierDetail = payload;
    },
    setFilterDossierKey: function setFilterDossierKey(state, payload) {
      state.filterDossierKey = {
        dossierNo: payload.dossierNo ? payload.dossierNo : '',
        applicantIdNo: payload.applicantIdNo ? payload.applicantIdNo : '',
        secretCode: payload.secretCode ? payload.secretCode : ''
      };
    },
    setEmployeeSelected: function setEmployeeSelected(state, payload) {
      state.employeeSelected = payload;
    },
    setTotalEmployee: function setTotalEmployee(state, payload) {
      state.totalEmployee = payload;
    },
    setWorkingUnitSelect: function setWorkingUnitSelect(state, payload) {
      state.workingUnitSelect = payload;
    },
    setActiveDetailService: function setActiveDetailService(state, payload) {
      state.activeDetailService = payload;
    },
    setActiveDetailDossier: function setActiveDetailDossier(state, payload) {
      state.activeDetailDossier = payload;
    },
    setApplicantIdNoSearch: function setApplicantIdNoSearch(state, payload) {
      state.applicantIdNoSearch = payload;
    },
    setDossierNoSearch: function setDossierNoSearch(state, payload) {
      state.dossierNoSearch = payload;
    },
    setFullScreen: function setFullScreen(state, payload) {
      state.fullScreen = payload;
    },
    setOriginality: function setOriginality(state, payload) {
      state.originality = payload;
    },
    setGroupid: function setGroupid(state, payload) {
      state.groupIdSite = payload;
    },
    setIsMobile: function setIsMobile(state, payload) {
      state.isMobile = payload;
    }
  },
  getters: {
    index: function index(state) {
      return state.index;
    },
    getTotalEmployee: function getTotalEmployee(state) {
      return state.totalEmployee;
    },
    getDetailDossier: function getDetailDossier(state) {
      return state.dossierDetail;
    },
    getFilterDossierKey: function getFilterDossierKey(state) {
      return state.filterDossierKey;
    },
    getActiveDetailService: function getActiveDetailService(state) {
      return state.activeDetailService;
    },
    getApplicantIdNoSearch: function getApplicantIdNoSearch(state) {
      return state.applicantIdNoSearch;
    },
    getDossierNoSearch: function getDossierNoSearch(state) {
      return state.dossierNoSearch;
    },
    getFullScreen: function getFullScreen(state) {
      return state.fullScreen;
    },
    getIsMobile: function getIsMobile(state) {
      return state.isMobile;
    },
    getOriginality: function getOriginality(state) {
      return state.originality;
    },
    employeeSelected: function employeeSelected(state) {
      return state.employeeSelected;
    },
    getGroupid: function getGroupid(state, payload) {
      return state.groupIdSite;
    }
  }
});

/***/ }),

/***/ 205:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 206:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 207:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(542),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "D:\\FDS\\frontend-opencps-v2.1\\onegate_21_kios_bng\\src\\App.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] App.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f79fe98e", Component.options)
  } else {
    hotAPI.reload("data-v-f79fe98e", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_dist_vuetify_min_css__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr_build_toastr_min_css__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr_build_toastr_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_toastr_build_toastr_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stylus_main_css__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stylus_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__stylus_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_dist_vue_min_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_dist_vue_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_dist_vue_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_content_placeholders__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_polyfill__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_axios__);













__WEBPACK_IMPORTED_MODULE_11_axios___default.a.defaults.headers.common['Token'] = window.Liferay ? window.Liferay.authToken : '';
__WEBPACK_IMPORTED_MODULE_3_vue_dist_vue_min_js___default.a.mixin({
  methods: {
    accept: function accept(text) {
      this.hide();
    },
    hide: function hide() {
      this.visible = false;
    },
    next: function next() {
      var _this = this;

      var inputs = document.querySelectorAll('input');
      var found = false;
      var arr1 = [];
      arr1.forEach.call(inputs, function (item, i) {
        if (!found && item === _this.input && i < inputs.length - 1) {
          found = true;
          _this.$nextTick(function () {
            inputs[i + 1].focus();
          });
        }
      });
      if (!found) {
        this.input.blur();
        this.hide();
      }
    }
  }
});
__WEBPACK_IMPORTED_MODULE_3_vue_dist_vue_min_js___default.a.use(__WEBPACK_IMPORTED_MODULE_8_vue_content_placeholders__["default"]);
__WEBPACK_IMPORTED_MODULE_3_vue_dist_vue_min_js___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue_dist_vue_min_js___default.a.config.productionTip = true;

new __WEBPACK_IMPORTED_MODULE_3_vue_dist_vue_min_js___default.a({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* store */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_4__App___default.a);
  }
});

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inotom_vue_go_top__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inotom_vue_go_top___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__inotom_vue_go_top__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      enableToTop: false,
      workingUnitList: [],
      govAgencyList: [],
      isDvc: true,
      currentIndex: 0,
      interVal: '',
      loading: true,
      isKios: true,
      wrapStyle: true,
      isMobile: false,
      drawer: null,
      active: 0,
      groupId: window.themeDisplay ? window.themeDisplay.getScopeGroupId() : '',
      kiosItems: [{
        route: 'ketquahoso',
        icon: 'library_books',
        text: 'Hồ sơ đã có kết quả'
      }, {
        route: 'tiepnhanhoso',
        icon: 'move_to_inbox',
        text: 'Hồ sơ đã tiếp nhận'
      }, {
        route: 'tracuuhoso',
        icon: 'search',
        text: 'Tra cứu hồ sơ'
      }, {
        route: 'tracuuthutuc',
        icon: 'pageview',
        text: 'Tra cứu thủ tục'
      }, {
        route: 'danhgia',
        icon: 'stars',
        text: 'Đánh giá cán bộ'
      }]
    };
  },
  components: {
    GoTop: __WEBPACK_IMPORTED_MODULE_2__inotom_vue_go_top___default.a
  },
  created: function created() {
    var vm = this;
    vm.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('header').css('display', 'none');
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-container').css('display', 'none');
      vm.setInterval();
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).scroll(function () {
        vm.enableToTop = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).scrollTop() > 200;
      });
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#navigation').css('display', 'none');
      var current = vm.$router.history.current;
      var newQuery = current.query;
      vm.$store.commit('setGroupid', newQuery.hasOwnProperty('groupIds') ? newQuery['groupIds'] : '');
      if (!newQuery.hasOwnProperty('secretKey')) {
        vm.isKios = true;
      } else {
        vm.isKios = false;
      }
      if (current['path'] && current['path'] === '/tra-cuu-ho-so-homepage') {
        vm.wrapStyle = false;
      } else {
        vm.wrapStyle = true;
      }
      vm.$store.dispatch('getGovAgency').then(function (result) {
        vm.govAgencyList = result;
        vm.isDvc = vm.govAgencyList.length > 1;
      }).catch(function (reject) {});
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true });
    }
  },
  mounted: function mounted() {
    var vm = this;
    vm.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#navigation').css('display', 'none');
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('header').css('display', 'none');
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-container').css('display', 'none');
    });
    this.onResize();
    window.addEventListener('resize', this.onResize, { passive: true });
  },

  computed: {
    fullScreen: function fullScreen() {
      return this.$store.getters.getFullScreen;
    },
    groupIds: function groupIds() {
      return this.$store.getters.getGroupid;
    }
  },
  watch: {
    '$route': function $route(newRoute, oldRoute) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('header').css('display', 'none');
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-container').css('display', 'none');
      var vm = this;
      var currentParams = newRoute.params;
      var currentQuery = newRoute.query;
      vm.$store.commit('setGroupid', currentQuery.hasOwnProperty('groupIds') ? currentQuery['groupIds'] : '');
      if (!currentQuery.hasOwnProperty('secretKey')) {
        vm.isKios = true;
      } else {
        vm.isKios = false;
      }
      if (newRoute['path'] && newRoute['path'] === '/tra-cuu-ho-so-homepage') {
        vm.wrapStyle = false;
      } else {
        vm.wrapStyle = true;
      }
    }
  },
  methods: {
    onResize: function onResize() {
      var vm = this;
      vm.isMobile = window.innerWidth < 1024;
      vm.$store.commit('setIsMobile', vm.isMobile);
    },
    backKiosHome: function backKiosHome() {
      var vm = this;
      this.interVal = setInterval(function () {
        vm.$router.push({
          path: '/'
        });
      }, 3 * 60 * 1000);
    },
    setInterval: function setInterval() {
      this.backKiosHome();
    },
    stopInterval: function stopInterval() {
      var vm = this;
      if (vm.interVal) {
        clearInterval(vm.interVal);
        vm.setInterval();
      }
    },
    goPage: function goPage(page, index) {
      var vm = this;
      vm.active = index;
      vm.$store.commit('setActiveDetailService', false);
      var queryString = void 0;
      if (page === 'ketquahoso') {
        queryString = '/ho-so-co-ket-qua';
      } else if (page === 'tiepnhanhoso') {
        queryString = '/tiep-nhan-ho-so';
      } else if (page === 'tracuuhoso') {
        queryString = '/tra-cuu-ho-so';
      } else if (page === 'tracuuthutuc') {
        queryString = '/tra-cuu-thu-tuc';
      } else if (page === 'danhgia') {
        if (vm.isDvc) {
          queryString = '/danh-gia-can-bo';
        } else {
          queryString = '/danh-sach-can-bo?agencyCode=' + vm.govAgencyList[0].administrationCode + '&agencyName=' + vm.govAgencyList[0].administrationName;
        }
      }
      vm.$router.push({
        path: queryString,
        query: {
          renew: Math.floor(Math.random() * (100 - 1 + 1)) + 1
        }
      });
    }
  }
});

/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['index'],
  components: {},
  data: function data() {
    return {
      options: {},
      arrCaptcha: [],
      captcha: '',
      currentlyDragging: null,
      loggedEvent: '',
      images: [{ name: 'Image 1', src: 'http://placehold.it/100/000000/ffffff' }, { name: 'Image 2', src: 'http://placehold.it/100/C93742/ffffff' }, { name: 'Image 3', src: 'http://placehold.it/100/6894D1/ffffff' }]
    };
  },
  computed: {
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  created: function created() {
    var vm = this;
    vm.makeRandomString();
    vm.shuffleArrCaptcha(vm.arrCaptcha);
  },

  watch: {},
  methods: {
    makeRandomString: function makeRandomString() {
      var vm = this;
      var text = '';
      var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      for (var i = 0; i < 4; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      if (text) {
        vm.arrCaptcha = vm.shuffleArrCaptcha(text.split(''));
      }
      vm.captcha = text;
    },
    shuffleArrCaptcha: function shuffleArrCaptcha(arra1) {
      var ctr = arra1.length;
      var temp = null;
      var index = 0;
      while (ctr > 0) {
        index = Math.floor(Math.random() * ctr);
        ctr--;
        temp = arra1[ctr];
        arra1[ctr] = arra1[index];
        arra1[index] = temp;
      }
      return arra1;
    },
    checkValidCaptcha: function checkValidCaptcha() {
      var vm = this;
      var str = '';
      var items = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#captcha').children();
      console.log(items);
      for (var i = 0; i < items.length; i++) {
        str += items[i].innerHTML;
      }
      if (vm.captcha === str) {
        return true;
      } else {
        return false;
      }
    }
  },
  filters: {
    dateTimeView: function dateTimeView(arg) {
      if (arg) {
        var value = new Date(arg);
        return value.getDate().toString().padStart(2, '0') + '/' + (value.getMonth() + 1).toString().padStart(2, '0') + '/' + value.getFullYear();
      } else {
        return '';
      }
    }
  }
});

/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__keyboard_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__keyboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__keyboard_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: [],
  components: {
    'vue-touch-keyboard': __WEBPACK_IMPORTED_MODULE_3__keyboard_vue___default.a
  },
  data: function data() {
    return {
      loading: false,
      loadingAction: false,
      dialogError: false,
      valid: false,
      passCheck: '',
      validPass: true,
      targetCheckPass: '',

      visible: false,
      layout: 'normal',
      input: null,
      options: {
        useKbEvents: true,
        preventClickEvent: false
      }
    };
  },
  computed: {
    filterDossierKey: function filterDossierKey() {
      return this.$store.getters.getFilterDossierKey;
    },
    dossierDetail: function dossierDetail() {
      return this.$store.getters.getDetailDossier;
    },
    applicantIdNoSearch: function applicantIdNoSearch() {
      return this.$store.getters.getApplicantIdNoSearch;
    },
    dossierNoSearch: function dossierNoSearch() {
      return this.$store.getters.getDossierNoSearch;
    },
    isMobile: function isMobile() {
      return this.$store.getters.getIsMobile;
    }
  },
  created: function created() {
    var vm = this;
    vm.$nextTick(function () {
      var inputs = document.querySelectorAll('input');
      inputs[0].focus();
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#passCheck').val('');
      var current = vm.$router.history.current;
      var newQuery = current.query;
      vm.targetCheckPass = newQuery['target'];
    });
  },

  watch: {},
  methods: {
    doLoadingDataHoSo: function doLoadingDataHoSo() {
      var vm = this;
      vm.dossierList = [];
      vm.loadingTable = true;
      vm.$store.dispatch('loadingDataHoSo', vm.filterDossierKey).then(function (result) {
        vm.loadingTable = false;
        vm.dossierList = result.data;
        vm.dossierItemTotal = result.total;
        vm.totalPages = Math.ceil(result.total / 15);
      }).catch(function (reject) {
        vm.loadingTable = false;
        vm.dossierList = [];
        vm.dossierItemTotal = 0;
      });
    },
    submitPass: function submitPass() {
      var vm = this;
      if (__WEBPACK_IMPORTED_MODULE_2_jquery___default()('#passCheck').val() !== '') {
        vm.validPass = true;
        if (vm.targetCheckPass === 'tracuuhoso') {
          var payload = {
            dossierNo: vm.filterDossierKey.dossierNo ? vm.filterDossierKey.dossierNo : '',
            applicantIdNo: vm.filterDossierKey.applicantIdNo ? vm.filterDossierKey.applicantIdNo : '',
            secretCode: __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#passCheck').val()
          };
          vm.$store.commit('setFilterDossierKey', payload);
          var newQuery = {
            dossierNo: vm.filterDossierKey.dossierNo,
            applicantIdNo: vm.filterDossierKey.applicantIdNo
          };
          var queryString = '?';
          for (var key in newQuery) {
            if (newQuery[key] !== '' && newQuery[key] !== 'undefined' && newQuery[key] !== undefined && newQuery[key] !== null) {
              queryString += key + '=' + newQuery[key] + '&';
            }
          }
          vm.$router.push({
            path: '/tra-cuu-ho-so' + queryString,
            query: {
              renew: Math.floor(Math.random() * (100 - 1 + 1)) + 1
            }
          });
        } else {
          console.log('vm.dossierDetail', vm.dossierDetail);
          var filter = {
            password: __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#passCheck').val(),
            dossierId: vm.dossierDetail.dossierId
          };
          vm.$store.dispatch('getDossierDetailPass', filter).then(function (result) {
            vm.loading = false;
            vm.dialogCheckPass = false;
            vm.clearDialog();
            if (result.status && result.status.toString() === '203') {
              vm.dialogError = true;
            } else if (result.status && result.status.toString() === '200') {
              vm.$store.commit('setDossierDetail', result.data);
              var _queryString = '?dossierNo=' + vm.dossierNoSearch + '&applicantIdNo=' + vm.applicantIdNoSearch + '&detail=true';
              vm.$router.push({
                path: '/tra-cuu-ho-so' + _queryString
              });
            }
          }).catch(function (reject) {
            vm.dialogCheckPass = false;
            vm.visible = false;
            vm.loading = false;
            console.log('reject', reject);
          });
        }
      } else {
        vm.validPass = false;
      }
    },
    viewDetail: function viewDetail(item) {
      var vm = this;
      vm.dossierDetail = item;
      vm.dialogCheckPass = true;
    },
    submitViewDetail: function submitViewDetail() {
      var vm = this;
      if (__WEBPACK_IMPORTED_MODULE_2_jquery___default()('#passCheck').val() !== '') {
        vm.validPass = true;
        vm.loading = true;
        var filter = {
          password: __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#passCheck').val(),
          dossierId: vm.dossierDetail.dossierId
        };
        vm.$store.dispatch('getDossierDetailPass', filter).then(function (result) {
          vm.loading = false;
          vm.dialogCheckPass = false;
          vm.clearDialog();
          if (result.status && result.status.toString() === '203') {
            vm.dialogError = true;
          } else if (result.status && result.status.toString() === '200') {
            __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/ho-so/' + vm.dossierDetail.dossierId);
          }
        }).catch(function (reject) {
          vm.dialogCheckPass = false;
          vm.visible = false;
          vm.loading = false;
          console.log('reject', reject);
        });
      } else {
        vm.validPass = false;
      }
    },
    clearDialog: function clearDialog() {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#passCheck').val('');
      this.validPass = true;
      this.visible = false;
    },
    goBack: function goBack() {
      window.history.back();
    },
    show: function show(e) {
      this.validPass = true;
      this.input = e.target;
      if (!this.visible) {
        this.visible = true;
      }
      this.bindClick('view');
    },
    bindClick: function bindClick(type) {
      var vm = this;
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.keyboard .enter').unbind('click');
        if (type === 'search') {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.keyboard .enter').bind('click', function () {
            vm.filterDossier();
          });
        } else if (type === 'view') {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.keyboard .enter').bind('click', function () {
            vm.submitViewDetail();
          });
        }
      }, 300);
    }
  }
});

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);






__WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js___default.a.use(__WEBPACK_IMPORTED_MODULE_2_toastr___default.a);
/* harmony default export */ __webpack_exports__["default"] = ({
  props: [],
  components: {},
  data: function data() {
    return {
      loading: false,
      loadingAction: false,
      dialogError: false,
      valid: false,
      secretKey: '',
      validPass: true,
      targetCheckPass: ''
    };
  },
  computed: {
    filterDossierKey: function filterDossierKey() {
      return this.$store.getters.getFilterDossierKey;
    },
    dossierDetail: function dossierDetail() {
      return this.$store.getters.getDetailDossier;
    },
    applicantIdNoSearch: function applicantIdNoSearch() {
      return this.$store.getters.getApplicantIdNoSearch;
    },
    dossierNoSearch: function dossierNoSearch() {
      return this.$store.getters.getDossierNoSearch;
    },
    fullScreen: function fullScreen() {
      return this.$store.getters.getFullScreen;
    }
  },
  created: function created() {
    var vm = this;
    vm.$nextTick(function () {
      vm.$store.commit('setFullScreen', true);
      var current = vm.$router.history.current;
      var newQuery = current.query;
      vm.targetCheckPass = newQuery['target'];
    });
  },

  watch: {},
  methods: {
    doLoadingDataHoSo: function doLoadingDataHoSo() {
      var vm = this;
      vm.dossierList = [];
      vm.loadingTable = true;
      vm.$store.dispatch('loadingDataHoSo', vm.filterDossierKey).then(function (result) {
        vm.loadingTable = false;
        vm.dossierList = result.data;
        vm.dossierItemTotal = result.total;
        vm.totalPages = Math.ceil(result.total / 15);
      }).catch(function (reject) {
        vm.loadingTable = false;
        vm.dossierList = [];
        vm.dossierItemTotal = 0;
      });
    },
    submitPass: function submitPass() {
      var vm = this;
      if (vm.$refs.form.validate()) {
        vm.validPass = true;
        if (vm.targetCheckPass === 'tracuuhoso') {
          var payload = {
            dossierNo: vm.filterDossierKey.dossierNo ? vm.filterDossierKey.dossierNo : '',
            applicantIdNo: vm.filterDossierKey.applicantIdNo ? vm.filterDossierKey.applicantIdNo : '',
            secretCode: __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#passCheck').val()
          };
          vm.$store.commit('setFilterDossierKey', payload);
          var newQuery = {
            keyword: vm.filterDossierKey.dossierNo,
            applicantIdNo: vm.filterDossierKey.applicantIdNo
          };
          var queryString = '?';
          for (var key in newQuery) {
            if (newQuery[key] !== '' && newQuery[key] !== 'undefined' && newQuery[key] !== undefined && newQuery[key] !== null) {
              queryString += key + '=' + newQuery[key] + '&';
            }
          }
          vm.$router.push({
            path: '/tra-cuu-ho-so' + queryString,
            query: {
              renew: Math.floor(Math.random() * (100 - 1 + 1)) + 1
            }
          });
        } else {
          var filter = {
            password: vm.secretKey,
            dossierId: vm.dossierDetail.dossierId
          };
          vm.$store.dispatch('getDossierDetailPass', filter).then(function (result) {
            vm.loading = false;
            if (result.status && result.status.toString() === '203') {
              __WEBPACK_IMPORTED_MODULE_2_toastr___default.a.error('Mã tra cứu không chính xác. Vui lòng thử lại.');
            } else if (result.status && result.status.toString() === '200') {
              vm.clearDialog();
              vm.$store.commit('setDossierDetail', result.data);
              var _queryString = '?keyword=' + vm.dossierNoSearch + '&applicantIdNo=' + vm.applicantIdNoSearch + '&detail=true';
              vm.$router.push({
                path: '/tra-cuu-ho-so-homepage' + _queryString
              });
            }
          }).catch(function (reject) {
            vm.loading = false;
            __WEBPACK_IMPORTED_MODULE_2_toastr___default.a.error('Lỗi hệ thống');
            console.log('reject', reject);
          });
        }
      } else {
        console.log('run validPass false');
      }
    },
    viewDetail: function viewDetail(item) {
      var vm = this;
      vm.dossierDetail = item;
    },
    clearDialog: function clearDialog() {
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#passCheck').val('');
      this.validPass = true;
    },
    clear: function clear(id) {
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#' + id).val('');
    },
    goBack: function goBack() {
      window.history.back();
    }
  }
});

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_dist_vue_min_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_dist_vue_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_dist_vue_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_toastr__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keyboard_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keyboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__keyboard_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['administration'],
  components: {
    'vue-touch-keyboard': __WEBPACK_IMPORTED_MODULE_5__keyboard_vue___default.a
  },
  data: function data() {
    return {
      loading: false,
      loadingAction: false,
      votingItems: [],
      isSigned: false,
      validPass1: true,
      validPass2: true,

      visible: false,
      layout: 'normal',
      input: null,
      options: {
        useKbEvents: true,
        preventClickEvent: false
      }
    };
  },
  computed: {},
  created: function created() {
    var vm = this;
    vm.$nextTick(function () {
      var vm = this;
      vm.isSigned = window.themeDisplay.isSignedIn();

      vm.validPass2 = true;
      var filter = {
        className: 'govagency',
        classPK: vm.administration
      };
      vm.$store.dispatch('loadVoting', filter).then(function (result) {
        vm.votingItems = result;
        console.log('votingItems', vm.votingItems);
        vm.loading = false;
      }).catch(function (reject) {
        vm.loading = false;
      });
    });
  },

  watch: {},
  methods: {
    submitVoting: function submitVoting() {
      var vm = this;
      if (!vm.isSigned) {
        if (__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#applicantIdNo').val() === '') {
          vm.validPass2 = false;
        } else {
          vm.validPass2 = true;
        }
        if (__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#dossierIdNoKey').val() === '') {
          vm.validPass1 = false;
        } else {
          vm.validPass1 = true;
        }
        if (vm.validPass1 && vm.validPass2) {
          var filter = {
            applicantIdNo: __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#applicantIdNo').val(),
            dossierNo: __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#dossierIdNoKey').val()
          };
          vm.$store.dispatch('checkPermisionVoting', filter).then(function (result) {
            console.log('result', result);
            if (result.hasPermission === true || result.hasPermission === 'true') {
              vm.doResultVoting();
            } else {
              __WEBPACK_IMPORTED_MODULE_4_toastr___default.a.error('Số CMTND hoặc Số hồ sơ không chính xác');
            }
          }).catch(function (xhr) {
            __WEBPACK_IMPORTED_MODULE_4_toastr___default.a.error('Lỗi hệ thống');
          });
        }
      } else {
        vm.doResultVoting();
      }
    },
    doResultVoting: function doResultVoting() {
      var vm = this;
      var arrAction = [];
      if (vm.votingItems.length > 0) {
        vm.loadingAction = true;
        for (var index in vm.votingItems) {
          vm.votingItems[index]['className'] = 'govagency';
          vm.votingItems[index]['classPk'] = vm.administration;
          arrAction.push(vm.$store.dispatch('submitVoting', vm.votingItems[index]));
        }
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(arrAction).then(function (results) {
          vm.loadingAction = false;
          __WEBPACK_IMPORTED_MODULE_4_toastr___default.a.success('Đánh giá của bạn được gửi thành công');
          vm.$router.push({
            path: '/danh-gia-cldv'
          });
        }).catch(function (xhr) {
          vm.loadingAction = false;
        });
      }
    },
    goBack: function goBack() {
      window.history.back();
    },
    clear: function clear(id) {
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#' + id).val('');
    },
    accept: function accept(text) {
      this.hide();
    },
    show: function show(e) {
      this.validPass = true;
      this.input = e.target;
      if (!this.visible) {
        this.visible = true;
      }
    },
    showKeyboard: function showKeyboard(e) {
      this.validPass = true;
      this.input = e.target;
      if (!this.visible) {
        this.visible = true;
      }
    },
    hide: function hide() {
      this.visible = false;
    },
    next: function next() {
      var _this = this;

      var inputs = document.querySelectorAll('input');
      var found = false;
      var arr1 = [];
      arr1.forEach.call(inputs, function (item, i) {
        if (!found && item === _this.input && i < inputs.length - 1) {
          found = true;
          _this.$nextTick(function () {
            inputs[i + 1].focus();
          });
        }
      });
      if (!found) {
        this.input.blur();
        this.hide();
      }
    }
  }
});

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Captcha_vue__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Captcha_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Captcha_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_star_rating__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__keyboard_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__keyboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__keyboard_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id'],
  components: {
    'vue-touch-keyboard': __WEBPACK_IMPORTED_MODULE_6__keyboard_vue___default.a,
    'captcha': __WEBPACK_IMPORTED_MODULE_4__Captcha_vue___default.a,
    StarRating: __WEBPACK_IMPORTED_MODULE_5_vue_star_rating___default.a
  },
  data: function data() {
    return {
      applicantIdNo: '',
      dossierNo: '',
      workingUnit: {},
      employee: {},
      votingItems: [],
      itemName: '',
      btnLoading: false,
      votingDialog_hidden_loading: false,
      validFormVoting: false,
      showCaptcha: false,
      dialogShowApplicantIdNo: false,
      visible: false,
      layout: 'normal',
      input: null,
      options: {
        useKbEvents: true,
        preventClickEvent: false
      }
    };
  },
  computed: {
    loading: function loading() {
      return this.$store.getters.loading;
    },
    employeeSelected: function employeeSelected() {
      return this.$store.getters.employeeSelected;
    },
    fullScreen: function fullScreen() {
      return this.$store.getters.getFullScreen;
    },
    isMobile: function isMobile() {
      return this.$store.getters.getIsMobile;
    }
  },
  created: function created() {
    var vm = this;
    var currentQuery = vm.$router.history.current.query;
    vm.$nextTick(function () {
      vm.getVotingEmployee();
    });
  },

  watch: {},
  methods: {
    getVotingEmployee: function getVotingEmployee() {
      var vm = this;
      vm.$store.dispatch('loadVoting', {
        className: 'employee',
        classPk: vm.id
      }).then(function (result) {
        vm.votingItems = result;
        vm.getScoreVoting(vm.votingItems);
      }).catch(function (xhr) {});
    },
    getScoreVoting: function getScoreVoting(votingItems) {
      var vm = this;
      if (votingItems && votingItems.length > 0) {
        var totalVoting = 0;
        var totalScore = 0;
        var lengthQuestion = votingItems.length;
        var lengthAnswer = votingItems[0]['answers'].length;
        for (var i = 0; i < lengthQuestion; i++) {
          totalVoting += votingItems[i]['answersCount'];
          for (var j = 0; j < lengthAnswer; j++) {
            totalScore += votingItems[i]['answers'][j] * (lengthAnswer - j);
          }
        }
        if (totalVoting > 0) {
          vm.employeeSelected['score'] = Number((totalScore * 5 / (totalVoting * lengthAnswer)).toFixed(1));
          vm.employeeSelected['totalVoting'] = Number(totalVoting);
        }
      }
    },

    submitResultVoting: function submitResultVoting() {
      var vm = this;
      var isSigned = window.themeDisplay ? window.themeDisplay.isSignedIn() : '';
      if (isSigned) {
        vm.doVottingResultSubmit();
      } else {
        vm.dialogShowApplicantIdNo = true;
      }
    },
    doVottingSubmit: function doVottingSubmit() {
      var vm = this;
      vm.applicantIdNo = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#applicantIdNo').val();
      vm.dossierNo = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#dossierNo').val();
      if (!vm.dossierNo || !vm.dossierNo) {
        __WEBPACK_IMPORTED_MODULE_2_toastr___default.a.error('Vui lòng điền đầy đủ thông tin xác thực');
      } else {
        var filter = {
          applicantIdNo: vm.applicantIdNo,
          dossierNo: vm.dossierNo
        };
        vm.$store.dispatch('checkPermisionVoting', filter).then(function (result) {
          console.log('result', result);
          if (result.hasPermission === true || result.hasPermission === 'true') {
            vm.doVottingResultSubmit();
          } else {
            __WEBPACK_IMPORTED_MODULE_2_toastr___default.a.error('Số CMTND hoặc Số hồ sơ không chính xác');
          }
        }).catch(function (xhr) {
          __WEBPACK_IMPORTED_MODULE_2_toastr___default.a.error('Lỗi hệ thống');
        });
      }
    },

    doVottingResultSubmit: function doVottingResultSubmit() {
      var vm = this;
      var arrAction = [];
      for (var key in vm.votingItems) {
        vm.votingItems[key]['className'] = 'employee';
        vm.votingItems[key]['classPk'] = vm.employeeSelected['employeeId'];
        arrAction.push(vm.$store.dispatch('submitVoting', vm.votingItems[key]));
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(arrAction).then(function (results) {
        __WEBPACK_IMPORTED_MODULE_2_toastr___default.a.success('Gửi đánh giá thành công');
        vm.dialogShowApplicantIdNo = false;
        vm.getVotingEmployee();
      }).catch(function (xhr) {
        __WEBPACK_IMPORTED_MODULE_2_toastr___default.a.error('Gửi đánh giá thất bại');
      });
    },
    changeScreen: function changeScreen() {
      var vm = this;
      vm.$store.commit('setFullScreen', !vm.fullScreen);
    },
    goBack: function goBack() {
      window.history.back();
    },
    show: function show(e) {
      this.validPass = true;
      this.input = e.target;
      if (!this.visible) {
        this.visible = true;
      }
      this.bindClick('search');
    },
    bindClick: function bindClick(type) {
      var vm = this;
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.keyboard .enter').unbind('click');
        if (type === 'search') {
          __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.keyboard .enter').bind('click', function () {
            vm.doVottingSubmit();
          });
        } else if (type === 'view') {
          __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.keyboard .enter').bind('click', function () {
            vm.submitViewDetail();
          });
        }
      }, 300);
    }
  },
  filters: {}
});

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_dist_vue_min_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_dist_vue_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_dist_vue_min_js__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['index'],
  components: {},
  data: function data() {
    return {
      loading: false,
      loadingAction: false,
      dossierDetail: {},
      listHistoryProcessing: [],
      dossierActions: [],
      tailieuNop: [],
      tailieuKeyQua: [],
      votingItems: [],
      loadingVoting: false,
      headers: [{
        text: '#',
        align: 'center',
        sortable: false
      }, {
        text: 'Vai trò',
        align: 'center',
        sortable: false,
        class: 'vaitro_column'
      }, {
        text: 'Công việc',
        align: 'center',
        sortable: false,
        class: 'congviec_column'
      }, {
        text: 'Thời hạn quy định',
        align: 'center',
        sortable: false,
        class: 'thoihanquydinh_column'
      }, {
        text: 'Ngày bắt đầu',
        align: 'center',
        sortable: false,
        class: 'ngaybatdau_column'
      }, {
        text: 'Người thực hiện',
        align: 'center',
        sortable: false,
        class: 'nguoithuchien_column'
      }, {
        text: 'Kết quả',
        align: 'center',
        sortable: false,
        class: 'ketqua_column'
      }]
    };
  },
  computed: {},
  created: function created() {
    var vm = this;
    vm.$nextTick(function () {
      var vm = this;
      vm.dossierDetail = this.$store.getters.getDetailDossier;
      if (vm.dossierDetail.submissionNote) {
        var submissionNote = vm.dossierDetail.submissionNote ? JSON.parse(vm.dossierDetail.submissionNote) : '';
        var resultTemp = submissionNote ? submissionNote.data : '';
        if (resultTemp) {
          for (var i = 0; i < resultTemp.length; i++) {
            if (resultTemp[i].hasOwnProperty('actions') && resultTemp[i]['actions'] !== null && resultTemp[i]['actions'] !== undefined) {
              if (!Array.isArray(resultTemp[i]['actions'])) {
                var arrActionsTemp = [];
                arrActionsTemp.push(resultTemp[i]['actions']);
                resultTemp[i]['actions'] = arrActionsTemp;
              }
            }
          }
          vm.dossierActions = resultTemp;
        }
      }
    });
  },

  watch: {},
  methods: {
    loadDossierActions: function loadDossierActions() {
      var vm = this;
      var dataParams = {
        dossierId: vm.dossierDetail.dossierId
      };
      if (vm.dossierDetail.originality === 0 || vm.dossierDetail.originality === '0') {} else {
        vm.$store.dispatch('loadDossierActions', dataParams).then(function (resultActions) {
          if (resultActions.data) {
            var resultTemp = resultActions.data;
            for (var i = 0; i < resultTemp.length; i++) {
              if (resultTemp[i].hasOwnProperty('actions') && resultTemp[i]['actions'] !== null && resultTemp[i]['actions'] !== undefined) {
                if (!Array.isArray(resultTemp[i]['actions'])) {
                  var arrActionsTemp = [];
                  arrActionsTemp.push(resultTemp[i]['actions']);
                  resultTemp[i]['actions'] = arrActionsTemp;
                }
              }
            }
            vm.dossierActions = resultTemp;
          }
        });
      }
    },
    loadLogs: function loadLogs() {
      var vm = this;
      var filter = {
        dossierId: vm.dossierDetail.dossierId
      };
      vm.$store.dispatch('getListHistoryProcessingItems', filter).then(function (result) {
        vm.listHistoryProcessing = [];
        vm.listHistoryProcessing = result;
      });
    },
    loadDossiertemplate: function loadDossiertemplate() {
      var vm = this;
      var filter = {
        dossierTemplateNo: vm.dossierDetail.dossierTemplateNo
      };
      if (vm.dossierDetail.dossierTemplateNo) {
        vm.$store.dispatch('loadDossierTemplates', filter).then(function (result) {
          console.log(result);
          vm.tailieuNop = result.filter(function (item) {
            return item.partType === 1;
          });
          vm.tailieuKeyQua = result.filter(function (item) {
            return item.partType === 2;
          });
        });
      }
    },
    loadVoting: function loadVoting() {
      var vm = this;
      var filter = {
        className: 'dossier',
        classPK: vm.dossierDetail.dossierId
      };
      vm.$store.dispatch('loadVoting', filter).then(function (result) {
        vm.votingItems = result;
        console.log('votingItems', vm.votingItems);
      }).catch(function (reject) {});
    },
    submitVoting: function submitVoting() {
      var vm = this;
      var arrAction = [];
      if (vm.votingItems.length > 0) {
        vm.loadingVoting = true;
        for (var index in vm.votingItems) {
          vm.votingItems[index]['className'] = 'dossier';
          vm.votingItems[index]['classPk'] = vm.dossierDetail.dossierId;
          arrAction.push(vm.$store.dispatch('submitVoting', vm.votingItems[index]));
        }
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(arrAction).then(function (results) {
          vm.loadingVoting = false;
          vm.loadVoting();
        }).catch(function (xhr) {
          vm.loadingVoting = false;
        });
      }
    },
    goBack: function goBack() {
      window.history.back();
    },
    getColor: function getColor(level) {
      if (level === 2) {
        return 'green';
      } else if (level === 3) {
        return 'orange';
      } else if (level === 4) {
        return 'red';
      }
    }
  },
  filters: {
    dateTimeView: function dateTimeView(arg) {
      if (arg) {
        var value = new Date(Number(arg));
        return value.getDate().toString().padStart(2, '0') + '/' + (value.getMonth() + 1).toString().padStart(2, '0') + '/' + value.getFullYear() + ' ' + value.getHours().toString().padStart(2, '0') + ':' + value.getMinutes().toString().padStart(2, '0');
      } else {
        return '';
      }
    }
  }
});

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_dist_vue_min_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_dist_vue_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_dist_vue_min_js__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['index'],
  components: {
    fullScreen: function fullScreen() {
      return this.$store.getters.getFullScreen;
    }
  },
  data: function data() {
    return {
      loading: false,
      loadingAction: false,
      dossierDetail: {},
      listHistoryProcessing: [],
      dossierActions: [],
      tailieuNop: [],
      tailieuKeyQua: [],
      votingItems: [],
      loadingVoting: false,
      headers: [{
        text: '#',
        align: 'center',
        sortable: false
      }, {
        text: 'Vai trò',
        align: 'center',
        sortable: false,
        class: 'vaitro_column'
      }, {
        text: 'Công việc',
        align: 'center',
        sortable: false,
        class: 'congviec_column'
      }, {
        text: 'Thời hạn quy định',
        align: 'center',
        sortable: false,
        class: 'thoihanquydinh_column'
      }, {
        text: 'Ngày bắt đầu',
        align: 'center',
        sortable: false,
        class: 'ngaybatdau_column'
      }, {
        text: 'Người thực hiện',
        align: 'center',
        sortable: false,
        class: 'nguoithuchien_column'
      }, {
        text: 'Kết quả',
        align: 'center',
        sortable: false,
        class: 'ketqua_column'
      }]
    };
  },
  computed: {},
  created: function created() {
    var vm = this;
    vm.$nextTick(function () {
      var vm = this;
      vm.$store.commit('setFullScreen', true);
      vm.dossierDetail = this.$store.getters.getDetailDossier;
      if (vm.dossierDetail.submissionNote) {
        var submissionNote = vm.dossierDetail.submissionNote ? JSON.parse(vm.dossierDetail.submissionNote) : '';
        var resultTemp = submissionNote ? submissionNote.data : '';
        if (resultTemp) {
          for (var i = 0; i < resultTemp.length; i++) {
            if (resultTemp[i].hasOwnProperty('actions') && resultTemp[i]['actions'] !== null && resultTemp[i]['actions'] !== undefined) {
              if (!Array.isArray(resultTemp[i]['actions'])) {
                var arrActionsTemp = [];
                arrActionsTemp.push(resultTemp[i]['actions']);
                resultTemp[i]['actions'] = arrActionsTemp;
              }
            }
          }
          vm.dossierActions = resultTemp;
        }
      }
    });
  },

  watch: {},
  methods: {
    loadDossierActions: function loadDossierActions() {
      var vm = this;
      var dataParams = {
        dossierId: vm.dossierDetail.dossierId
      };
      if (vm.dossierDetail.originality === 0 || vm.dossierDetail.originality === '0') {} else {
        vm.$store.dispatch('loadDossierActions', dataParams).then(function (resultActions) {
          if (resultActions.data) {
            var resultTemp = resultActions.data;
            for (var i = 0; i < resultTemp.length; i++) {
              if (resultTemp[i].hasOwnProperty('actions') && resultTemp[i]['actions'] !== null && resultTemp[i]['actions'] !== undefined) {
                if (!Array.isArray(resultTemp[i]['actions'])) {
                  var arrActionsTemp = [];
                  arrActionsTemp.push(resultTemp[i]['actions']);
                  resultTemp[i]['actions'] = arrActionsTemp;
                }
              }
            }
            vm.dossierActions = resultTemp;
          }
        });
      }
    },
    loadLogs: function loadLogs() {
      var vm = this;
      var filter = {
        dossierId: vm.dossierDetail.dossierId
      };
      vm.$store.dispatch('getListHistoryProcessingItems', filter).then(function (result) {
        vm.listHistoryProcessing = [];
        vm.listHistoryProcessing = result;
      });
    },
    loadDossiertemplate: function loadDossiertemplate() {
      var vm = this;
      var filter = {
        dossierTemplateNo: vm.dossierDetail.dossierTemplateNo
      };
      if (vm.dossierDetail.dossierTemplateNo) {
        vm.$store.dispatch('loadDossierTemplates', filter).then(function (result) {
          console.log(result);
          vm.tailieuNop = result.filter(function (item) {
            return item.partType === 1;
          });
          vm.tailieuKeyQua = result.filter(function (item) {
            return item.partType === 2;
          });
        });
      }
    },
    loadVoting: function loadVoting() {
      var vm = this;
      var filter = {
        className: 'dossier',
        classPK: vm.dossierDetail.dossierId
      };
      vm.$store.dispatch('loadVoting', filter).then(function (result) {
        vm.votingItems = result;
        console.log('votingItems', vm.votingItems);
      }).catch(function (reject) {});
    },
    submitVoting: function submitVoting() {
      var vm = this;
      var arrAction = [];
      if (vm.votingItems.length > 0) {
        vm.loadingVoting = true;
        for (var index in vm.votingItems) {
          vm.votingItems[index]['className'] = 'dossier';
          vm.votingItems[index]['classPk'] = vm.dossierDetail.dossierId;
          arrAction.push(vm.$store.dispatch('submitVoting', vm.votingItems[index]));
        }
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(arrAction).then(function (results) {
          vm.loadingVoting = false;
          vm.loadVoting();
        }).catch(function (xhr) {
          vm.loadingVoting = false;
        });
      }
    },
    goBack: function goBack() {
      var vm = this;
      var current = vm.$router.history.current;
      var newQuery = current.query;
      var queryString = '?';
      newQuery['detail'] = '';
      for (var key in newQuery) {
        if (newQuery[key] !== '' && newQuery[key] !== 'undefined' && newQuery[key] !== undefined && newQuery[key] !== null && newQuery[key] !== 'null') {
          queryString += key + '=' + newQuery[key] + '&';
        }
      }
      vm.$router.push({
        path: current.path + queryString
      });
    },
    getColor: function getColor(level) {
      if (level === 2) {
        return 'green';
      } else if (level === 3) {
        return 'orange';
      } else if (level === 4) {
        return 'red';
      }
    }
  },
  filters: {
    dateTimeView: function dateTimeView(arg) {
      if (arg) {
        var value = new Date(Number(arg));
        return value.getDate().toString().padStart(2, '0') + '/' + (value.getMonth() + 1).toString().padStart(2, '0') + '/' + value.getFullYear() + ' ' + value.getHours().toString().padStart(2, '0') + ':' + value.getMinutes().toString().padStart(2, '0');
      } else {
        return '';
      }
    }
  }
});

/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_dist_vue_min_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_dist_vue_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_dist_vue_min_js__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['index'],
  components: {
    fullScreen: function fullScreen() {
      return this.$store.getters.getFullScreen;
    }
  },
  data: function data() {
    return {
      loading: true,
      loadingAction: false,
      dossierDetail: {},
      listHistoryProcessing: [],
      dossierActions: [],
      tailieuNop: [],
      tailieuKeyQua: [],
      isPermission: false,
      detailInfo: true,
      detailVoting: false,
      detailSync: false,
      votingItems: [],
      loadingVoting: false,
      headers: [{
        text: '#',
        align: 'center',
        sortable: false
      }, {
        text: 'Vai trò',
        align: 'center',
        sortable: false,
        class: 'vaitro_column'
      }, {
        text: 'Công việc',
        align: 'center',
        sortable: false,
        class: 'congviec_column'
      }, {
        text: 'Thời hạn quy định',
        align: 'center',
        sortable: false,
        class: 'thoihanquydinh_column'
      }, {
        text: 'Ngày bắt đầu',
        align: 'center',
        sortable: false,
        class: 'ngaybatdau_column'
      }, {
        text: 'Người thực hiện',
        align: 'center',
        sortable: false,
        class: 'nguoithuchien_column'
      }, {
        text: 'Kết quả',
        align: 'center',
        sortable: false,
        class: 'ketqua_column'
      }]
    };
  },
  computed: {},
  created: function created() {
    var vm = this;
    vm.$nextTick(function () {
      vm.detailInfo = true;
      vm.$store.commit('setFullScreen', true);
      var currentParams = vm.$router.history.current.params;
      var currentQuery = vm.$router.history.current.query;
      console.log('currentQuery', currentQuery);
      if (currentQuery.hasOwnProperty('secretKey') && currentQuery.secretKey) {
        console.log('run run run');
        var filter = {
          secretKey: currentQuery.secretKey,
          dossierId: vm.index
        };
        vm.loading = true;
        vm.$store.dispatch('getDetailDossierQR', filter).then(function (resultDossier) {
          vm.loading = false;
          if (resultDossier.status && resultDossier.status.toString() === '200') {
            vm.isPermission = true;
            vm.dossierDetail = resultDossier.data;
            if (vm.dossierDetail.submissionNote) {
              var submissionNote = vm.dossierDetail.submissionNote ? JSON.parse(vm.dossierDetail.submissionNote) : '';
              var resultTemp = submissionNote ? submissionNote.data : '';
              if (resultTemp) {
                for (var i = 0; i < resultTemp.length; i++) {
                  if (resultTemp[i].hasOwnProperty('actions') && resultTemp[i]['actions'] !== null && resultTemp[i]['actions'] !== undefined) {
                    if (!Array.isArray(resultTemp[i]['actions'])) {
                      var arrActionsTemp = [];
                      arrActionsTemp.push(resultTemp[i]['actions']);
                      resultTemp[i]['actions'] = arrActionsTemp;
                    }
                  }
                }
                vm.dossierActions = resultTemp;
              }
            }
          } else {
            vm.isPermission = false;
          }
        });
      } else {
        vm.loading = false;
        vm.isPermission = false;
      }
    });
  },

  watch: {},
  methods: {
    loadDossierActions: function loadDossierActions() {
      var vm = this;
      var dataParams = {
        dossierId: vm.dossierDetail.dossierId
      };
      vm.detailInfo = false;
      if (vm.dossierDetail.originality === 0 || vm.dossierDetail.originality === '0') {} else {
        vm.$store.dispatch('loadDossierActions', dataParams).then(function (resultActions) {
          if (resultActions.data) {
            var resultTemp = resultActions.data;
            for (var i = 0; i < resultTemp.length; i++) {
              if (resultTemp[i].hasOwnProperty('actions') && resultTemp[i]['actions'] !== null && resultTemp[i]['actions'] !== undefined) {
                if (!Array.isArray(resultTemp[i]['actions'])) {
                  var arrActionsTemp = [];
                  arrActionsTemp.push(resultTemp[i]['actions']);
                  resultTemp[i]['actions'] = arrActionsTemp;
                }
              }
            }
            vm.dossierActions = resultTemp;
          }
        });
      }
    },
    loadLogs: function loadLogs() {
      var vm = this;
      var filter = {
        dossierId: vm.dossierDetail.dossierId
      };
      vm.$store.dispatch('getListHistoryProcessingItems', filter).then(function (result) {
        vm.listHistoryProcessing = [];
        vm.listHistoryProcessing = result;
      });
    },
    loadDossiertemplate: function loadDossiertemplate() {
      var vm = this;
      var filter = {
        dossierTemplateNo: vm.dossierDetail.dossierTemplateNo
      };
      if (vm.dossierDetail.dossierTemplateNo) {
        vm.$store.dispatch('loadDossierTemplates', filter).then(function (result) {
          console.log(result);
          vm.tailieuNop = result.filter(function (item) {
            return item.partType === 1;
          });
          vm.tailieuKeyQua = result.filter(function (item) {
            return item.partType === 2;
          });
        });
      }
    },
    loadVoting: function loadVoting() {
      var vm = this;
      vm.detailVoting = true;
      vm.detailSync = false;
      vm.detailInfo = false;
      var filter = {
        className: 'dossier',
        classPK: vm.dossierDetail.dossierId
      };
      vm.$store.dispatch('loadVoting', filter).then(function (result) {
        vm.votingItems = result;
        console.log('votingItems', vm.votingItems);
      }).catch(function (reject) {});
    },
    submitVoting: function submitVoting() {
      var vm = this;
      var arrAction = [];
      if (vm.votingItems.length > 0) {
        vm.loadingVoting = true;
        for (var index in vm.votingItems) {
          vm.votingItems[index]['className'] = 'dossier';
          vm.votingItems[index]['classPk'] = vm.dossierDetail.dossierId;
          arrAction.push(vm.$store.dispatch('submitVoting', vm.votingItems[index]));
        }
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(arrAction).then(function (results) {
          vm.loadingVoting = false;
          vm.loadVoting();
        }).catch(function (xhr) {
          vm.loadingVoting = false;
        });
      }
    },
    goBack: function goBack() {
      var vm = this;
      var current = vm.$router.history.current;
      var newQuery = current.query;
      var queryString = '?';
      newQuery['detail'] = '';
      for (var key in newQuery) {
        if (newQuery[key] !== '' && newQuery[key] !== 'undefined' && newQuery[key] !== undefined && newQuery[key] !== null && newQuery[key] !== 'null') {
          queryString += key + '=' + newQuery[key] + '&';
        }
      }
      vm.$router.push({
        path: current.path + queryString
      });
    },
    getColor: function getColor(level) {
      if (level === 2) {
        return 'green';
      } else if (level === 3) {
        return 'orange';
      } else if (level === 4) {
        return 'red';
      }
    },
    goHome: function goHome() {
      window.open('/web/cong-dich-vu-cong', '_self');
    }
  },
  filters: {
    dateTimeView: function dateTimeView(arg) {
      if (arg) {
        var value = new Date(Number(arg));
        return value.getDate().toString().padStart(2, '0') + '/' + (value.getMonth() + 1).toString().padStart(2, '0') + '/' + value.getFullYear() + ' ' + value.getHours().toString().padStart(2, '0') + ':' + value.getMinutes().toString().padStart(2, '0');
      } else {
        return '';
      }
    }
  }
});

/***/ }),

/***/ 239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['index'],
  components: {},
  data: function data() {
    return {
      loading: false,
      loadingAction: false,
      serviceDetail: {}
    };
  },
  computed: {},
  created: function created() {
    var vm = this;
    vm.$nextTick(function () {
      var vm = this;
      vm.loading = true;
      var filter = {
        index: vm.index
      };
      vm.$store.dispatch('getServiceDetail', filter).then(function (result) {
        vm.serviceDetail = result;
        vm.loading = false;
      }).catch(function (reject) {
        vm.loading = false;
      });
    });
  },

  watch: {},
  methods: {
    goBack: function goBack() {
      window.history.back();
    },
    getColor: function getColor(level) {
      if (level === 2) {
        return 'green';
      } else if (level === 3) {
        return 'orange';
      } else if (level === 4) {
        return 'red';
      }
    }
  }
});

/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pagination_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pagination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ChiTietDanhGiaCanBo_vue__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ChiTietDanhGiaCanBo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ChiTietDanhGiaCanBo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keyboard_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keyboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__keyboard_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: [],
  components: {
    'tiny-pagination': __WEBPACK_IMPORTED_MODULE_3__pagination_vue___default.a,
    'vue-touch-keyboard': __WEBPACK_IMPORTED_MODULE_5__keyboard_vue___default.a,
    'chi-tiet-danh-gia': __WEBPACK_IMPORTED_MODULE_4__ChiTietDanhGiaCanBo_vue___default.a
  },
  data: function data() {
    return {
      loading: false,
      loadingAction: false,
      govAgencyList: [],
      govAgencySelectedObj: {},
      govAgencySelected: '',
      detailActive: false,

      visible: false,
      layout: 'normal',
      input: null,
      options: {
        useKbEvents: false
      }
    };
  },
  computed: {
    fullScreen: function fullScreen() {
      return this.$store.getters.getFullScreen;
    },
    isMobile: function isMobile() {
      return this.$store.getters.getIsMobile;
    }
  },
  created: function created() {
    var vm = this;
    vm.$nextTick(function () {
      var vm = this;
      var current = vm.$router.history.current;
      var newQuery = current.query;

      if (vm.govAgencyList.length === 0) {
        vm.$store.dispatch('getGovAgency').then(function (result) {
          vm.govAgencyList = result;
        }).catch(function (reject) {});
      }
    });
  },

  watch: {
    '$route': function $route(newRoute, oldRoute) {
      var vm = this;
      var currentParams = newRoute.params;
      var currentQuery = newRoute.query;
      vm.govAgencySelected = currentQuery.hasOwnProperty('administration') ? currentQuery.administration : '';
      if (vm.govAgencySelected) {
        vm.detailActive = true;
      } else {
        vm.detailActive = false;
      }
      if (vm.govAgencyList.length === 0) {
        vm.$store.dispatch('getGovAgency').then(function (result) {
          vm.govAgencyList = result;
        }).catch(function (reject) {});
      }
    }
  },
  methods: {
    changeScreen: function changeScreen() {
      var vm = this;
      vm.$store.commit('setFullScreen', !vm.fullScreen);
    },
    votingDetail: function votingDetail(item) {
      var vm = this;
      vm.govAgencySelected = item.administrationCode;
      var current = vm.$router.history.current;
      var newQuery = current.query;
      var queryString = '?';
      newQuery['agencyCode'] = item.administrationCode;
      newQuery['agencyName'] = item.administrationName;
      for (var key in newQuery) {
        if (newQuery[key] !== '' && newQuery[key] !== 'undefined' && newQuery[key] !== undefined && newQuery[key] !== null) {
          queryString += key + '=' + newQuery[key] + '&';
        }
      }
      vm.$router.push({
        path: '/danh-sach-can-bo' + queryString,
        query: {
          renew: Math.floor(Math.random() * (100 - 1 + 1)) + 1
        }
      });
    }
  }
});

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_dist_vue_min_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_dist_vue_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_dist_vue_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pagination_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pagination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ChiTietDanhGiaCLDV_vue__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ChiTietDanhGiaCLDV_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ChiTietDanhGiaCLDV_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__keyboard_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__keyboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__keyboard_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: [],
  components: {
    'tiny-pagination': __WEBPACK_IMPORTED_MODULE_4__pagination_vue___default.a,
    'vue-touch-keyboard': __WEBPACK_IMPORTED_MODULE_6__keyboard_vue___default.a,
    'chi-tiet-danh-gia': __WEBPACK_IMPORTED_MODULE_5__ChiTietDanhGiaCLDV_vue___default.a
  },
  data: function data() {
    return {
      loading: false,
      loadingAction: false,
      govAgencyList: [],
      govAgencySelectedObj: {},
      govAgencySelected: '',
      detailActive: false,

      visible: false,
      layout: 'normal',
      input: null,
      options: {
        useKbEvents: false
      }
    };
  },
  computed: {
    groupIds: function groupIds() {
      return this.$store.getters.getGroupid;
    },
    groupIdArr: function groupIdArr() {
      console.log('groupIds', this.getGroupIdArr(this.groupIds));
      return this.getGroupIdArr(this.groupIds);
    }
  },
  created: function created() {
    var vm = this;
    vm.$nextTick(function () {
      var vm = this;
      var current = vm.$router.history.current;
      var newQuery = current.query;
      vm.govAgencySelected = newQuery.hasOwnProperty('administration') ? newQuery.administration : '';

      var groupIds = vm.groupIdArr.length;
      if (vm.govAgencySelected) {
        vm.detailActive = true;
      } else {
        vm.detailActive = false;
      }
      if (groupIds > 0) {
        var key;

        (function () {
          var count = 0;
          for (key = 0; key < groupIds; key++) {
            var filter = {
              groupId: vm.groupIdArr[key]
            };
            console.log('filter', filter);
            vm.$store.dispatch('getGovAgency', filter).then(function (result) {
              count += 1;
              result[0] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(result[0], { groupId: vm.groupIdArr[key] });
              vm.govAgencyList = vm.govAgencyList.concat(result);
              if (count === groupIds) {
                if (vm.govAgencyList.length > 0) {
                  vm.govAgencySelected = newQuery.hasOwnProperty('administration') ? newQuery.administration : '';
                  if (groupIds === 1) {
                    vm.govAgencySelected = vm.govAgencyList[0]['administrationCode'];
                    vm.detailActive = true;
                  }
                }
              }
            }).catch(function (reject) {
              if (count === groupIds) {
                if (vm.govAgencyList.length > 0) {
                  vm.govAgencySelected = newQuery.hasOwnProperty('administration') ? newQuery.administration : '';
                  if (groupIds === 1) {
                    vm.govAgencySelected = vm.govAgencyList[0]['administrationCode'];
                    vm.detailActive = true;
                  }
                }
              }
            });
          }
        })();
      } else {
        var filter = {
          groupId: ''
        };
        vm.$store.dispatch('getGovAgency', filter).then(function (result) {
          vm.govAgencyList = result;
          if (vm.govAgencyList.length > 0) {
            vm.govAgencySelected = newQuery.hasOwnProperty('administration') ? newQuery.administration : '';
            if (vm.govAgencyList.length === 1) {
              vm.govAgencySelected = vm.govAgencyList[0]['administrationCode'];
              vm.detailActive = true;
            }
          }
        }).catch(function (reject) {});
      }
    });
  },

  watch: {
    '$route': function $route(newRoute, oldRoute) {
      var vm = this;
      var currentParams = newRoute.params;
      var currentQuery = newRoute.query;
      vm.govAgencySelected = currentQuery.hasOwnProperty('administration') ? currentQuery.administration : '';
      if (vm.govAgencySelected) {
        vm.detailActive = true;
      } else {
        vm.detailActive = false;
      }
      if (vm.govAgencyList.length === 0) {
        vm.$store.dispatch('getGovAgency').then(function (result) {
          vm.govAgencyList = result;
        }).catch(function (reject) {});
      }
    }
  },
  methods: {
    votingDetail: function votingDetail(item) {
      var vm = this;
      vm.govAgencySelected = item.administrationCode;
      var current = vm.$router.history.current;
      var newQuery = current.query;
      var queryString = '?';
      newQuery['administration'] = item.administrationCode;
      for (var key in newQuery) {
        if (newQuery[key] !== '' && newQuery[key] !== 'undefined' && newQuery[key] !== undefined && newQuery[key] !== null) {
          queryString += key + '=' + newQuery[key] + '&';
        }
      }
      vm.$router.push({
        path: current.path + queryString,
        query: {
          renew: Math.floor(Math.random() * (100 - 1 + 1)) + 1
        }
      });
    },
    govAgencyName: function govAgencyName(arg) {
      var vm = this;
      if (arg) {
        var value = vm.govAgencyList.filter(function (item) {
          return item.administrationCode.toString() === arg.toString();
        });
        if (value.length > 0) {
          return value[0].administrationName;
        }
      } else {
        return '';
      }
    },
    getGroupIdArr: function getGroupIdArr(groupIds) {
      if (groupIds) {
        return groupIds.split(',');
      } else {
        return [];
      }
    },
    paggingData: function paggingData(config) {
      console.log('config', config);
      var vm = this;
      var current = vm.$router.history.current;
      var newQuery = current.query;
      var queryString = '?';
      newQuery['page'] = '';

      for (var key in newQuery) {
        if (newQuery[key] !== '' && newQuery[key] !== 'undefined' && newQuery[key] !== undefined && newQuery[key] !== null && newQuery[key] !== 'null') {
          queryString += key + '=' + newQuery[key] + '&';
        }
      }
      queryString += 'page=' + config.page;
      vm.$router.push({
        path: current.path + queryString
      });
    }
  }
});

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Captcha_vue__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Captcha_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Captcha_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Pagination1_vue__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Pagination1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Pagination1_vue__);







__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_toastr___default.a);
__WEBPACK_IMPORTED_MODULE_1_toastr___default.a.options = {
  'closeButton': true,
  'timeOut': '5000'
};
/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['itemCode'],
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a,
    'captcha': __WEBPACK_IMPORTED_MODULE_2__Captcha_vue___default.a,
    'tiny-pagination': __WEBPACK_IMPORTED_MODULE_4__Pagination1_vue___default.a
  },
  data: function data() {
    return {
      itemName: '',
      employeeItems: [],
      btnLoading: false,
      dialog_voting: false,
      dialog_voting_result: false,
      dialogShowApplicantIdNo: false,
      applicantIdNo: '',
      agencyName: '',
      dossierNo: '',
      employeeSelected: '',
      votingItems: [],
      lengthPage: 0,
      totalEmployee: 0,
      employeePage: 1,
      numberPerPage: 12
    };
  },
  computed: {
    loading: function loading() {
      return this.$store.getters.loading;
    },
    fullScreen: function fullScreen() {
      return this.$store.getters.getFullScreen;
    },
    isMobile: function isMobile() {
      return this.$store.getters.getIsMobile;
    }
  },
  created: function created() {
    var vm = this;
    var currentQuery = vm.$router.history.current.query;
    vm.agencyName = currentQuery.hasOwnProperty('agencyName') ? currentQuery.agencyName : '';
    vm.$nextTick(function () {
      vm.employeePage = currentQuery.hasOwnProperty('page') ? Number(currentQuery.page) : 1;
      vm.getEmployee();
    });
  },

  watch: {
    '$route': function $route(newRoute, oldRoute) {
      var vm = this;
      vm.getEmployee();
    }
  },
  methods: {
    changeScreen: function changeScreen() {
      var vm = this;
      vm.$store.commit('setFullScreen', !vm.fullScreen);
    },
    getEmployee: function getEmployee() {
      var vm = this;
      var sortEmployee = function sortEmployee(employeeList) {
        function compare(a, b) {
          if (a.employeeNo < b.employeeNo) {
            return -1;
          } else if (a.employeeNo > b.employeeNo) {
            return 1;
          } else {
            return 0;
          }
        }
        return employeeList.sort(compare);
      };
      var filter = {
        start: vm.employeePage * vm.numberPerPage - vm.numberPerPage,
        end: vm.employeePage * vm.numberPerPage,
        agencyCode: ''
      };
      var current = vm.$router.history.current;
      var newQuery = current.query;
      vm.$store.dispatch('loadEmployeesMotcua', filter).then(function (result) {
        vm.totalEmployee = result[0];
        vm.employeeItems = sortEmployee(result[1]);
        vm.lengthPage = Math.ceil(result[0] / vm.numberPerPage);
        if (vm.employeeItems && vm.employeeItems.length > 0) {
          for (var key in vm.employeeItems) {
            vm.getAvatar(vm.employeeItems[key], key);
            vm.getVotingEmployee(vm.employeeItems[key], key);
          }
        }
      }).catch(function (xhr) {
        vm.totalThuTuc = 0;
        vm.thutucPage = 1;
      });
    },
    getAvatar: function getAvatar(item, key) {
      var vm = this;
      var filter = {
        employeeId: item.employeeId
      };
      vm.$store.dispatch('loadImageEmployee', filter).then(function (data) {
        if (data !== '' && data !== null) {
          var portalURL = '';
          if (window.themeDisplay !== null && window.themeDisplay !== undefined) {
            portalURL = window.themeDisplay.getPortalURL();
          }
          vm.employeeItems[key]['imgSrc'] = portalURL + data;
        }
      }).catch(function (data) {
        vm.employeeItems[key]['imgSrc'] = '';
      });
    },
    viewDetailEmployee: function viewDetailEmployee(item) {
      var vm = this;
      vm.$store.commit('setEmployeeSelected', item);
      vm.$router.push({
        path: '/danh-sach-can-bo/' + item.employeeId,
        query: {
          renew: Math.floor(Math.random() * (100 - 1 + 1)) + 1
        }
      });
    },
    getVotingEmployee: function getVotingEmployee(item, key) {
      var vm = this;
      vm.$store.dispatch('loadVoting', {
        className: 'employee',
        classPk: item.employeeId
      }).then(function (result) {
        var votingItems = result;
        vm.getScoreVoting(votingItems, key);
      }).catch(function (xhr) {});
    },
    getScoreVoting: function getScoreVoting(votingItems, key) {
      var vm = this;
      if (votingItems && votingItems.length > 0) {
        var totalVoting = 0;
        var totalScore = 0;
        var lengthQuestion = votingItems.length;
        var lengthAnswer = votingItems[0]['answers'].length;
        for (var i = 0; i < lengthQuestion; i++) {
          totalVoting += votingItems[i]['answersCount'];
          for (var j = 0; j < lengthAnswer; j++) {
            totalScore += votingItems[i]['answers'][j] * (lengthAnswer - j);
          }
        }
        if (totalVoting > 0) {
          vm.employeeItems[key]['score'] = Number((totalScore * 5 / (totalVoting * lengthAnswer)).toFixed(1));
          vm.employeeItems[key]['totalVoting'] = Number(totalVoting);
        }
      }
    },
    changePage: function changePage() {
      var vm = this;
      var current = vm.$router.history.current;
      var newQuery = current.query;
      var queryString = '?';
      newQuery['page'] = '';
      for (var key in newQuery) {
        if (newQuery[key] !== '' && newQuery[key] !== 'undefined' && newQuery[key] !== undefined && newQuery[key] !== null && newQuery[key] !== 'null') {
          queryString += key + '=' + newQuery[key] + '&';
        }
      }
      queryString += 'page=' + vm.employeePage;
      vm.$router.push({
        path: current.path + queryString
      });
    },
    goBack: function goBack() {
      window.history.back();
    }
  }
});

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__keyboard_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__keyboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__keyboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pagination2_vue__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pagination2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pagination2_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: [],
  components: {
    'tiny-pagination': __WEBPACK_IMPORTED_MODULE_4__pagination2_vue___default.a,
    'vue-touch-keyboard': __WEBPACK_IMPORTED_MODULE_3__keyboard_vue___default.a
  },
  data: function data() {
    return {
      loading: false,
      loadingAction: false,
      dossierNoKey: '',
      agencies: [],
      dossierList: [],
      totalPages: 0,
      pagination: {
        rowsPerPage: 10,
        page: 1
      },
      headerTable: [{
        text: 'STT',
        align: 'center',
        sortable: false,
        width: '50px'
      }, {
        text: 'Mã hồ sơ',
        align: 'center',
        sortable: false,
        width: '200px'
      }, {
        text: 'Chủ hồ sơ',
        align: 'center',
        sortable: false
      }, {
        text: 'Ngày nộp',
        align: 'center',
        sortable: false,
        width: '170px'
      }, {
        text: 'Ngày có kết quả',
        align: 'center',
        sortable: false,
        width: '170px'
      }],
      visible: false,
      layout: 'normal',
      input: null,
      options: {
        useKbEvents: true,
        preventClickEvent: false
      }
    };
  },
  computed: {
    fullScreen: function fullScreen() {
      return this.$store.getters.getFullScreen;
    },
    groupIds: function groupIds() {
      return this.$store.getters.getGroupid;
    },
    groupIdArr: function groupIdArr() {
      return this.getGroupIdArr(this.groupIds);
    },
    isMobile: function isMobile() {
      return this.$store.getters.getIsMobile;
    }
  },
  created: function created() {
    var vm = this;
    vm.$nextTick(function () {
      var current = vm.$router.history.current;
      var newQuery = current.query;
      vm.dossierNoKey = newQuery.hasOwnProperty('keyword') ? newQuery.keyword : '';
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#dossierNoKey').val(vm.dossierNoKey);
      vm.$store.commit('setFullScreen', false);
      vm.$store.dispatch('agencies').then(function (result) {
        vm.agencies = result;
      });
      vm.doLoadingDataHoSo();
      setInterval(function () {
        vm.doLoadingDataHoSo();
      }, 1800000);
    });
  },

  watch: {
    '$route': function $route(newRoute, oldRoute) {
      var vm = this;
      var currentQuery = newRoute.query;
      var keyword = currentQuery.hasOwnProperty('keyword') ? currentQuery.keyword : '';
      vm.dossierNoKey = keyword;
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#dossierNoKey').val(vm.dossierNoKey);
      vm.searchDossier();
    }
  },
  methods: {
    changeItem: function changeItem(event) {
      var vm = this;
      vm.pagination.page = event + 1;
    },
    doLoadingDataHoSo: function doLoadingDataHoSo() {
      var vm = this;
      vm.dossierList = [];
      vm.loading = true;
      var filter = {
        fromDate: vm.fromDate(),
        toDate: vm.fromDate(),
        groupId: '',
        keyword: vm.dossierNoKey
      };
      var groupIds = vm.groupIdArr.length;
      if (groupIds > 0) {
        var key;

        (function () {
          var count = 0;
          for (key = 0; key < groupIds; key++) {
            filter.groupId = vm.groupIdArr[key];
            console.log('filter', filter);
            vm.$store.dispatch('loadingDataHoSoKQ', filter).then(function (result) {
              count += 1;
              if (result.data) {
                vm.dossierList = vm.dossierList.concat(result.data);
              }
              if (count === groupIds) {
                console.log('dossierList', vm.dossierList);
                vm.totalPages = Math.ceil(vm.dossierList.length / vm.pagination.rowsPerPage);
                vm.loading = false;
              }
            }).catch(function (reject) {
              count += 1;
              if (count === groupIds) {
                vm.totalPages = Math.ceil(vm.dossierList.length / vm.pagination.rowsPerPage);
                vm.loading = false;
              }
            });
          }
        })();
      } else {
        vm.$store.dispatch('loadingDataHoSoKQ', filter).then(function (result) {
          vm.loading = false;
          if (result.data) {
            vm.dossierList = vm.dossierList.concat(result.data);
            vm.totalPages = Math.ceil(vm.dossierList.length / vm.pagination.rowsPerPage);
            console.log('dosierLisst', vm.dossierList);
          }
        }).catch(function (reject) {
          vm.loading = false;
        });
      }
    },
    searchKeyword: function searchKeyword() {
      var vm = this;
      vm.visible = false;
      vm.dossierNoKey = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#dossierNoKey').val();
      var keyword = vm.dossierNoKey !== null && vm.dossierNoKey !== 'null' ? vm.dossierNoKey : '';
      vm.$router.push({
        path: '/ho-so-co-ket-qua?keyword=' + keyword,
        query: {
          renew: Math.floor(Math.random() * (100 - 1 + 1)) + 1
        }
      });
    },
    searchDossier: function searchDossier() {
      var vm = this;
      vm.dossierList = [];
      vm.loading = true;
      var filter = {
        fromDate: vm.fromDate(),
        toDate: vm.fromDate(),
        groupId: '',
        keyword: vm.dossierNoKey
      };
      vm.$store.dispatch('loadingDataHoSoKQ', filter).then(function (result) {
        vm.loading = false;
        if (result.data) {
          vm.dossierList = vm.dossierList.concat(result.data);
          vm.totalPages = Math.ceil(vm.dossierList.length / vm.pagination.rowsPerPage);
        }
      }).catch(function (reject) {
        vm.loading = false;
      });
    },
    getGroupIdArr: function getGroupIdArr(groupIds) {
      if (groupIds) {
        return groupIds.split(',');
      } else {
        return [];
      }
    },
    changeScreen: function changeScreen() {
      var vm = this;
      vm.$store.commit('setFullScreen', !vm.fullScreen);
    },
    fromDate: function fromDate() {
      var value = new Date();
      return value.getDate().toString().padStart(2, '0') + '/' + (value.getMonth() + 1).toString().padStart(2, '0') + '/' + value.getFullYear();
    },
    toDate: function toDate() {
      var value = new Date(new Date().getTime() + 86400000);
      return value.getDate().toString().padStart(2, '0') + '/' + (value.getMonth() + 1).toString().padStart(2, '0') + '/' + value.getFullYear();
    },
    show: function show(e) {
      this.validPass = true;
      this.input = e.target;
      if (!this.visible) {
        this.visible = true;
      }
      this.bindClick('search');
    },
    bindClick: function bindClick(type) {
      var vm = this;
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.keyboard .enter').unbind('click');
        if (type === 'search') {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.keyboard .enter').bind('click', function () {
            vm.searchKeyword();
          });
        } else if (type === 'view') {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.keyboard .enter').bind('click', function () {
            vm.submitViewDetail();
          });
        }
      }, 300);
    }
  }
});

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__keyboard_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__keyboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__keyboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pagination2_vue__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pagination2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pagination2_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: [],
  components: {
    'vue-touch-keyboard': __WEBPACK_IMPORTED_MODULE_3__keyboard_vue___default.a,
    'tiny-pagination': __WEBPACK_IMPORTED_MODULE_4__pagination2_vue___default.a
  },
  data: function data() {
    return {
      loading: false,
      loadingAction: false,
      dossierNoKey: '',
      dossierList: [],
      agencies: [],
      totalPages: 0,
      pagination: {
        rowsPerPage: 10,
        page: 1
      },
      headerTable: [{
        text: 'STT',
        align: 'center',
        sortable: false,
        width: '50px'
      }, {
        text: 'Mã hồ sơ',
        align: 'center',
        sortable: false,
        width: '200px'
      }, {
        text: 'Chủ hồ sơ',
        align: 'center',
        sortable: false
      }, {
        text: 'Ngày nộp',
        align: 'center',
        sortable: false,
        width: '170px'
      }, {
        text: 'Ngày tiếp nhận',
        align: 'center',
        sortable: false,
        width: '170px'
      }],
      visible: false,
      layout: 'normal',
      input: null,
      options: {
        useKbEvents: true,
        preventClickEvent: false
      }
    };
  },
  computed: {
    fullScreen: function fullScreen() {
      return this.$store.getters.getFullScreen;
    },
    groupIds: function groupIds() {
      return this.$store.getters.getGroupid;
    },
    groupIdArr: function groupIdArr() {
      return this.getGroupIdArr(this.groupIds);
    },
    isMobile: function isMobile() {
      return this.$store.getters.getIsMobile;
    }
  },
  created: function created() {
    var vm = this;
    var currentQuery = vm.$router.history.current.query;
    var keyword = currentQuery.hasOwnProperty('keyword') ? currentQuery.keyword : '';
    vm.dossierNoKey = keyword;
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#dossierNoKey').val(vm.dossierNoKey);
    vm.$nextTick(function () {
      vm.$store.commit('setFullScreen', false);
      vm.$store.dispatch('agencies').then(function (result) {
        vm.agencies = result;
      });
      vm.searchDossier();
      setInterval(function () {
        vm.dossierNoKey = '';
        vm.searchDossier();
      }, 1800000);
    });
  },

  watch: {
    '$route': function $route(newRoute, oldRoute) {
      var vm = this;
      var currentQuery = newRoute.query;
      var keyword = currentQuery.hasOwnProperty('keyword') ? currentQuery.keyword : '';
      vm.dossierNoKey = keyword;
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#dossierNoKey').val(vm.dossierNoKey);
      vm.searchDossier();
    }
  },
  methods: {
    changeItem: function changeItem(event) {
      var vm = this;
      vm.pagination.page = event + 1;
    },
    searchKeyword: function searchKeyword() {
      var vm = this;
      vm.dossierNoKey = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#dossierNoKey').val();
      var keyword = vm.dossierNoKey !== null && vm.dossierNoKey !== 'null' ? vm.dossierNoKey : '';
      vm.$router.push({
        path: '/tiep-nhan-ho-so?keyword=' + keyword,
        query: {
          renew: Math.floor(Math.random() * (100 - 1 + 1)) + 1
        }
      });
    },
    paggingData: function paggingData(config) {
      var vm = this;
      vm.pagination.page = config.page;
    },
    searchDossier: function searchDossier() {
      var vm = this;
      vm.dossierList = [];
      vm.loading = true;
      var filter = {
        fromDate: vm.fromDate(),
        toDate: vm.fromDate(),
        groupId: '',
        keyword: vm.dossierNoKey
      };
      vm.$store.dispatch('loadingDataHoSoTN', filter).then(function (result) {
        vm.loading = false;
        if (result.data) {
          vm.dossierList = result.data;
          vm.pagination.page = 1;
          vm.totalPages = Math.ceil(vm.dossierList.length / vm.pagination.rowsPerPage);
        }
      }).catch(function (reject) {
        vm.loading = false;
      });
    },
    changeScreen: function changeScreen() {
      var vm = this;
      vm.$store.commit('setFullScreen', !vm.fullScreen);
    },
    getGroupIdArr: function getGroupIdArr(groupIds) {
      if (groupIds) {
        return groupIds.split(',');
      } else {
        return [];
      }
    },
    fromDate: function fromDate() {
      var value = new Date();
      return value.getDate().toString().padStart(2, '0') + '/' + (value.getMonth() + 1).toString().padStart(2, '0') + '/' + value.getFullYear();
    },
    toDate: function toDate() {
      var value = new Date(new Date().getTime() + 86400000);
      return value.getDate().toString().padStart(2, '0') + '/' + (value.getMonth() + 1).toString().padStart(2, '0') + '/' + value.getFullYear();
    },
    show: function show(e) {
      this.validPass = true;
      this.input = e.target;
      if (!this.visible) {
        this.visible = true;
      }
      this.bindClick('search');
    },
    bindClick: function bindClick(type) {
      var vm = this;
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.keyboard .enter').unbind('click');
        if (type === 'search') {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.keyboard .enter').bind('click', function () {
            vm.searchKeyword();
          });
        } else if (type === 'view') {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.keyboard .enter').bind('click', function () {
            vm.submitViewDetail();
          });
        }
      }, 300);
    }
  }
});

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: [],
  components: {},
  data: function data() {
    return {};
  },
  created: function created() {},

  methods: {
    goTraCuuHoSo: function goTraCuuHoSo() {
      __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/tra-cuu-ho-so');
    },
    goTraCuuThuTuc: function goTraCuuThuTuc() {
      __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/tra-cuu-thu-tuc');
    },
    goDanhGiaCanBo: function goDanhGiaCanBo() {
      __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/danh-gia-can-bo');
    },
    goHoSoKetQua: function goHoSoKetQua() {
      __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/ho-so-co-ket-qua');
    }
  }
});

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var COMPONENT_NAME = 'TinyPagination';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: COMPONENT_NAME,
  props: {
    total: {
      type: Number,
      required: true
    },
    page: {
      type: Number,
      default: 1
    },
    lang: {
      type: String,
      default: 'en'
    },
    customClass: {
      type: String
    },
    limits: {
      type: Array,
      default: function _default() {
        return [10, 15, 20, 50, 100];
      }
    },
    showLimit: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      version: '0.2.1',
      currentPage: 1,
      currentLimit: 6,
      translations: {
        en: {
          prev: 'Previous',
          title: 'Page',
          next: 'Next'
        }
      },
      availableLanguages: ['en']
    };
  },
  created: function created() {
    this.currentPage = this.page;
  },

  watch: {
    page: function page(val) {
      this.currentPage = parseInt(val);
    }
  },
  computed: {
    translation: function translation() {
      return this.availableLanguages.includes(this.lang) ? this.translations[this.lang] : this.translations['en'];
    },
    totalPages: function totalPages() {
      return Math.ceil(this.total / this.currentLimit);
    },
    totalPagesData: function totalPagesData() {
      var totalDatas = [];
      var data = {};
      for (var index = 1; index <= this.totalPages; ++index) {
        data = {
          value: index,
          text: 'Trang ' + index
        };
        totalDatas.push(data);
      }
      return totalDatas;
    },
    titlePage: function titlePage() {
      return '' + this.currentPage;
    },
    classFirstPage: function classFirstPage() {
      return {
        'c-not-allowed pagination__navigation--disabled': this.currentPage === 1
      };
    },
    classLastPage: function classLastPage() {
      return {
        'c-not-allowed pagination__navigation--disabled': this.currentPage === this.totalPages
      };
    }
  },
  methods: {
    nextPage: function nextPage() {
      if (this.currentPage !== this.totalPages) {
        this.currentPage += 1;
        this.$emit('tiny:change-page', {
          page: this.currentPage
        });
      }
    },
    lastPage: function lastPage() {
      if (this.currentPage > 1) {
        this.currentPage -= 1;
        this.$emit('tiny:change-page', {
          page: this.currentPage
        });
      }
    },
    nextPageLast: function nextPageLast() {
      this.currentPage = this.totalPages;
      this.$emit('tiny:change-page', {
        page: this.totalPages
      });
    },
    lastPageLast: function lastPageLast() {
      this.currentPage = 1;
      this.$emit('tiny:change-page', {
        page: 1
      });
    },
    goToPage: function goToPage() {
      this.$emit('tiny:change-page', {
        page: this.currentPage
      });
    },
    onLimitChange: function onLimitChange() {
      this.currentPage = 1;
    }
  }
});

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChiTietHoSo_vue__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChiTietHoSo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ChiTietHoSo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pagination_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pagination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keyboard_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keyboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__keyboard_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: [],
  components: {
    'tiny-pagination': __WEBPACK_IMPORTED_MODULE_4__pagination_vue___default.a,
    'vue-touch-keyboard': __WEBPACK_IMPORTED_MODULE_5__keyboard_vue___default.a,
    'chi-tiet-ho-so': __WEBPACK_IMPORTED_MODULE_3__ChiTietHoSo_vue___default.a
  },
  data: function data() {
    return {
      loading: false,
      loadingAction: false,
      loadingTable: false,
      dossierNoKey: '',
      applicantNameKey: '',
      applicantIdNoKey: '',
      dossierList: [],
      agencies: [],
      dossierItemTotal: 0,
      hosoDatasPage: 1,
      totalPages: 0,
      headersTable: [{
        text: 'Mã hồ sơ',
        align: 'center',
        sortable: false
      }, {
        text: 'Người nộp',
        align: 'center',
        sortable: false
      }, {
        text: 'Ngày nộp',
        align: 'center',
        sortable: false
      }],
      validateTracuu: false,
      dialogCheckPass: false,
      dialogError: false,
      dossierDetail: '',
      valid: false,
      passCheck: '',
      validPass: true,
      activeDetailDossier: false,

      visible: false,
      layout: 'normal',
      input: null,
      options: {
        useKbEvents: true,
        preventClickEvent: false
      }
    };
  },
  computed: {
    filterDossierKey: function filterDossierKey() {
      return this.$store.getters.getFilterDossierKey;
    },
    groupIds: function groupIds() {
      return this.$store.getters.getGroupid;
    },
    groupIdArr: function groupIdArr() {
      return this.getGroupIdArr(this.groupIds);
    },
    isMobile: function isMobile() {
      return this.$store.getters.getIsMobile;
    },
    fullScreen: function fullScreen() {
      return this.$store.getters.getFullScreen;
    }
  },
  created: function created() {
    var vm = this;
    vm.$nextTick(function () {
      var vm = this;
      vm.$store.dispatch('agencies').then(function (result) {
        vm.agencies = result;
      });
      vm.$store.commit('setFullScreen', false);
      var current = vm.$router.history.current;
      var newQuery = current.query;
      vm.dossierNoKey = newQuery.hasOwnProperty('dossierNo') ? newQuery.dossierNo : '';
      vm.applicantIdNoKey = newQuery.hasOwnProperty('applicantIdNo') ? newQuery.applicantIdNo : '';
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#dossierNoKey').val(vm.dossierNoKey);
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#applicantIdNoKey').val(vm.applicantIdNoKey);

      vm.hosoDatasPage = 1;
      if ((vm.dossierNoKey !== '' || vm.applicantIdNoKey !== '') && !newQuery.hasOwnProperty('detail') && !newQuery['detail']) {
        vm.validateTracuu = true;
        vm.doLoadingDataHoSo();
      } else {
        vm.validateTracuu = false;
      }
      if (newQuery.hasOwnProperty('detail') && newQuery['detail']) {
        vm.validateTracuu = true;
        vm.activeDetailDossier = true;
      } else {
        vm.activeDetailDossier = false;
      }
    });
  },

  watch: {
    '$route': function $route(newRoute, oldRoute) {
      var vm = this;
      var currentParams = newRoute.params;
      var currentQuery = newRoute.query;
      vm.dossierNoKey = currentQuery.hasOwnProperty('dossierNo') ? currentQuery.dossierNo : '';
      vm.applicantIdNoKey = currentQuery.hasOwnProperty('applicantIdNo') ? currentQuery.applicantIdNo : '';
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#dossierNoKey').val(vm.dossierNoKey);
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#applicantIdNoKey').val(vm.applicantIdNoKey);
      vm.hosoDatasPage = 1;
      if ((vm.dossierNoKey || vm.applicantIdNoKey) && !currentQuery.hasOwnProperty('detail') && !currentQuery['detail']) {
        vm.validateTracuu = true;
        vm.doLoadingDataHoSo();
      } else {
        vm.validateTracuu = false;
      }
      if (currentQuery.hasOwnProperty('detail') && currentQuery['detail']) {
        vm.validateTracuu = true;
        vm.activeDetailDossier = true;
      } else {
        vm.activeDetailDossier = false;
      }
    }
  },
  methods: {
    filterDossier: function filterDossier() {
      var vm = this;
      vm.visible = false;
      var current = vm.$router.history.current;
      var newQuery = current.query;
      var queryString = '?';
      vm.dossierNoKey = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#dossierNoKey').val();
      vm.applicantIdNoKey = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#applicantIdNoKey').val();
      if (vm.dossierNoKey.indexOf('D-') < 0) {
        newQuery['dossierNo'] = vm.dossierNoKey;
        newQuery['applicantIdNo'] = vm.applicantIdNoKey;
        vm.$store.commit('setDossierNoSearch', vm.dossierNoKey);
        vm.$store.commit('setApplicantIdNoSearch', vm.applicantIdNoKey);
        newQuery['detail'] = '';
        for (var key in newQuery) {
          if (newQuery[key] !== '' && newQuery[key] !== 'undefined' && newQuery[key] !== undefined && newQuery[key] !== null) {
            queryString += key + '=' + newQuery[key] + '&';
          }
        }
        if (vm.dossierNoKey || vm.applicantIdNoKey) {
          vm.validateTracuu = true;
          vm.$router.push({
            path: current.path + queryString,
            query: {
              renew: Math.floor(Math.random() * (100 - 1 + 1)) + 1
            }
          });
        } else {
          vm.validateTracuu = false;
        }
      } else if (vm.dossierNoKey.indexOf('D-') >= 0 && String(vm.dossierNoKey).split('-').length === 3) {
        console.log('run run run');
        var filter = {
          password: String(vm.dossierNoKey).split('-')[1],
          dossierId: String(vm.dossierNoKey).split('-')[2]
        };
        console.log('filter', filter);
        vm.$store.dispatch('getDossierDetailPass', filter).then(function (result) {
          if (result.status && result.status.toString() === '203') {
            vm.dialogError = true;
          } else if (result.status && result.status.toString() === '200') {
            vm.$store.commit('setDossierDetail', result.data);
            var _queryString = '?detail=true';
            vm.$router.push({
              path: '/tra-cuu-ho-so' + _queryString
            });
          }
        }).catch(function (reject) {
          vm.dialogCheckPass = false;
          vm.visible = false;
          vm.loading = false;
          console.log('reject', reject);
        });
      }
    },
    submitPass: function submitPass() {
      var vm = this;
      if (__WEBPACK_IMPORTED_MODULE_2_jquery___default()('#passCheck').val() !== '') {
        vm.validPass = true;
        if (vm.targetCheckPass === 'tracuuhoso') {
          var payload = {
            dossierNo: vm.filterDossierKey.dossierNo ? vm.filterDossierKey.dossierNo : '',
            applicantIdNo: vm.filterDossierKey.applicantIdNo ? vm.filterDossierKey.applicantIdNo : '',
            secretCode: __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#passCheck').val()
          };
          vm.$store.commit('setFilterDossierKey', payload);
          var newQuery = {
            dossierNo: vm.filterDossierKey.dossierNo,
            applicantIdNo: vm.filterDossierKey.applicantIdNo
          };
          var queryString = '?';
          for (var key in newQuery) {
            if (newQuery[key] !== '' && newQuery[key] !== 'undefined' && newQuery[key] !== undefined && newQuery[key] !== null) {
              queryString += key + '=' + newQuery[key] + '&';
            }
          }
          vm.$router.push({
            path: '/tra-cuu-ho-so' + queryString,
            query: {
              renew: Math.floor(Math.random() * (100 - 1 + 1)) + 1
            }
          });
        } else {
          console.log('vm.dossierDetail', vm.dossierDetail);
          var filter = {
            password: __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#passCheck').val(),
            dossierId: vm.dossierDetail.dossierId
          };
          vm.$store.dispatch('getDossierDetailPass', filter).then(function (result) {
            vm.loading = false;
            vm.dialogCheckPass = false;
            vm.clearDialog();
            if (result.status && result.status.toString() === '203') {
              vm.dialogError = true;
            } else if (result.status && result.status.toString() === '200') {
              vm.$store.commit('setDossierDetail', result.data);
              var _queryString2 = '?dossierNo=' + vm.dossierNoSearch + '&applicantIdNo=' + vm.applicantIdNoSearch + '&detail=true';
              vm.$router.push({
                path: '/tra-cuu-ho-so' + _queryString2
              });
            }
          }).catch(function (reject) {
            vm.dialogCheckPass = false;
            vm.visible = false;
            vm.loading = false;
            console.log('reject', reject);
          });
        }
      } else {
        vm.validPass = false;
      }
    },
    confirmPass: function confirmPass() {
      var vm = this;
      var payload = {
        dossierNo: vm.dossierNoKey,
        applicantIdNo: vm.applicantIdNoKey,
        secretCode: vm.filterDossierKey.secretCode ? vm.filterDossierKey.secretCode : ''
      };
      vm.$store.commit('setFilterDossierKey', payload);
      if (vm.dossierNoKey || vm.applicantIdNoKey) {
        vm.validateTracuu = true;
        vm.$router.push({
          path: '/ma-truy-cap',
          query: {
            target: 'tracuuhoso'
          }
        });
      } else {
        vm.validateTracuu = false;
      }
    },
    doLoadingDataHoSo: function doLoadingDataHoSo() {
      var vm = this;
      vm.dossierList = [];
      vm.loadingTable = true;
      var currentQuery = __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].history.current.query;
      var filter = null;
      var groupIds = vm.groupIdArr.length;
      if (groupIds > 0) {
        var key;

        (function () {
          var totalRecord = 0;
          var count = 0;
          for (key = 0; key < groupIds; key++) {
            filter = {
              page: currentQuery.page ? currentQuery.page : 1,
              dossierNo: currentQuery.hasOwnProperty('dossierNo') ? currentQuery.dossierNo : '',
              applicantIdNo: currentQuery.hasOwnProperty('applicantIdNo') ? currentQuery.applicantIdNo : '',
              secretCode: vm.filterDossierKey.secretCode,
              groupId: vm.groupIdArr[key]
            };
            vm.$store.dispatch('loadingDataHoSo', filter).then(function (result) {
              vm.hosoDatasPage = currentQuery.page ? currentQuery.page : 1;
              count += 1;
              totalRecord = result.total > totalRecord ? result.total : totalRecord;
              if (result.data) {
                vm.dossierList = vm.dossierList.concat(result.data);
              }
              if (count === groupIds) {
                vm.loadingTable = false;
                vm.dossierItemTotal = totalRecord;
                vm.totalPages = Number(totalRecord);
              }
            }).catch(function (reject) {
              count += 1;
              if (count === groupIds) {
                vm.loadingTable = false;
                vm.dossierItemTotal = totalRecord;
                vm.totalPages = Number(totalRecord);
              }
            });
          }
        })();
      } else {
        filter = {
          page: currentQuery.page ? currentQuery.page : 1,
          dossierNo: currentQuery.hasOwnProperty('dossierNo') ? currentQuery.dossierNo : '',
          applicantIdNo: currentQuery.hasOwnProperty('applicantIdNo') ? currentQuery.applicantIdNo : '',
          secretCode: vm.filterDossierKey.secretCode
        };
        vm.$store.dispatch('loadingDataHoSo', filter).then(function (result) {
          vm.hosoDatasPage = currentQuery.page ? currentQuery.page : 1;
          vm.loadingTable = false;
          if (result.data) {
            vm.dossierList = result.data;
            vm.dossierItemTotal = result.total;
            vm.totalPages = Number(result.total);
          } else {
            vm.dossierList = [];
            vm.dossierItemTotal = 0;
          }
        }).catch(function (reject) {
          vm.loadingTable = false;
          vm.dossierList = [];
          vm.totalPages = 0;
          vm.dossierItemTotal = 0;
        });
      }
    },
    viewDetail: function viewDetail(item) {
      var vm = this;
      vm.dossierDetail = item;
      vm.$store.commit('setDossierDetail', item);
      vm.$router.push({
        path: '/ma-truy-cap',
        query: {
          target: 'chitiethoso'
        }
      });
    },
    submitViewDetail: function submitViewDetail() {
      var vm = this;
      if (__WEBPACK_IMPORTED_MODULE_2_jquery___default()('#passCheck').val() !== '') {
        vm.validPass = true;
        vm.loading = true;
        var filter = {
          password: __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#passCheck').val(),
          dossierId: vm.dossierDetail.dossierId
        };
        vm.$store.dispatch('getDossierDetailPass', filter).then(function (result) {
          vm.loading = false;
          vm.dialogCheckPass = false;
          vm.clearDialog();
          if (result.status && result.status.toString() === '203') {
            vm.dialogError = true;
          } else if (result.status && result.status.toString() === '200') {
            __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/ho-so/' + vm.dossierDetail.dossierId);
          }
        }).catch(function (reject) {
          vm.dialogCheckPass = false;
          vm.visible = false;
          vm.loading = false;
          console.log('reject', reject);
        });
      } else {
        vm.validPass = false;
      }
    },
    getGroupIdArr: function getGroupIdArr(groupIds) {
      if (groupIds) {
        return groupIds.split(',');
      } else {
        return [];
      }
    },
    changeScreen: function changeScreen() {
      var vm = this;
      vm.$store.commit('setFullScreen', !vm.fullScreen);
    },
    paggingData: function paggingData(config) {
      var vm = this;
      var current = vm.$router.history.current;
      var newQuery = current.query;
      var queryString = '?';
      newQuery['page'] = '';
      for (var key in newQuery) {
        if (newQuery[key] !== '' && newQuery[key] !== 'undefined' && newQuery[key] !== undefined && newQuery[key] !== null && newQuery[key] !== 'null') {
          queryString += key + '=' + newQuery[key] + '&';
        }
      }
      queryString += 'page=' + config.page;
      vm.$router.push({
        path: current.path + queryString
      });
    },
    clearDialog: function clearDialog() {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#passCheck').val('');
      this.validPass = true;
      this.visible = false;
    },
    show: function show(e) {
      this.validPass = true;
      this.input = e.target;
      if (!this.visible) {
        this.visible = true;
      }
      this.bindClick('search');
    },
    showKeyboard: function showKeyboard(e) {
      this.validPass = true;
      this.input = e.target;
      if (!this.visible) {
        this.visible = true;
      }
      this.bindClick('view');
    },
    bindClick: function bindClick(type) {
      var vm = this;
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.keyboard .enter').unbind('click');
        if (type === 'search') {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.keyboard .enter').bind('click', function () {
            vm.filterDossier();
          });
        } else if (type === 'view') {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.keyboard .enter').bind('click', function () {
            vm.submitViewDetail();
          });
        }
      }, 300);
    }
  }
});

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_dist_vue_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChiTietHoSoHomePage_vue__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChiTietHoSoHomePage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ChiTietHoSoHomePage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pagination_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pagination_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: [],
  components: {
    'tiny-pagination': __WEBPACK_IMPORTED_MODULE_4__pagination_vue___default.a,
    'chi-tiet-ho-so': __WEBPACK_IMPORTED_MODULE_3__ChiTietHoSoHomePage_vue___default.a
  },
  data: function data() {
    return {
      loading: false,
      loadingAction: false,
      loadingTable: false,
      dossierNoKey: '',
      applicantNameKey: '',
      applicantIdNoKey: '',
      dossierList: [],
      dossierItemTotal: 0,
      hosoDatasPage: 1,
      totalPages: 0,
      headersTable: [{
        text: 'STT',
        align: 'center',
        sortable: false
      }, {
        text: 'Mã hồ sơ',
        align: 'center',
        sortable: false
      }, {
        text: 'Chủ hồ sơ',
        align: 'center',
        sortable: false
      }, {
        text: 'Ngày nộp',
        align: 'center',
        sortable: false
      }, {
        text: 'Trạng thái',
        align: 'center',
        sortable: false
      }],
      validateTracuu: false,
      dialogCheckPass: false,
      dialogError: false,
      dossierDetail: '',
      valid: false,
      passCheck: '',
      validPass: true,
      activeDetailDossier: false,

      visible: false,
      layout: 'normal',
      input: null,
      options: {
        useKbEvents: true,
        preventClickEvent: false
      }
    };
  },
  computed: {
    filterDossierKey: function filterDossierKey() {
      return this.$store.getters.getFilterDossierKey;
    }
  },
  created: function created() {
    var vm = this;
    vm.$nextTick(function () {
      var vm = this;
      vm.$store.commit('setFullScreen', true);
      var current = vm.$router.history.current;
      var newQuery = current.query;
      vm.dossierNoKey = newQuery.hasOwnProperty('keyword') ? newQuery.keyword : '';
      vm.applicantIdNoKey = newQuery.hasOwnProperty('applicantIdNo') ? newQuery.applicantIdNo : '';
      if (!newQuery.hasOwnProperty('detail') && __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#dossierNoKey').val() === '') {
        var inputs = document.querySelectorAll('input');
        inputs[0].focus();
      }
      vm.hosoDatasPage = 1;
      if ((vm.dossierNoKey !== '' || vm.applicantIdNoKey !== '') && !newQuery.hasOwnProperty('detail') && !newQuery['detail']) {
        vm.validateTracuu = true;
        vm.doLoadingDataHoSo();
      } else {
        vm.validateTracuu = false;
      }
      if (newQuery.hasOwnProperty('detail') && newQuery['detail']) {
        vm.validateTracuu = true;
        vm.activeDetailDossier = true;
      } else {
        vm.activeDetailDossier = false;
      }
    });
  },

  watch: {
    '$route': function $route(newRoute, oldRoute) {
      var vm = this;
      var currentParams = newRoute.params;
      var currentQuery = newRoute.query;
      vm.dossierNoKey = currentQuery.hasOwnProperty('keyword') ? currentQuery.keyword : '';
      vm.applicantIdNoKey = currentQuery.hasOwnProperty('applicantIdNo') ? currentQuery.applicantIdNo : '';
      vm.hosoDatasPage = 1;
      if ((vm.dossierNoKey || vm.applicantIdNoKey) && !currentQuery.hasOwnProperty('detail') && !currentQuery['detail']) {
        vm.validateTracuu = true;
        vm.doLoadingDataHoSo();
      } else {
        vm.validateTracuu = false;
      }
      if (currentQuery.hasOwnProperty('detail') && currentQuery['detail']) {
        vm.validateTracuu = true;
        vm.activeDetailDossier = true;
      } else {
        vm.activeDetailDossier = false;
      }
      if (!currentQuery.hasOwnProperty('detail') && vm.dossierNoKey === '') {
        var inputs = document.querySelectorAll('input');
        inputs[0].focus();
      }
    }
  },
  methods: {
    filterDossier: function filterDossier() {
      var vm = this;
      vm.visible = false;
      var current = vm.$router.history.current;
      var newQuery = current.query;
      var queryString = '?';
      newQuery['keyword'] = vm.dossierNoKey;
      vm.$store.commit('setDossierNoSearch', vm.dossierNoKey);
      newQuery['applicantIdNo'] = vm.applicantIdNoKey;
      vm.$store.commit('setApplicantIdNoSearch', vm.applicantIdNoKey);
      newQuery['detail'] = '';
      for (var key in newQuery) {
        if (newQuery[key] !== '' && newQuery[key] !== 'undefined' && newQuery[key] !== undefined && newQuery[key] !== null) {
          queryString += key + '=' + newQuery[key] + '&';
        }
      }
      if (vm.dossierNoKey || vm.applicantIdNoKey) {
        vm.validateTracuu = true;
        vm.$router.push({
          path: current.path + queryString,
          query: {
            renew: Math.floor(Math.random() * (100 - 1 + 1)) + 1
          }
        });
      } else {
        vm.validateTracuu = false;
      }
    },
    confirmPass: function confirmPass() {
      var vm = this;
      var payload = {
        dossierNo: vm.dossierNoKey,
        applicantIdNo: vm.applicantIdNoKey,
        secretCode: vm.filterDossierKey.secretCode ? vm.filterDossierKey.secretCode : ''
      };
      vm.$store.commit('setFilterDossierKey', payload);
      if (vm.dossierNoKey || vm.applicantIdNoKey) {
        vm.validateTracuu = true;
        vm.$router.push({
          path: '/ma-truy-cap-ho-so',
          query: {
            target: 'tracuuhoso'
          }
        });
      } else {
        vm.validateTracuu = false;
      }
    },
    showMore: function showMore() {
      var vm = this;
      vm.hosoDatasPage += 1;
      vm.loadingTable = true;
      var currentQuery = vm.$router.history.current.query;
      var filter = null;
      filter = {
        page: vm.hosoDatasPage,
        dossierNo: currentQuery.hasOwnProperty('keyword') ? currentQuery.keyword : '',
        applicantName: currentQuery.hasOwnProperty('applicantName') ? currentQuery.applicantName : '',
        applicantIdNo: currentQuery.hasOwnProperty('applicantIdNo') ? currentQuery.applicantIdNo : ''
      };
      vm.$store.dispatch('loadingDataHoSo', filter).then(function (result) {
        vm.loadingTable = false;
        var dossierMore = result.data;
        vm.dossierList = vm.dossierList.concat(dossierMore);
      }).catch(function (reject) {
        vm.loadingTable = false;
      });
    },
    doLoadingDataHoSo: function doLoadingDataHoSo() {
      var vm = this;
      vm.dossierList = [];
      vm.loadingTable = true;
      var currentQuery = vm.$router.history.current.query;
      var filter = null;
      filter = {
        page: currentQuery.page ? currentQuery.page : 1,
        dossierNo: currentQuery.hasOwnProperty('keyword') ? currentQuery.keyword : '',
        applicantIdNo: currentQuery.hasOwnProperty('applicantIdNo') ? currentQuery.applicantIdNo : '',
        secretCode: vm.filterDossierKey.secretCode
      };
      vm.$store.dispatch('loadingDataHoSo', filter).then(function (result) {
        vm.hosoDatasPage = currentQuery.page ? currentQuery.page : 1;
        vm.loadingTable = false;
        if (result.data) {
          vm.dossierList = result.data;
          vm.dossierItemTotal = result.total;
          vm.totalPages = Number(result.total);
        } else {
          vm.dossierList = [];
          vm.dossierItemTotal = 0;
        }
      }).catch(function (reject) {
        vm.loadingTable = false;
        vm.dossierList = [];
        vm.totalPages = 0;
        vm.dossierItemTotal = 0;
      });
    },
    viewDetail: function viewDetail(item) {
      var vm = this;
      vm.dossierDetail = item;
      if (item.permission) {
        vm.$store.commit('setDossierDetail', item);
        var queryString = '?keyword=' + vm.dossierNoKey + '&applicantIdNo=' + vm.applicantIdNoKey + '&detail=true';
        vm.$router.push({
          path: '/tra-cuu-ho-so-homepage' + queryString
        });
      } else {
        vm.$store.commit('setDossierDetail', item);
        vm.$router.push({
          path: '/ma-truy-cap-ho-so',
          query: {
            target: 'chitiethoso'
          }
        });
      }
    },
    submitViewDetail: function submitViewDetail() {
      var vm = this;
      if (__WEBPACK_IMPORTED_MODULE_2_jquery___default()('#passCheck').val() !== '') {
        vm.validPass = true;
        vm.loading = true;
        var filter = {
          password: __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#passCheck').val(),
          dossierId: vm.dossierDetail.dossierId
        };
        vm.$store.dispatch('getDossierDetailPass', filter).then(function (result) {
          vm.loading = false;
          vm.dialogCheckPass = false;
          vm.clearDialog();
          if (result.status && result.status.toString() === '203') {
            vm.dialogError = true;
          } else if (result.status && result.status.toString() === '200') {
            __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/ho-so/' + vm.dossierDetail.dossierId);
          }
        }).catch(function (reject) {
          vm.dialogCheckPass = false;
          vm.visible = false;
          vm.loading = false;
          console.log('reject', reject);
        });
      } else {
        vm.validPass = false;
      }
    },
    paggingData: function paggingData(config) {
      var vm = this;
      var current = vm.$router.history.current;
      var newQuery = current.query;
      var queryString = '?';
      newQuery['page'] = '';
      for (var key in newQuery) {
        if (newQuery[key] !== '' && newQuery[key] !== 'undefined' && newQuery[key] !== undefined && newQuery[key] !== null && newQuery[key] !== 'null') {
          queryString += key + '=' + newQuery[key] + '&';
        }
      }
      queryString += 'page=' + config.page;
      vm.$router.push({
        path: current.path + queryString
      });
    },
    clearDialog: function clearDialog() {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#passCheck').val('');
      this.validPass = true;
      this.visible = false;
    },
    goBack: function goBack() {
      window.history.back();
    },
    clear: function clear(id) {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#' + id).val('');
    },
    accept: function accept(text) {
      this.hide();
    },
    show: function show(e) {
      this.validPass = true;
      this.input = e.target;
      if (!this.visible) {
        this.visible = true;
      }
      this.bindClick('search');
    },
    showKeyboard: function showKeyboard(e) {
      this.validPass = true;
      this.input = e.target;
      if (!this.visible) {
        this.visible = true;
      }
      this.bindClick('view');
    },
    hide: function hide() {
      this.visible = false;
    },
    next: function next() {
      var _this = this;

      var inputs = document.querySelectorAll('input');
      var found = false;
      var arr1 = [];
      arr1.forEach.call(inputs, function (item, i) {
        if (!found && item === _this.input && i < inputs.length - 1) {
          found = true;
          _this.$nextTick(function () {
            inputs[i + 1].focus();
          });
        }
      });
      if (!found) {
        this.input.blur();
        this.hide();
      }
    },
    bindClick: function bindClick(type) {
      var vm = this;
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.keyboard .line:nth-child(2) .key:last-child').unbind('click');
        if (type === 'search') {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.keyboard .line:nth-child(2) .key:last-child').bind('click', function () {
            vm.filterDossier();
          });
        } else if (type === 'view') {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.keyboard .line:nth-child(2) .key:last-child').bind('click', function () {
            vm.submitViewDetail();
          });
        }
      }, 300);
    }
  }
});

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_dist_vue_min_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_dist_vue_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_dist_vue_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pagination_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pagination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keyboard_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keyboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__keyboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ChiTietThuTuc_vue__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ChiTietThuTuc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ChiTietThuTuc_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: [],
  components: {
    'tiny-pagination': __WEBPACK_IMPORTED_MODULE_4__pagination_vue___default.a,
    'vue-touch-keyboard': __WEBPACK_IMPORTED_MODULE_5__keyboard_vue___default.a,
    'chi-tiet-thu-tuc': __WEBPACK_IMPORTED_MODULE_6__ChiTietThuTuc_vue___default.a
  },
  data: function data() {
    return {
      loading: false,
      loadingAction: false,
      serviceNameKey: '',
      listLinhVuc: [],
      linhVucSelected: '',
      listMucDo: [],
      levelSelected: '',
      listThuTuc: [],
      govAgencyList: [],
      govAgencySelected: {},
      groupIdSelected: '',
      serviceItemTotal: 0,
      pageListLinhVuc: 1,
      pageListThuTuc: 1,
      totalPaggingLinhVuc: 0,
      totalPaggingThuTuc: 0,
      serviceId: '',
      headersTable: [{
        text: 'STT',
        align: 'center',
        sortable: false
      }, {
        text: 'Tên thủ tục',
        align: 'center',
        sortable: false
      }, {
        text: 'Lĩnh vực',
        align: 'center',
        sortable: false
      }, {
        text: 'Mức độ',
        align: 'center',
        sortable: false
      }],
      showListThuTuc: false,

      visible: false,
      layout: 'normal',
      input: null,
      options: {
        useKbEvents: true,
        preventClickEvent: false
      }
    };
  },
  computed: {
    activeDetailService: function activeDetailService() {
      return this.$store.getters.getActiveDetailService;
    },
    groupIds: function groupIds() {
      return this.$store.getters.getGroupid;
    },
    groupIdArr: function groupIdArr() {
      console.log('groupIds', this.getGroupIdArr(this.groupIds));
      return this.getGroupIdArr(this.groupIds);
    },
    isMobile: function isMobile() {
      return this.$store.getters.getIsMobile;
    },
    fullScreen: function fullScreen() {
      return this.$store.getters.getFullScreen;
    }
  },
  created: function created() {
    var vm = this;
    vm.$nextTick(function () {
      var vm = this;
      vm.$store.commit('setFullScreen', false);
      var current = vm.$router.history.current;
      var newQuery = current.query;
      vm.loading = true;
      vm.listThuTuc = [];
      var groupIds = vm.groupIdArr.length;
      if (groupIds > 0) {
        var key;

        (function () {
          var count = 0;
          for (key = 0; key < groupIds; key++) {
            var filter = {
              groupId: vm.groupIdArr[key]
            };
            vm.$store.dispatch('getGovAgency', filter).then(function (result) {
              count += 1;
              result[0] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(result[0], { groupId: vm.groupIdArr[key] });
              vm.govAgencyList = vm.govAgencyList.concat(result);
              if (count === groupIds) {
                vm.loading = false;
                if (vm.govAgencyList.length > 0) {
                  vm.serviceNameKey = newQuery.hasOwnProperty('keyword') ? newQuery.keyword : '';
                  vm.levelSelected = newQuery.hasOwnProperty('level') ? Number(newQuery.level) : '';
                  vm.linhVucSelected = newQuery.hasOwnProperty('domain') ? newQuery.domain : '';
                  vm.govAgencySelected = newQuery.hasOwnProperty('administration') ? newQuery.administration : '';
                  __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#serviceNameKey').val(vm.serviceNameKey);
                  if (groupIds === 1) {
                    vm.govAgencySelected = vm.govAgencyList[0]['administrationCode'];
                    console.log('govAgencySelected', vm.govAgencySelected);
                  }
                  vm.filterGovagency();
                }
              }
            }).catch(function (reject) {
              if (count === groupIds) {
                vm.loading = false;
                if (vm.govAgencyList.length > 0) {
                  vm.serviceNameKey = newQuery.hasOwnProperty('keyword') ? newQuery.keyword : '';
                  vm.levelSelected = newQuery.hasOwnProperty('level') ? Number(newQuery.level) : '';
                  vm.linhVucSelected = newQuery.hasOwnProperty('domain') ? newQuery.domain : '';
                  vm.govAgencySelected = newQuery.hasOwnProperty('administration') ? newQuery.administration : '';
                  __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#serviceNameKey').val(vm.serviceNameKey);
                  if (groupIds === 1) {
                    vm.govAgencySelected = vm.govAgencyList[0]['administrationCode'];
                    console.log('govAgencySelected', vm.govAgencySelected);
                  }
                  vm.filterGovagency();
                }
              }
            });
          }
        })();
      } else {
        var filter = {
          groupId: ''
        };
        vm.$store.dispatch('getGovAgency', filter).then(function (result) {
          vm.govAgencyList = result;
          vm.loading = false;
          if (vm.govAgencyList.length > 0) {
            vm.serviceNameKey = newQuery.hasOwnProperty('keyword') ? newQuery.keyword : '';
            vm.levelSelected = newQuery.hasOwnProperty('level') ? Number(newQuery.level) : '';
            vm.linhVucSelected = newQuery.hasOwnProperty('domain') ? newQuery.domain : '';
            vm.govAgencySelected = newQuery.hasOwnProperty('administration') ? newQuery.administration : '';
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#serviceNameKey').val(vm.serviceNameKey);
            if (vm.govAgencyList.length === 1) {
              vm.govAgencySelected = vm.govAgencyList[0]['administrationCode'];
            }
            vm.filterGovagency();
          }
          if (vm.linhVucSelected || vm.serviceNameKey !== '') {
            vm.doLoadingThuTuc();
            vm.showListThuTuc = true;
          }
        }).catch(function (reject) {
          vm.loading = false;
        });
      }
    });
  },

  watch: {
    '$route': function $route(newRoute, oldRoute) {
      var vm = this;
      var currentParams = newRoute.params;
      var currentQuery = newRoute.query;
      vm.govAgencySelected = currentQuery.hasOwnProperty('administration') ? currentQuery.administration : '';
      vm.serviceNameKey = currentQuery.hasOwnProperty('keyword') ? currentQuery.keyword : '';
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#serviceNameKey').val(vm.serviceNameKey);
      vm.levelSelected = currentQuery.hasOwnProperty('level') ? Number(currentQuery.level) : '';
      vm.linhVucSelected = currentQuery.hasOwnProperty('domain') ? currentQuery.domain : '';
      if (vm.govAgencySelected && !vm.linhVucSelected) {
        vm.loading = true;
        var filter = {
          page: currentQuery.page ? currentQuery.page : 1,
          administrationCode: vm.govAgencySelected
        };
        vm.$store.dispatch('getDomainListsPublic', filter).then(function (result) {
          vm.loading = false;
          if (result.data) {
            vm.listLinhVuc = result.data;
            vm.totalPaggingLinhVuc = Number(result.total);
          } else {
            vm.listLinhVuc = [];
            vm.totalPaggingLinhVuc = 0;
          }
          vm.pageListLinhVuc = Number(currentQuery.page) ? Number(currentQuery.page) : 1;
        }).catch(function (reject) {
          vm.loading = false;
          vm.listLinhVuc = [];
          vm.totalPaggingLinhVuc = 0;
        });
      }
      if (vm.linhVucSelected || vm.serviceNameKey !== '') {
        vm.doLoadingThuTuc();
        vm.showListThuTuc = true;
      }
      if (currentQuery.hasOwnProperty('detail')) {
        vm.$store.commit('setActiveDetailService', true);
      } else {
        vm.$store.commit('setActiveDetailService', false);
      }
    }
  },
  methods: {
    filterServiceinfos: function filterServiceinfos(type) {
      var vm = this;
      vm.visible = false;
      if (type === 'keyword' && vm.serviceNameKey !== '') {
        vm.showListThuTuc = true;
      }
      var current = vm.$router.history.current;
      var newQuery = current.query;
      var queryString = '?';
      if (newQuery.hasOwnProperty('detail')) {
        newQuery['detail'] = '';
      }
      vm.serviceNameKey = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#serviceNameKey').val();
      newQuery['keyword'] = vm.serviceNameKey;
      newQuery['level'] = vm.levelSelected ? vm.levelSelected : '';
      newQuery['domain'] = vm.linhVucSelected ? vm.linhVucSelected : '';
      newQuery['administration'] = vm.govAgencySelected ? vm.govAgencySelected : '';
      newQuery['page'] = 1;
      for (var key in newQuery) {
        if (newQuery[key] !== '' && newQuery[key] !== 'undefined' && newQuery[key] !== undefined && newQuery[key] !== null) {
          queryString += key + '=' + newQuery[key] + '&';
        }
      }
      vm.$router.push({
        path: current.path + queryString,
        query: {
          renew: Math.floor(Math.random() * (100 - 1 + 1)) + 1
        }
      });
    },
    doLoadingThuTuc: function doLoadingThuTuc() {
      var vm = this;
      vm.listThuTuc = [];
      vm.loading = true;
      var currentQuery = __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].history.current.query;
      var filter = null;
      filter = {
        page: currentQuery.page ? currentQuery.page : 1,
        administration: currentQuery.hasOwnProperty('administration') ? currentQuery.administration : vm.govAgencySelected,
        keyword: currentQuery.hasOwnProperty('keyword') ? currentQuery.keyword : '',
        level: currentQuery.hasOwnProperty('level') ? currentQuery.level : vm.levelSelected,
        domain: currentQuery.hasOwnProperty('domain') ? currentQuery.domain : vm.linhVucSelected
      };
      vm.$store.dispatch('getServiceLists', filter).then(function (result) {
        vm.loading = false;
        if (result.data) {
          vm.listThuTuc = result.data;
          vm.pageListThuTuc = Number(currentQuery.page) ? Number(currentQuery.page) : 1;
          vm.totalPaggingThuTuc = result.total;
        } else {
          vm.totalPaggingThuTuc = 0;
          vm.listThuTuc = [];
        }
        vm.serviceItemTotal = result.total;
      }).catch(function (reject) {
        vm.loading = false;
        vm.listThuTuc = [];
        vm.totalPaggingThuTuc = 0;
        vm.serviceItemTotal = 0;
      });
    },
    filterGovagency: function filterGovagency() {
      var vm = this;
      var current = vm.$router.history.current;
      var newQuery = current.query;
      if (vm.govAgencySelected) {
        vm.loading = true;
        var filter = {
          page: newQuery.page ? newQuery.page : 1,
          administrationCode: vm.govAgencySelected
        };
        vm.$store.dispatch('getDomainListsPublic', filter).then(function (result) {
          vm.loading = false;
          if (result.data) {
            vm.listLinhVuc = result.data;
            vm.totalPaggingLinhVuc = Number(result.total);
            if (vm.listLinhVuc.length === 1) {
              vm.linhVucSelected = vm.listLinhVuc[0].domainCode;
              vm.changeDomain();
            }
          } else {
            vm.listLinhVuc = [];
            vm.totalPaggingLinhVuc = 0;
          }
          vm.pageListLinhVuc = Number(newQuery.page) ? Number(newQuery.page) : 1;
          if (vm.govAgencySelected && vm.linhVucSelected) {
            vm.doLoadingThuTuc();
          }
        }).catch(function (reject) {
          vm.listLinhVuc = [];
          vm.totalPaggingLinhVuc = 0;
          vm.loading = false;
        });
      }
    },
    changeAdministration: function changeAdministration() {
      var vm = this;
      console.log('vm.groupIdSelected', vm.govAgencyList, vm.govAgencySelected);
      vm.groupIdSelected = vm.govAgencyList.filter(function (item) {
        return item['administrationCode'] === vm.govAgencySelected;
      })[0]['groupId'];
      console.log('vm.groupIdSelected', vm.groupIdSelected);
      vm.showListThuTuc = false;
      vm.listLinhVuc = [];
      vm.linhVucSelected = '';
      vm.levelSelected = '';
      vm.visible = false;
      var current = vm.$router.history.current;
      var newQuery = {
        administration: ''
      };
      var queryString = '?';
      setTimeout(function () {
        newQuery['administration'] = vm.govAgencySelected ? vm.govAgencySelected : '';
        for (var key in newQuery) {
          if (newQuery[key] !== '' && newQuery[key] !== 'undefined' && newQuery[key] !== undefined && newQuery[key] !== null) {
            queryString += key + '=' + newQuery[key] + '&';
          }
        }
        vm.$router.push({
          path: current.path + queryString,
          query: {
            renew: Math.floor(Math.random() * (100 - 1 + 1)) + 1
          }
        });
      }, 200);
    },
    filterAdministration: function filterAdministration(item) {
      var vm = this;
      vm.govAgencySelected = item.administrationCode;
      vm.changeAdministration();
    },
    changeDomain: function changeDomain() {
      var vm = this;
      vm.showListThuTuc = true;
      setTimeout(function () {
        if (vm.linhVucSelected) {
          vm.filterServiceinfos();
        }
      }, 200);
    },
    filterDomain: function filterDomain(item) {
      var vm = this;
      vm.linhVucSelected = item.domainCode;
      vm.changeDomain();
    },
    changeLevel: function changeLevel() {
      var vm = this;
      setTimeout(function () {
        vm.filterServiceinfos();
      }, 200);
    },
    viewDetail: function viewDetail(item) {
      var vm = this;
      vm.serviceId = item.serviceInfoId;
      var current = vm.$router.history.current;
      var newQuery = current.query;
      var queryString = '?';
      if (newQuery.hasOwnProperty('detail')) {
        newQuery['detail'] = '';
      }
      for (var key in newQuery) {
        if (newQuery[key] !== '' && newQuery[key] !== 'undefined' && newQuery[key] !== undefined && newQuery[key] !== null) {
          queryString += key + '=' + newQuery[key] + '&';
        }
      }
      queryString += '&detail=true';
      vm.$router.push({
        path: current.path + queryString
      });
    },
    getGroupIdArr: function getGroupIdArr(groupIds) {
      if (groupIds) {
        return groupIds.split(',');
      } else {
        return [];
      }
    },
    paggingData: function paggingData(config) {
      var vm = this;
      var current = vm.$router.history.current;
      var newQuery = current.query;
      var queryString = '?';
      newQuery['page'] = '';

      for (var key in newQuery) {
        if (newQuery[key] !== '' && newQuery[key] !== 'undefined' && newQuery[key] !== undefined && newQuery[key] !== null && newQuery[key] !== 'null') {
          queryString += key + '=' + newQuery[key] + '&';
        }
      }
      queryString += 'page=' + config.page;
      vm.$router.push({
        path: current.path + queryString
      });
    },
    getColor: function getColor(level) {
      if (level === 2) {
        return 'green';
      } else if (level === 3) {
        return 'orange darken-1';
      } else if (level === 4) {
        return 'red';
      }
    },
    govAgencyName: function govAgencyName(arg) {
      var vm = this;
      if (arg) {
        var value = vm.govAgencyList.filter(function (item) {
          return item.administrationCode.toString() === arg.toString();
        });
        if (value.length > 0) {
          return value[0].administrationName;
        }
      } else {
        return '';
      }
    },
    changeScreen: function changeScreen() {
      var vm = this;
      vm.$store.commit('setFullScreen', !vm.fullScreen);
    },
    show: function show(e) {
      this.validPass = true;
      this.input = e.target;
      if (!this.visible) {
        this.visible = true;
      }
      this.bindClick('search');
    },
    bindClick: function bindClick(type) {
      var vm = this;
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.keyboard .enter').unbind('click');
        if (type === 'search') {
          __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.keyboard .enter').bind('click', function () {
            vm.filterServiceinfos('keyword');
          });
        } else if (type === 'view') {
          __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.keyboard .enter').bind('click', function () {
            vm.submitViewDetail();
          });
        }
      }, 300);
    }
  }
});

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isObject__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isObject__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    input: HTMLInputElement,
    layout: [String, Object],
    accept: Function,
    cancel: Function,
    change: Function,
    next: Function,
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      currentKeySet: 'default',
      inputScrollLeft: 0,
      Layouts: {
        'normal': {
          _meta: {
            'tab': { key: '\t', text: 'Tab', width: 60, classes: 'control' },
            'shiftl': { keySet: 'shifted', text: '123#%', width: 100, classes: 'control' },
            'shiftr': { keySet: 'default', text: 'abc', width: 100, classes: 'control' },
            'caps': { keySet: 'capsed', text: 'ABC', width: 100, classes: 'control' },
            'space': { key: ' ', text: 'Space', width: 100 },
            'enter': { key: '\r\n', text: 'Enter', width: 80, classes: 'control enter' },
            'backspace': { func: 'backspace', text: '&#8592;  Xóa', classes: 'control backspace', width: 65 },
            'accept': { func: 'accept', text: 'Close', classes: 'control featured', width: 30 },
            'next': { func: 'next', text: 'Next', classes: 'control featured' },
            'emty': { key: '', text: '', width: 60, classes: 'control emty' }
          },

          default: ['1 2 3 4 5 6 7 8 9 0 - [ ]', 'q w e r t y u i o p _ {backspace}', 'a s d f g h j k l : ; {enter}', 'z x c v b n m , . {caps} {shiftl}', '{next} {space} {accept}'],
          shifted: ['1 2 3 4 5 6 7 8 9 0 {backspace}', '! @ # $ % & * ( ) ? {enter}', '- / : ; _ < > | + = {shiftr}', '{next} {space} {accept}'],
          capsed: ['Q W E R T Y U I O P {backspace}', 'A S D F G H J K L : ; {enter}', 'Z X C V B N M , . {shiftr} {shiftl}', '{next} {space} {accept}']
        },
        'compact': {
          _meta: {
            'default': { keySet: 'default', text: 'abc', classes: 'control' },
            'alpha': { keySet: 'default', text: 'Abc', classes: 'control' },
            'shift': { keySet: 'shifted', text: 'ABC', classes: 'control' },
            'numbers': { keySet: 'numbers', text: '123', classes: 'control' },
            'space': { key: ' ', text: 'Space', width: 200 },
            'backspace': { func: 'backspace', classes: 'control' },
            'accept': { func: 'accept', text: 'Close', classes: 'control featured' },
            'next': { func: 'next', text: 'Next', classes: 'featured' },
            'zero': { key: '0', width: 130 }
          },

          default: ['q w e r t y u i o p', ' a s d f g h j k l ', '{shift} z x c v b n m {backspace}', '{numbers} , {space} . {next} {accept}'],

          shifted: ['Q W E R T Y U I O P', ' A S D F G H J K L ', '{default} Z X C V B N M ', '{numbers} _ {space} {backspace} {next} {accept}'],

          numbers: ['1 2 3', '4 5 6', '7 8 9', '  {alpha} . {zero} {backspace} {next} {accept}']
        },
        'numeric': {

          _meta: {
            'backspace': { func: 'backspace', classes: 'control' },
            'accept': { func: 'accept', text: 'Close', classes: 'control featured' },
            'next': { func: 'next', text: 'Next', classes: 'control featured' },
            'zero': { key: '0', width: 130 }
          },

          default: ['1 2 3', '4 5 6', '7 8 9', '_ - . {zero} {backspace} {next} {accept}']
        }
      }
    };
  },

  computed: {
    keySet: function keySet() {
      var layout = this.getLayout();
      if (!layout) return;
      var keySet = layout[this.currentKeySet];
      if (!keySet) return;
      var res = [];
      var meta = layout['_meta'] || {};
      keySet.forEach(function (line) {
        var row = [];
        line.split(' ').forEach(function (item) {
          if (__WEBPACK_IMPORTED_MODULE_2_lodash_isObject___default()(item)) {
            row.push(item);
          } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isString___default()(item)) {
            if (item.length > 2 && item[0] === '{' && item[item.length - 1] === '}') {
              var name = item.substring(1, item.length - 1);
              if (meta[name]) row.push(meta[name]);else console.warn('Missing named key from meta: ' + name);
            } else {
              if (item === '') {
                row.push({
                  placeholder: true
                });
              } else {
                row.push({
                  key: item,
                  text: item
                });
              }
            }
          }
        });
        res.push(row);
      });
      return res;
    }
  },
  watch: {
    layout: function layout() {
      console.log('Layout changed');
      this.currentKeySet = 'default';
    }
  },
  methods: {
    getLayout: function getLayout() {
      if (__WEBPACK_IMPORTED_MODULE_1_lodash_isString___default()(this.layout)) {
        return this.Layouts[this.layout];
      }
      return this.layout;
    },
    changeKeySet: function changeKeySet(name) {
      var layout = this.getLayout();
      if (layout[name] != null) {
        this.currentKeySet = name;
      }
    },
    toggleKeySet: function toggleKeySet(name) {
      this.currentKeySet = this.currentKeySet === name ? 'default' : name;
    },
    getCaptionOfKey: function getCaptionOfKey(key) {
      return key.text || key.key || '';
    },
    getClassesOfKey: function getClassesOfKey(key) {
      if (key.placeholder) {
        return 'placeholder';
      } else {
        var classes = 'key ' + (key.func || '') + ' ' + (key.classes || '');
        if (key.keySet && this.currentKeySet === key.keySet) {
          classes += ' activated';
        }
        return classes;
      }
    },
    getKeyStyle: function getKeyStyle(key) {
      if (key.width) {
        return {
          flex: key.width
        };
      }
    },
    supportsSelection: function supportsSelection() {
      return (/text|password|search|tel|url/.test(this.input.type)
      );
    },
    getCaret: function getCaret() {
      if (this.supportsSelection()) {
        var pos = {
          start: this.input.selectionStart || 0,
          end: this.input.selectionEnd || 0
        };
        if (pos.end < pos.start) pos.end = pos.start;
        return pos;
      } else {
        var val = this.input.value;
        return {
          start: val.length,
          end: val.length
        };
      }
    },
    backspace: function backspace(caret, text) {
      text = text.substring(0, caret.start - 1) + text.substring(caret.start);
      caret.start -= 1;
      caret.end = caret.start;
      return text;
    },
    insertChar: function insertChar(caret, text, ch) {
      text = text.substr(0, caret.start) + ch.toString() + text.substr(caret.start);
      caret.start += ch.length;
      caret.end = caret.start;
      return text;
    },
    mousedown: function mousedown(e) {
      if (!this.input) return;
      if (this.options.preventClickEvent) e.preventDefault();
      this.inputScrollLeft = this.input.scrollLeft;
    },
    clickKey: function clickKey(e, key) {
      if (!this.input) return;
      if (this.options.preventClickEvent) e.preventDefault();
      var caret = this.getCaret();
      var text = this.input.value;
      var addChar = null;
      if ((typeof key === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(key)) === 'object') {
        if (key.keySet) {
          this.toggleKeySet(key.keySet);
        } else if (key.func) {
          switch (key.func) {
            case 'backspace':
              {
                text = this.backspace(caret, text);
                break;
              }
            case 'accept':
              {
                if (this.accept) this.cancel();
                return;
              }
            case 'cancel':
              {
                if (this.cancel) this.cancel();
                return;
              }
            case 'next':
              {
                if (this.next) this.next();
                return;
              }
          }
        } else {
          addChar = key.key;
        }
      } else {
        addChar = key;
      }
      if (addChar) {
        if (this.input.maxLength <= 0 || text.length < this.input.maxLength) {
          if (this.options.useKbEvents) {
            var _e = document.createEvent('Event');
            _e.initEvent('keydown', true, true);
            _e.which = _e.keyCode = addChar.charCodeAt();
            if (this.input.dispatchEvent(_e)) {
              text = this.insertChar(caret, text, addChar);
            }
          } else {
            text = this.insertChar(caret, text, addChar);
          }
        }
      }
      this.input.value = text;
      this.setFocusToInput(caret);
      if (this.change) {
        this.change(text, addChar);
      }
      if (this.input.maxLength > 0 && text.length >= this.input.maxLength) {
        if (this.next) this.next();
      }
    },
    setFocusToInput: function setFocusToInput(caret) {
      this.input.focus();
      if (caret && this.supportsSelection()) {
        this.input.selectionStart = caret.start;
        this.input.selectionEnd = caret.end;
      }
    },
    closeKeyboard: function closeKeyboard() {
      this.cancel();
    }
  },
  mounted: function mounted() {
    if (this.input) {
      this.setFocusToInput();
    }
  }
});

/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var COMPONENT_NAME = 'TinyPagination';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: COMPONENT_NAME,
  props: {
    total: {
      type: Number,
      required: true
    },
    page: {
      type: Number,
      default: 1
    },
    lang: {
      type: String,
      default: 'en'
    },
    customClass: {
      type: String
    },
    limits: {
      type: Array,
      default: function _default() {
        return [10, 15, 20, 50, 100];
      }
    },
    showLimit: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      version: '0.2.1',
      currentPage: 1,
      currentLimit: 15,
      translations: {
        en: {
          prev: 'Previous',
          title: 'Page',
          next: 'Next'
        }
      },
      availableLanguages: ['en']
    };
  },
  created: function created() {
    this.currentPage = this.page;
  },

  watch: {
    page: function page(val) {
      this.currentPage = parseInt(val);
    }
  },
  computed: {
    translation: function translation() {
      return this.availableLanguages.includes(this.lang) ? this.translations[this.lang] : this.translations['en'];
    },
    totalPages: function totalPages() {
      return Math.ceil(this.total / this.currentLimit);
    },
    totalPagesData: function totalPagesData() {
      var totalDatas = [];
      var data = {};
      for (var index = 1; index <= this.totalPages; ++index) {
        data = {
          value: index,
          text: 'Trang ' + index
        };
        totalDatas.push(data);
      }
      return totalDatas;
    },
    titlePage: function titlePage() {
      return '' + this.currentPage;
    },
    classFirstPage: function classFirstPage() {
      return {
        'c-not-allowed pagination__navigation--disabled': this.currentPage === 1
      };
    },
    classLastPage: function classLastPage() {
      return {
        'c-not-allowed pagination__navigation--disabled': this.currentPage === this.totalPages
      };
    }
  },
  methods: {
    nextPage: function nextPage() {
      if (this.currentPage !== this.totalPages) {
        this.currentPage += 1;
        this.$emit('tiny:change-page', {
          page: this.currentPage
        });
      }
    },
    lastPage: function lastPage() {
      if (this.currentPage > 1) {
        this.currentPage -= 1;
        this.$emit('tiny:change-page', {
          page: this.currentPage
        });
      }
    },
    nextPageLast: function nextPageLast() {
      this.currentPage = this.totalPages;
      this.$emit('tiny:change-page', {
        page: this.totalPages
      });
    },
    lastPageLast: function lastPageLast() {
      this.currentPage = 1;
      this.$emit('tiny:change-page', {
        page: 1
      });
    },
    goToPage: function goToPage() {
      this.$emit('tiny:change-page', {
        page: this.currentPage
      });
    },
    onLimitChange: function onLimitChange() {
      this.currentPage = 1;
    }
  }
});

/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var COMPONENT_NAME = 'TinyPagination';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: COMPONENT_NAME,
  props: {
    total: {
      type: Number,
      required: true
    },
    page: {
      type: Number,
      default: 1
    },
    lang: {
      type: String,
      default: 'en'
    },
    customClass: {
      type: String
    },
    limits: {
      type: Array,
      default: function _default() {
        return [10, 15, 20, 50, 100];
      }
    },
    showLimit: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      version: '0.2.1',
      currentPage: 1,
      currentLimit: 10,
      translations: {
        en: {
          prev: 'Previous',
          title: 'Page',
          next: 'Next'
        }
      },
      availableLanguages: ['en']
    };
  },
  created: function created() {
    this.currentPage = this.page;
  },

  watch: {
    page: function page(val) {
      this.currentPage = parseInt(val);
    }
  },
  computed: {
    translation: function translation() {
      return this.availableLanguages.includes(this.lang) ? this.translations[this.lang] : this.translations['en'];
    },
    totalPages: function totalPages() {
      return Math.ceil(this.total / this.currentLimit);
    },
    totalPagesData: function totalPagesData() {
      var totalDatas = [];
      var data = {};
      for (var index = 1; index <= this.totalPages; ++index) {
        data = {
          value: index,
          text: 'Trang ' + index
        };
        totalDatas.push(data);
      }
      return totalDatas;
    },
    titlePage: function titlePage() {
      return '' + this.currentPage;
    },
    classFirstPage: function classFirstPage() {
      return {
        'c-not-allowed pagination__navigation--disabled': this.currentPage === 1
      };
    },
    classLastPage: function classLastPage() {
      return {
        'c-not-allowed pagination__navigation--disabled': this.currentPage === this.totalPages
      };
    }
  },
  methods: {
    nextPage: function nextPage() {
      if (this.currentPage !== this.totalPages) {
        this.currentPage += 1;
        this.$emit('tiny:change-page', {
          page: this.currentPage
        });
      }
    },
    lastPage: function lastPage() {
      if (this.currentPage > 1) {
        this.currentPage -= 1;
        this.$emit('tiny:change-page', {
          page: this.currentPage
        });
      }
    },
    nextPageLast: function nextPageLast() {
      this.currentPage = this.totalPages;
      this.$emit('tiny:change-page', {
        page: this.totalPages
      });
    },
    lastPageLast: function lastPageLast() {
      this.currentPage = 1;
      this.$emit('tiny:change-page', {
        page: 1
      });
    },
    goToPage: function goToPage() {
      this.$emit('tiny:change-page', {
        page: this.currentPage
      });
    },
    onLimitChange: function onLimitChange() {
      this.currentPage = 1;
    }
  }
});

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(527),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "D:\\FDS\\frontend-opencps-v2.1\\onegate_21_kios_bng\\src\\components\\keyboard.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] keyboard.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3e11bc78", Component.options)
  } else {
    hotAPI.reload("data-v-3e11bc78", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 493:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(529),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "D:\\FDS\\frontend-opencps-v2.1\\onegate_21_kios_bng\\src\\components\\CheckPassword.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CheckPassword.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5770123c", Component.options)
  } else {
    hotAPI.reload("data-v-5770123c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(520),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "D:\\FDS\\frontend-opencps-v2.1\\onegate_21_kios_bng\\src\\components\\CheckPasswordHP.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CheckPasswordHP.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0c4c516a", Component.options)
  } else {
    hotAPI.reload("data-v-0c4c516a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(530),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "D:\\FDS\\frontend-opencps-v2.1\\onegate_21_kios_bng\\src\\components\\ChiTietDanhGiaCLDV.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ChiTietDanhGiaCLDV.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-632aa9ac", Component.options)
  } else {
    hotAPI.reload("data-v-632aa9ac", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(539),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "D:\\FDS\\frontend-opencps-v2.1\\onegate_21_kios_bng\\src\\components\\ChiTietHoSoQR.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ChiTietHoSoQR.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ba460eea", Component.options)
  } else {
    hotAPI.reload("data-v-ba460eea", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(523),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "D:\\FDS\\frontend-opencps-v2.1\\onegate_21_kios_bng\\src\\components\\DanhGiaCanBo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DanhGiaCanBo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1d4a4106", Component.options)
  } else {
    hotAPI.reload("data-v-1d4a4106", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(526),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "D:\\FDS\\frontend-opencps-v2.1\\onegate_21_kios_bng\\src\\components\\DanhGiaChatLuongDichVu.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DanhGiaChatLuongDichVu.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2db7bcb9", Component.options)
  } else {
    hotAPI.reload("data-v-2db7bcb9", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(522),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "D:\\FDS\\frontend-opencps-v2.1\\onegate_21_kios_bng\\src\\components\\DanhSachCanBo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DanhSachCanBo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1cc2d6b2", Component.options)
  } else {
    hotAPI.reload("data-v-1cc2d6b2", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(525),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "D:\\FDS\\frontend-opencps-v2.1\\onegate_21_kios_bng\\src\\components\\HoSoKetQua.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] HoSoKetQua.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2ce8ac97", Component.options)
  } else {
    hotAPI.reload("data-v-2ce8ac97", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(531),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "D:\\FDS\\frontend-opencps-v2.1\\onegate_21_kios_bng\\src\\components\\HoSoTiepNhan.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] HoSoTiepNhan.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-709cea0a", Component.options)
  } else {
    hotAPI.reload("data-v-709cea0a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(538),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "D:\\FDS\\frontend-opencps-v2.1\\onegate_21_kios_bng\\src\\components\\Landing.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Landing.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b8c38714", Component.options)
  } else {
    hotAPI.reload("data-v-b8c38714", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(533),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "D:\\FDS\\frontend-opencps-v2.1\\onegate_21_kios_bng\\src\\components\\Pagination1.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Pagination1.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7907e2b6", Component.options)
  } else {
    hotAPI.reload("data-v-7907e2b6", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(528),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "D:\\FDS\\frontend-opencps-v2.1\\onegate_21_kios_bng\\src\\components\\TraCuuHoSo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TraCuuHoSo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4aca7818", Component.options)
  } else {
    hotAPI.reload("data-v-4aca7818", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(524),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "D:\\FDS\\frontend-opencps-v2.1\\onegate_21_kios_bng\\src\\components\\TraCuuHomePage.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TraCuuHomePage.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-28f0c43f", Component.options)
  } else {
    hotAPI.reload("data-v-28f0c43f", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(536),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "D:\\FDS\\frontend-opencps-v2.1\\onegate_21_kios_bng\\src\\components\\TraCuuThuTuc.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TraCuuThuTuc.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-97b0229c", Component.options)
  } else {
    hotAPI.reload("data-v-97b0229c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-0"
  }, [_c('v-card', {
    staticStyle: {
      "min-height": "100vh"
    }
  }, [_c('h2', {
    staticClass: "pt-2 mx-2 text-xs-center"
  }, [_c('span', {
    staticStyle: {
      "color": "#065694"
    }
  }, [_vm._v("XÁC THỰC TRA CỨU THÔNG TIN HỒ SƠ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "d-inline-block mt-4",
    staticStyle: {
      "width": "100%",
      "max-width": "700px"
    }
  }, [_c('v-flex', {
    staticClass: "px-2 pb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "px-3 py-3",
    staticStyle: {
      "max-width": "700px",
      "margin": "0 auto",
      "border": "1px solid #dddddd"
    },
    attrs: {
      "color": "#002c46b3",
      "flat": ""
    }
  }, [_c('v-form', {
    ref: "form",
    staticClass: "mt-2",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "solo": "",
      "placeholder": "Mã tra cứu",
      "prepend-inner-icon": "vpn_key",
      "height": "42",
      "rules": [function (v) { return !!v || 'Mã tra cứu là bắt buộc'; }],
      "required": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitPass($event)
      }
    },
    model: {
      value: (_vm.secretKey),
      callback: function($$v) {
        _vm.secretKey = $$v
      },
      expression: "secretKey"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "text-xs-left",
    attrs: {
      "wrap": "",
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "flex white--text",
    staticStyle: {
      "width": "calc(100% - 30px)"
    }
  }, [_vm._v("Mã tra cứu là dãy số gồm 4 ký tự được in trên giấy tiếp nhận hồ sơ và hẹn trả kết quả, mail thông báo tiếp nhận hồ sơ.")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-left text-xs-center mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ml-0 mr-1 my-0 white--text",
    attrs: {
      "color": "#0b72ba",
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.submitPass
    }
  }, [_c('v-icon', [_vm._v("search")]), _vm._v(" \n                  Tra cứu\n                ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-1 my-0 white--text",
    attrs: {
      "color": "#0b72ba",
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('v-icon', [_vm._v("reply")]), _vm._v(" \n                  Quay lại\n                ")], 1)], 1)], 1)], 1)], 1)], 1)])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "290"
    },
    model: {
      value: (_vm.dialogError),
      callback: function($$v) {
        _vm.dialogError = $$v
      },
      expression: "dialogError"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Bạn không có quyền truy cập hồ sơ \n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogError = false
      }
    }
  }, [_vm._v("Đồng ý")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0c4c516a", module.exports)
  }
}

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', {
    staticClass: "text-xs-center pt-4"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": "100",
      "width": "5",
      "color": "purple",
      "indeterminate": ""
    }
  })], 1) : _c('div', {
    staticClass: "px-2 pt-2",
    staticStyle: {
      "height": "100%",
      "background-color": "#ffff"
    }
  }, [_c('v-form', {
    ref: "formVoting",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.validFormVoting),
      callback: function($$v) {
        _vm.validFormVoting = $$v
      },
      expression: "validFormVoting"
    }
  }, [_c('v-container', {
    attrs: {
      "align-center": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg10": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-1",
    staticStyle: {
      "text-align": "center!important",
      "max-height": "200px"
    },
    attrs: {
      "xs4": "",
      "sm3": ""
    }
  }, [(_vm.employeeSelected['imgSrc']) ? _c('div', {
    staticClass: "mt-1",
    staticStyle: {
      "width": "100%",
      "max-width": "150px",
      "height": "200px",
      "margin": "0 auto",
      "background-position": "center",
      "background-size": "cover"
    },
    style: ('background-image: url(' + _vm.employeeSelected['imgSrc'] + ');')
  }) : _c('img', {
    staticStyle: {
      "width": "100%",
      "max-width": "150px",
      "height": "200px",
      "object-fit": "contain",
      "opacity": "0.6",
      "background": "#ddd"
    },
    attrs: {
      "src": "/o/opencps-store/js/kios_bng/img/avatar_contacts.png"
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-2",
    staticStyle: {
      "word-wrap": "break-word",
      "position": "relative"
    },
    attrs: {
      "xs8": "",
      "sm9": ""
    }
  }, [_c('div', {
    staticClass: "text-bold primary--text",
    staticStyle: {
      "font-size": "1.5em"
    }
  }, [_vm._v(_vm._s(_vm.employeeSelected.fullName))]), _vm._v(" "), (_vm.employeeSelected.jobPosTitle || _vm.employeeSelected.workingUnitName) ? _c('div', {
    staticClass: "primary--text"
  }, [_vm._v("\n                  " + _vm._s(_vm.employeeSelected.jobPosTitle) + " - " + _vm._s(_vm.employeeSelected.workingUnitName) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [_vm._v("Email: " + _vm._s(_vm.employeeSelected.email))]), _vm._v(" "), _c('div', {
    style: (_vm.isMobile ? '' : 'position:absolute;top:0;right:0')
  }, [_c('star-rating', {
    attrs: {
      "read-only": "",
      "rating": _vm.employeeSelected['score'],
      "increment": 0.1,
      "max-rating": 5,
      "show-rating": false,
      "star-size": 30,
      "title": _vm.employeeSelected['score'] + '/5*'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-bold primary--text pl-2"
  }, [_vm._v(_vm._s(_vm.employeeSelected['totalVoting']) + " lượt đánh giá")])], 1), _vm._v(" "), (!_vm.isMobile) ? _c('div', _vm._l((_vm.votingItems), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "text-bold primary--text"
    }, [_vm._v("* " + _vm._s(item.subject))]), _vm._v(" "), _c('div', {
      staticClass: "ml-3"
    }, [_c('v-radio-group', {
      staticClass: "py-0",
      attrs: {
        "height": "10",
        "row": ""
      },
      model: {
        value: (item.selected),
        callback: function($$v) {
          _vm.$set(item, "selected", $$v)
        },
        expression: "item.selected"
      }
    }, _vm._l((item['choices']), function(itemChoise, indexChoise) {
      return _c('v-radio', {
        key: 'rd' + indexChoise,
        attrs: {
          "height": "10",
          "value": indexChoise + 1
        }
      }, [_c('div', {
        class: item.selected === indexChoise + 1 ? 'primary--text' : 'black--text',
        attrs: {
          "slot": "label"
        },
        slot: "label"
      }, [_vm._v(_vm._s(itemChoise))])])
    }), 1)], 1)])
  }), 0) : _vm._e()])], 1), _vm._v(" "), (_vm.isMobile) ? _c('div', _vm._l((_vm.votingItems), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "px-2 mt-3"
    }, [_c('div', {
      staticClass: "text-bold primary--text"
    }, [_vm._v(_vm._s(index + 1) + ". " + _vm._s(item.subject))]), _vm._v(" "), _c('div', {
      staticClass: "ml-3"
    }, [_c('v-radio-group', {
      attrs: {
        "height": "10",
        "row": ""
      },
      model: {
        value: (item.selected),
        callback: function($$v) {
          _vm.$set(item, "selected", $$v)
        },
        expression: "item.selected"
      }
    }, _vm._l((item['choices']), function(itemChoise, indexChoise) {
      return _c('v-radio', {
        key: 'rd' + indexChoise,
        attrs: {
          "label": itemChoise,
          "height": "10",
          "value": indexChoise + 1
        }
      })
    }), 1)], 1)])
  }), 0) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center my-3",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [(Array.isArray(_vm.votingItems) && _vm.votingItems.length > 0) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.votingDialog_hidden_loading,
      "disabled": _vm.votingDialog_hidden_loading
    },
    on: {
      "click": _vm.submitResultVoting
    }
  }, [_vm._v("\n          Gửi đánh giá\n        ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("reply")]), _vm._v(" \n          Quay lại \n        ")], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.dialogShowApplicantIdNo),
      callback: function($$v) {
        _vm.dialogShowApplicantIdNo = $$v
      },
      expression: "dialogShowApplicantIdNo"
    }
  }, [_c('v-form', {
    ref: "formVoting",
    staticClass: "dialog-submit-voting",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.validFormVoting),
      callback: function($$v) {
        _vm.validFormVoting = $$v
      },
      expression: "validFormVoting"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "flat": "",
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', [_vm._v("Nhập số CMND, mã hồ sơ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogShowApplicantIdNo = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "input-custom"
  }, [_c('input', {
    attrs: {
      "id": "applicantIdNo",
      "type": "text",
      "required": "required"
    },
    on: {
      "focus": _vm.show
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "applicantIdNo"
    }
  }, [_vm._v("Số CMND/ Hộ chiếu")])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "input-custom"
  }, [_c('input', {
    attrs: {
      "id": "dossierNo",
      "type": "text",
      "required": "required"
    },
    on: {
      "focus": _vm.show
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "dossierNo"
    }
  }, [_vm._v("Mã hồ sơ")])])])], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doVottingSubmit($event)
      }
    }
  }, [_vm._v("Đồng ý")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return (function () { return _vm.dialogShowApplicantIdNo = false; })($event)
      }
    }
  }, [_vm._v("Quay lại")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isMobile) ? _c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "fab": "",
      "color": "primary"
    },
    on: {
      "click": _vm.changeScreen
    }
  }, [(!_vm.fullScreen) ? _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fullscreen")]) : _vm._e(), _vm._v(" "), (_vm.fullScreen) ? _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fullscreen_exit")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.visible && !_vm.isMobile) ? _c('div', {
    staticClass: "virtual-keyboard"
  }, [_c('v-btn', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "0"
    },
    attrs: {
      "small": "",
      "fab": "",
      "color": "#383533"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#fff"
    }
  }, [_vm._v("clear")])], 1), _vm._v(" "), (_vm.visible) ? _c('vue-touch-keyboard', {
    attrs: {
      "layout": _vm.layout,
      "cancel": _vm.hide,
      "accept": _vm.accept,
      "input": _vm.input,
      "next": _vm.next,
      "options": _vm.options
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-16bb497c", module.exports)
  }
}

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "pb-3",
    attrs: {
      "flat": ""
    }
  }, [_c('h3', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "color": "#065694"
    }
  }, [_vm._v("ĐÁNH GIÁ CÁN BỘ")]), _vm._v(" "), (_vm.agencyName) ? _c('h3', {
    staticClass: "text-xs-center pb-2",
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(_vm._s(_vm.agencyName))]) : _vm._e(), _vm._v(" "), (_vm.employeeItems.length > 0) ? _c('div', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.employeeItems), function(employee) {
    return _c('v-flex', {
      key: employee.employeeId,
      staticClass: "px-2 py-2",
      attrs: {
        "xs12": "",
        "sm6": "",
        "md4": "",
        "lg3": ""
      }
    }, [_c('v-card', {
      staticStyle: {
        "box-shadow": "none"
      },
      attrs: {
        "flat": "",
        "hover": "",
        "color": "#1a571b21"
      }
    }, [_c('v-card-text', {
      staticClass: "py-2 px-1",
      staticStyle: {
        "overflow": "hidden"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.viewDetailEmployee(employee)
        }
      }
    }, [_c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticStyle: {
        "text-align": "center!important"
      },
      attrs: {
        "xs4": ""
      }
    }, [(employee['imgSrc']) ? _c('div', {
      staticClass: "mt-1",
      staticStyle: {
        "max-width": "100px",
        "height": "150px",
        "margin": "0 auto",
        "background-position": "center",
        "background-size": "cover"
      },
      style: ('background-image: url(' + employee['imgSrc'] + ');')
    }) : _c('img', {
      staticStyle: {
        "max-width": "100%",
        "height": "150px",
        "object-fit": "contain",
        "background": "#ddd",
        "opacity": "0.6"
      },
      attrs: {
        "src": "/o/opencps-store/js/kios_bng/img/avatar_contacts.png"
      }
    })]), _vm._v(" "), _c('v-flex', {
      staticStyle: {
        "word-wrap": "break-word"
      },
      attrs: {
        "xs8": ""
      }
    }, [_c('div', {
      staticClass: "primary--text"
    }, [_vm._v(_vm._s(employee.jobPosTitle))]), _vm._v(" "), _c('div', {
      staticClass: "text-bold primary--text mb-2"
    }, [_vm._v(_vm._s(employee.fullName))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(employee.workingUnitName))]), _vm._v(" "), _c('div', [_vm._v("Email: " + _vm._s(employee.email))])])], 1)], 1), _vm._v(" "), _c('v-divider', {
      staticClass: "my-0",
      attrs: {
        "light": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "py-2",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.viewDetailEmployee(employee)
        }
      }
    }, [_c('v-layout', {
      staticClass: "px-3",
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "pt-2",
      staticStyle: {
        "max-width": "100px"
      }
    }, [_c('span', {
      staticClass: "text-bold"
    }, [_vm._v("Đánh giá:")])]), _vm._v(" "), _c('v-flex', [_c('star-rating', {
      attrs: {
        "read-only": "",
        "rating": employee['score'] ? employee['score'] : 0,
        "increment": 0.1,
        "max-rating": 5,
        "show-rating": false,
        "star-size": 30
      }
    })], 1)], 1), _vm._v(" "), _c('v-layout', {
      staticClass: "px-3",
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticStyle: {
        "max-width": "100px"
      }
    }, [_c('span', {
      staticClass: "text-bold"
    }, [_vm._v("Kết quả:")])]), _vm._v(" "), _c('v-flex', [_c('span', {
      staticClass: "text-bold primary--text"
    }, [_vm._v(_vm._s(employee['totalVoting'] ? employee['totalVoting'] : 0) + " lượt đánh giá")])])], 1)], 1)], 1)], 1)
  }), 1)], 1), _vm._v(" "), (_vm.totalEmployee > _vm.numberPerPage) ? _c('div', {
    staticClass: "text-xs-center pt-2 pb-3",
    staticStyle: {
      "width": "100%",
      "max-width": "350px",
      "margin": "0 auto"
    }
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.lengthPage,
      "circle": ""
    },
    on: {
      "input": _vm.changePage
    },
    model: {
      value: (_vm.employeePage),
      callback: function($$v) {
        _vm.employeePage = $$v
      },
      expression: "employeePage"
    }
  })], 1) : _vm._e()], 1) : _c('div', [_c('v-alert', {
    staticClass: "mt-4 mx-3",
    attrs: {
      "value": true,
      "outline": "",
      "color": "blue",
      "icon": "priority_high"
    }
  }, [_vm._v("\n            Không có danh sách cán bộ\n          ")])], 1)])], 1)], 1), _vm._v(" "), (!_vm.isMobile) ? _c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "fab": "",
      "color": "primary"
    },
    on: {
      "click": _vm.changeScreen
    }
  }, [(!_vm.fullScreen) ? _c('v-icon', {
    attrs: {
      "size": "20",
      "dark": ""
    }
  }, [_vm._v("fullscreen")]) : _vm._e(), _vm._v(" "), (_vm.fullScreen) ? _c('v-icon', {
    attrs: {
      "size": "20",
      "dark": ""
    }
  }, [_vm._v("fullscreen_exit")]) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1cc2d6b2", module.exports)
  }
}

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-2 py-0 kios-item"
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.loading) ? _c('content-placeholders', {
    staticClass: "mt-3"
  }, [_c('content-placeholders-text', {
    attrs: {
      "lines": 10
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.detailActive) ? _c('h4', {
    staticClass: "pt-2 ml-2"
  }, [_c('span', {
    staticStyle: {
      "color": "#065694"
    }
  }, [_vm._v("CHỌN ĐƠN VỊ ")])]) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.detailActive) ? _c('div', {
    staticClass: "mt-4",
    class: _vm.visible ? 'overlayActive' : ''
  }, [_c('v-layout', {
    staticClass: "wrap"
  }, _vm._l((_vm.govAgencyList), function(item, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "pr-3",
      attrs: {
        "xs6": "",
        "sm4": ""
      }
    }, [_c('v-btn', {
      staticClass: "kios-btn btn-select",
      staticStyle: {
        "width": "100%",
        "background-color": "#b3d4fc5c!important"
      },
      attrs: {
        "outline": "",
        "flat": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.votingDetail(item)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.administrationName) + "\n          ")])], 1)
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.isMobile) ? _c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "fab": "",
      "color": "primary"
    },
    on: {
      "click": _vm.changeScreen
    }
  }, [(!_vm.fullScreen) ? _c('v-icon', {
    attrs: {
      "size": "20",
      "dark": ""
    }
  }, [_vm._v("fullscreen")]) : _vm._e(), _vm._v(" "), (_vm.fullScreen) ? _c('v-icon', {
    attrs: {
      "size": "20",
      "dark": ""
    }
  }, [_vm._v("fullscreen_exit")]) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1d4a4106", module.exports)
  }
}

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-0"
  }, [_c('div', [_c('v-card', {
    staticClass: "pb-2",
    staticStyle: {
      "border": "none",
      "min-height": "100vh"
    },
    attrs: {
      "flat": ""
    }
  }, [_c('h2', {
    staticClass: "pt-2 mx-2 text-xs-center"
  }, [_c('span', {
    staticStyle: {
      "color": "#065694"
    }
  }, [_vm._v("TRA CỨU THÔNG TIN HỒ SƠ ")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "mx-2 mt-2 px-0 py-0",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "px-3 py-3",
    staticStyle: {
      "max-width": "700px",
      "margin": "0 auto",
      "border": "1px solid #dddddd"
    },
    attrs: {
      "color": "#002c46b3",
      "flat": ""
    }
  }, [_c('v-form', {
    ref: "form",
    staticClass: "mt-2",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "solo": "",
      "placeholder": "Mã số hồ sơ",
      "prepend-inner-icon": "description",
      "height": "42"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterDossier($event)
      }
    },
    model: {
      value: (_vm.dossierNoKey),
      callback: function($$v) {
        _vm.dossierNoKey = $$v
      },
      expression: "dossierNoKey"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "solo": "",
      "placeholder": "Số CMTND/ Hộ chiếu",
      "prepend-inner-icon": "credit_card",
      "height": "42"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterDossier($event)
      }
    },
    model: {
      value: (_vm.applicantIdNoKey),
      callback: function($$v) {
        _vm.applicantIdNoKey = $$v
      },
      expression: "applicantIdNoKey"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-left text-xs-center mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ml-0 mr-1 my-0 white--text",
    attrs: {
      "color": "#0b72ba",
      "loading": _vm.loadingTable,
      "disabled": _vm.loadingTable
    },
    on: {
      "click": _vm.filterDossier
    }
  }, [_c('v-icon', [_vm._v("search")]), _vm._v(" \n                  Tra cứu\n                ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-1 my-0 white--text",
    attrs: {
      "color": "#0b72ba",
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('v-icon', [_vm._v("reply")]), _vm._v(" \n                  Quay lại\n                ")], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-width": "1300px",
      "margin": "0 auto"
    }
  }, [_c('v-flex', {
    staticClass: "mt-3 mx-3"
  }, [_c('v-toolbar', {
    attrs: {
      "height": "42",
      "color": "#0b72ba",
      "dark": "",
      "flat": ""
    }
  }, [(!_vm.activeDetailDossier) ? _c('v-toolbar-title', {
    staticStyle: {
      "font-size": "16px !important"
    }
  }, [_vm._v("Kết quả tìm kiếm "), _c('span', [_vm._v(": " + _vm._s(_vm.dossierList.length) + " hồ sơ")])]) : _c('v-toolbar-title', {
    staticStyle: {
      "font-size": "16px !important"
    }
  }, [_vm._v("Thông tin chi tiết hồ sơ")])], 1)], 1), _vm._v(" "), (_vm.validateTracuu === true && !_vm.activeDetailDossier) ? _c('div', {
    staticClass: "mx-3 mt-4",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-data-table', {
    staticClass: "table-landing table-bordered",
    attrs: {
      "headers": _vm.headersTable,
      "items": _vm.dossierList,
      "hide-actions": "",
      "id": "tracuuhoso"
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "hover-pointer",
          class: {
            'active': props.index % 2 == 1
          },
          on: {
            "click": function($event) {
              return _vm.viewDetail(props.item)
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-center py-3",
          attrs: {
            "width": "50px"
          }
        }, [(_vm.loadingTable) ? _c('content-placeholders', [_c('content-placeholders-text', {
          attrs: {
            "lines": 1
          }
        })], 1) : _c('div', [_c('span', [_vm._v(_vm._s(props.index + 1))]), _c('br')])], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left py-3"
        }, [(_vm.loadingTable) ? _c('content-placeholders', [_c('content-placeholders-text', {
          attrs: {
            "lines": 1
          }
        })], 1) : _c('div', [_c('span', [_vm._v(_vm._s(props.item.dossierNo))]), _c('br')])], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left py-3"
        }, [(_vm.loadingTable) ? _c('content-placeholders', [_c('content-placeholders-text', {
          attrs: {
            "lines": 1
          }
        })], 1) : _c('div', [_c('span', [_vm._v(_vm._s(props.item.applicantName))])])], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left py-3"
        }, [(_vm.loadingTable) ? _c('content-placeholders', [_c('content-placeholders-text', {
          attrs: {
            "lines": 1
          }
        })], 1) : _c('div', [_c('span', [_c('span', [_vm._v(_vm._s(props.item.receiveDate))])])])], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left py-3"
        }, [(_vm.loadingTable) ? _c('content-placeholders', [_c('content-placeholders-text', {
          attrs: {
            "lines": 1
          }
        })], 1) : _c('div', [_c('span', [_vm._v(_vm._s(props.item.dossierStatusText))])])], 1)])]
      }
    }], null, false, 269305121)
  }, [_vm._v(" "), _c('template', {
    slot: "no-data"
  }, [_c('div', {
    staticClass: "text-xs-center mt-2"
  }, [_vm._v("\n                Không có hồ sơ nào được tìm thấy\n              ")])])], 2), _vm._v(" "), (_vm.totalPages > 10) ? _c('div', {
    staticClass: "text-xs-center layout wrap mt-2",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "flex pagging-table px-2"
  }, [_c('tiny-pagination', {
    attrs: {
      "total": _vm.totalPages,
      "page": _vm.hosoDatasPage,
      "custom-class": "custom-tiny-class"
    },
    on: {
      "tiny:change-page": _vm.paggingData
    }
  })], 1)]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.validateTracuu === true && _vm.activeDetailDossier) ? _c('div', {
    staticClass: "mx-3 mt-0",
    staticStyle: {
      "border": "1px solid #0b72ba"
    }
  }, [_c('chi-tiet-ho-so', {
    attrs: {
      "index": _vm.dossierDetail.dossierId
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "290"
    },
    model: {
      value: (_vm.dialogError),
      callback: function($$v) {
        _vm.dialogError = $$v
      },
      expression: "dialogError"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Bạn không có quyền truy cập hồ sơ \n          "), _c('span', [_vm._v(_vm._s(_vm.dossierDetail.dossierNo))])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogError = false
      }
    }
  }, [_vm._v("Đồng ý")])], 1)], 1)], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-28f0c43f", module.exports)
  }
}

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-0 kios-item"
  }, [_c('div', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#ffffff"
    }
  }, [(_vm.agencies.length === 1) ? _c('h4', {
    staticClass: "py-1 text-xs-center",
    staticStyle: {
      "color": "green",
      "text-transform": "uppercase"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.agencies[0]['administrationName']) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "py-2 mx-3 text-xs-center"
  }, [_c('span', {
    staticStyle: {
      "color": "#065694"
    }
  }, [_vm._v("DANH SÁCH HỒ SƠ CÓ KẾT QUẢ NGÀY " + _vm._s(_vm.fromDate()) + " \n            "), (_vm.dossierList.length > 0) ? _c('span', [_vm._v("(Tổng số: " + _vm._s(_vm.dossierList.length) + " hồ sơ)")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "py-3 mx-3"
  }, [_c('v-layout', {
    staticClass: "mb-3",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm6": ""
    }
  }, [_c('div', {
    staticClass: "input-custom"
  }, [_c('input', {
    attrs: {
      "id": "dossierNoKey",
      "type": "text",
      "required": "required"
    },
    on: {
      "focus": _vm.show,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchKeyword($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "dossierNoKey"
    }
  }, [_vm._v("Mã hồ sơ, tên chủ hồ sơ")]), _vm._v(" "), _c('v-icon', {
    staticClass: "icon-prepend text-bold",
    attrs: {
      "size": "18"
    },
    on: {
      "click": _vm.searchKeyword
    }
  }, [_vm._v("search")])], 1)])], 1), _vm._v(" "), (_vm.loading) ? _c('content-placeholders', {
    staticClass: "mt-3"
  }, [_c('content-placeholders-text', {
    attrs: {
      "lines": 10
    }
  })], 1) : _c('div', [(_vm.dossierList.length > 0) ? _c('div', [_c('v-data-table', {
    staticClass: "table-bordered",
    attrs: {
      "headers": _vm.headerTable,
      "items": _vm.dossierList,
      "pagination": _vm.pagination,
      "hide-actions": "",
      "light": ""
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: {
            'active': props.index % 2 == 1
          }
        }, [_c('td', {
          staticClass: "text-xs-center"
        }, [_c('span', [_vm._v(_vm._s(_vm.pagination.page * _vm.pagination.rowsPerPage - _vm.pagination.rowsPerPage + props.index + 1))]), _c('br')]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('span', [_vm._v(_vm._s(props.item.dossierNo))]), _c('br')]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('span', [_vm._v(_vm._s(props.item.applicantName))])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('span', [_vm._v(_vm._s(props.item.receiveDate))])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('span', [_vm._v(_vm._s(props.item.releaseDate))])])])]
      }
    }], null, false, 97893056)
  })], 1) : _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "mt-3",
    attrs: {
      "value": true,
      "outline": "",
      "color": "blue",
      "icon": "priority_high"
    }
  }, [_vm._v("\n                Không có hồ sơ có kết quả ngày " + _vm._s(_vm.fromDate()) + "\n              ")])], 1), _vm._v(" "), (_vm.dossierList.length > 10) ? _c('div', {
    staticClass: "text-xs-center layout wrap mt-2",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "flex pagging-table px-2"
  }, [_c('tiny-pagination', {
    attrs: {
      "total": _vm.dossierList.length,
      "page": _vm.pagination.page,
      "custom-class": "custom-tiny-class"
    },
    on: {
      "tiny:change-page": _vm.paggingData
    }
  })], 1)]) : _vm._e()], 1)], 1)]), _vm._v(" "), (!_vm.isMobile) ? _c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "fab": "",
      "color": "primary"
    },
    on: {
      "click": _vm.changeScreen
    }
  }, [(!_vm.fullScreen) ? _c('v-icon', {
    attrs: {
      "size": "20",
      "dark": ""
    }
  }, [_vm._v("fullscreen")]) : _vm._e(), _vm._v(" "), (_vm.fullScreen) ? _c('v-icon', {
    attrs: {
      "size": "20",
      "dark": ""
    }
  }, [_vm._v("fullscreen_exit")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.visible && !_vm.isMobile) ? _c('div', {
    staticClass: "virtual-keyboard"
  }, [_c('v-btn', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "0"
    },
    attrs: {
      "small": "",
      "fab": "",
      "color": "#383533"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#fff"
    }
  }, [_vm._v("clear")])], 1), _vm._v(" "), (_vm.visible) ? _c('vue-touch-keyboard', {
    attrs: {
      "layout": _vm.layout,
      "cancel": _vm.hide,
      "accept": _vm.accept,
      "input": _vm.input,
      "next": _vm.next,
      "options": _vm.options
    }
  }) : _vm._e()], 1) : _vm._e()], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2ce8ac97", module.exports)
  }
}

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-2 py-0 kios-item"
  }, [(_vm.loading) ? _c('content-placeholders', {
    staticClass: "mt-3"
  }, [_c('content-placeholders-text', {
    attrs: {
      "lines": 10
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.detailActive) ? _c('h4', {
    staticClass: "pt-2 ml-2"
  }, [_c('span', {
    staticStyle: {
      "color": "#065694"
    }
  }, [_vm._v("CHỌN ĐƠN VỊ ")])]) : _vm._e(), _vm._v(" "), (_vm.detailActive) ? _c('div', {
    staticClass: "text-xs-center"
  }, [_c('h4', {
    staticClass: "py-2",
    staticStyle: {
      "color": "#065694"
    }
  }, [_vm._v("KHẢO SÁT MỨC ĐỘ HÀI LÒNG")]), _vm._v(" "), _c('h4', {
    staticClass: "pb-2",
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(_vm._s(_vm.govAgencyName(_vm.govAgencySelected)))])]) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.detailActive) ? _c('div', {
    staticClass: "mt-4",
    class: _vm.visible ? 'overlayActive' : ''
  }, [_c('v-layout', {
    staticClass: "wrap"
  }, _vm._l((_vm.govAgencyList), function(item, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "pr-3",
      attrs: {
        "xs6": "",
        "sm4": ""
      }
    }, [_c('v-btn', {
      staticClass: "kios-btn btn-select",
      staticStyle: {
        "width": "100%",
        "background-color": "#b3d4fc5c!important"
      },
      attrs: {
        "outline": "",
        "flat": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.votingDetail(item)
        }
      }
    }, [_vm._v(_vm._s(item.administrationName))])], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.detailActive) ? _c('chi-tiet-danh-gia', {
    attrs: {
      "administration": _vm.govAgencySelected
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2db7bcb9", module.exports)
  }
}

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-touch-keyboard"
  }, [_c('div', {
    staticClass: "keyboard"
  }, _vm._l((_vm.keySet), function(line, index) {
    return _c('div', {
      key: index,
      staticClass: "line"
    }, _vm._l((line), function(key, index) {
      return _c('span', {
        key: index,
        class: _vm.getClassesOfKey(key),
        style: (_vm.getKeyStyle(key)),
        domProps: {
          "innerHTML": _vm._s(_vm.getCaptionOfKey(key))
        },
        on: {
          "click": function (e) { return _vm.clickKey(e, key); },
          "mousedown": _vm.mousedown
        }
      })
    }), 0)
  }), 0)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3e11bc78", module.exports)
  }
}

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-0 kios-item"
  }, [_c('div', [_c('v-card', {
    staticClass: "pb-2",
    attrs: {
      "flat": ""
    }
  }, [(_vm.agencies.length === 1) ? _c('h4', {
    staticClass: "py-1 text-xs-center",
    staticStyle: {
      "color": "green",
      "text-transform": "uppercase"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.agencies[0]['administrationName']) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "py-2 ml-2 text-xs-center"
  }, [_c('span', {
    staticStyle: {
      "color": "#065694"
    }
  }, [_vm._v("TRA CỨU THÔNG TIN HỒ SƠ ")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "px-0 py-0",
    attrs: {
      "wrap": ""
    }
  }, [_c('div', {
    style: (!_vm.isMobile ? 'width: calc(100% - 120px)' : 'width: 100%')
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "input-custom"
  }, [_c('input', {
    attrs: {
      "id": "dossierNoKey",
      "type": "text",
      "required": "required"
    },
    on: {
      "focus": _vm.show,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterDossier($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "dossierNoKey"
    }
  }, [_vm._v("Mã hồ sơ")])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "px-2",
    class: _vm.isMobile ? 'mt-3' : '',
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "input-custom"
  }, [_c('input', {
    attrs: {
      "id": "applicantIdNoKey",
      "type": "text",
      "required": "required"
    },
    on: {
      "focus": _vm.show,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterDossier($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "applicantIdNoKey"
    }
  }, [_vm._v("Số CMND/ hộ chiếu")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right px-2",
    style: (!_vm.isMobile ? 'width: 120px' : 'width: 100%')
  }, [_c('v-btn', {
    staticClass: "kios-btn mx-0",
    attrs: {
      "color": "primary",
      "loading": _vm.loadingTable,
      "disabled": _vm.loadingTable
    },
    on: {
      "click": _vm.filterDossier
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("search")]), _vm._v("\n             \n            Tra Cứu\n            "), _c('span', {
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_vm._v("Loading...")])], 1)], 1)]), _vm._v(" "), (_vm.validateTracuu === false && !_vm.activeDetailDossier) ? _c('v-alert', {
    staticClass: "mt-5 mx-2",
    attrs: {
      "value": true,
      "outline": "",
      "color": "orange",
      "icon": "priority_high"
    }
  }, [_vm._v("\n        Nhập thông tin tra cứu\n      ")]) : _vm._e(), _vm._v(" "), (_vm.validateTracuu === true && !_vm.activeDetailDossier) ? _c('div', {
    staticClass: "wrap-scroll wrap-scroll-tabledossier mx-2 mt-4",
    class: _vm.visible ? 'overlayActive' : '',
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-data-table', {
    staticClass: "table-tracuu table-landing table-bordered",
    class: _vm.visible ? 'overlayActive' : '',
    attrs: {
      "headers": _vm.headersTable,
      "items": _vm.dossierList,
      "hide-actions": "",
      "id": "tracuuhoso"
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: {
            'active': props.index % 2 == 1
          },
          on: {
            "click": function($event) {
              return _vm.viewDetail(props.item)
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-left"
        }, [(_vm.loadingTable) ? _c('content-placeholders', [_c('content-placeholders-text', {
          attrs: {
            "lines": 1
          }
        })], 1) : _c('div', [_c('span', [_vm._v(_vm._s(props.item.dossierNo))]), _c('br')])], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [(_vm.loadingTable) ? _c('content-placeholders', [_c('content-placeholders-text', {
          attrs: {
            "lines": 1
          }
        })], 1) : _c('div', [_c('span', [_vm._v(_vm._s(props.item.applicantName))])])], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [(_vm.loadingTable) ? _c('content-placeholders', [_c('content-placeholders-text', {
          attrs: {
            "lines": 1
          }
        })], 1) : _c('div', [_c('span', [_c('span', [_vm._v(_vm._s(props.item.receiveDate))])])])], 1)])]
      }
    }], null, false, 1457508949)
  }, [_vm._v(" "), _c('template', {
    slot: "no-data"
  }, [_c('div', {
    staticClass: "text-xs-center mt-2"
  }, [_vm._v("\n              Không có hồ sơ nào được tìm thấy\n            ")])])], 2), _vm._v(" "), (_vm.totalPages > 10) ? _c('div', {
    staticClass: "text-xs-center layout wrap mt-2",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "flex pagging-table px-2"
  }, [_c('tiny-pagination', {
    attrs: {
      "total": _vm.totalPages,
      "page": _vm.hosoDatasPage,
      "custom-class": "custom-tiny-class"
    },
    on: {
      "tiny:change-page": _vm.paggingData
    }
  })], 1)]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.validateTracuu === true && _vm.activeDetailDossier) ? _c('div', {
    staticClass: "mx-2 mt-3"
  }, [_c('chi-tiet-ho-so', {
    attrs: {
      "index": _vm.dossierDetail.dossierId
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.visible && !_vm.isMobile) ? _c('div', {
    staticClass: "virtual-keyboard"
  }, [_c('v-btn', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "0"
    },
    attrs: {
      "small": "",
      "fab": "",
      "color": "#383533"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#fff"
    }
  }, [_vm._v("clear")])], 1), _vm._v(" "), (_vm.visible) ? _c('vue-touch-keyboard', {
    attrs: {
      "layout": _vm.layout,
      "cancel": _vm.hide,
      "accept": _vm.accept,
      "input": _vm.input,
      "next": _vm.next,
      "options": _vm.options
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isMobile) ? _c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "fab": "",
      "color": "primary"
    },
    on: {
      "click": _vm.changeScreen
    }
  }, [(!_vm.fullScreen) ? _c('v-icon', {
    attrs: {
      "size": "20",
      "dark": ""
    }
  }, [_vm._v("fullscreen")]) : _vm._e(), _vm._v(" "), (_vm.fullScreen) ? _c('v-icon', {
    attrs: {
      "size": "20",
      "dark": ""
    }
  }, [_vm._v("fullscreen_exit")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "290"
    },
    model: {
      value: (_vm.dialogError),
      callback: function($$v) {
        _vm.dialogError = $$v
      },
      expression: "dialogError"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Bạn không có quyền truy cập hồ sơ \n          "), _c('span', [_vm._v(_vm._s(_vm.dossierDetail.dossierNo))])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogError = false
      }
    }
  }, [_vm._v("Đồng ý")])], 1)], 1)], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4aca7818", module.exports)
  }
}

/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-0 kios-item"
  }, [_c('v-card', [_c('v-layout', {
    staticClass: "wrap-password px-0 py-0",
    attrs: {
      "wrap": ""
    }
  }, [_c('div', {
    staticStyle: {
      "width": "calc(100% - 150px)"
    }
  }, [_c('v-layout', {
    staticClass: "text-xs-center",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pr-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "input-custom"
  }, [_c('input', {
    attrs: {
      "id": "passCheck",
      "type": "text",
      "required": "required"
    },
    on: {
      "focus": _vm.show,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitPass($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "passCheck"
    }
  }, [_vm._v("Mã tra cứu")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('v-btn', {
    staticClass: "kios-btn",
    attrs: {
      "color": "primary",
      "loading": _vm.loadingTable,
      "disabled": _vm.loadingTable
    },
    on: {
      "click": _vm.submitPass
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "20"
    }
  }, [_vm._v("search")]), _vm._v("\n           \n          Tra Cứu\n          "), _c('span', {
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_vm._v("Loading...")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center text-bold mt-3",
    staticStyle: {
      "color": "#065694"
    }
  }, [_c('p', {
    staticClass: "mb-1"
  }, [_vm._v("Mã tra cứu là dãy số gồm 4 ký tự được in trên")]), _vm._v(" "), _c('p', {
    staticClass: "mb-1"
  }, [_vm._v(" GIẤY TIẾP NHẬN HỒ SƠ VÀ HẸN TRẢ KẾT QUẢ")])])]), _vm._v(" "), (_vm.visible && !_vm.isMobile) ? _c('div', {
    staticClass: "virtual-keyboard"
  }, [_c('v-btn', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "0"
    },
    attrs: {
      "small": "",
      "fab": "",
      "color": "#383533"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#fff"
    }
  }, [_vm._v("clear")])], 1), _vm._v(" "), (_vm.visible) ? _c('vue-touch-keyboard', {
    attrs: {
      "layout": _vm.layout,
      "cancel": _vm.hide,
      "accept": _vm.accept,
      "input": _vm.input,
      "next": _vm.next,
      "options": _vm.options
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "290"
    },
    model: {
      value: (_vm.dialogError),
      callback: function($$v) {
        _vm.dialogError = $$v
      },
      expression: "dialogError"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Bạn không có quyền truy cập hồ sơ \n        "), _c('span', [_vm._v(_vm._s(_vm.dossierDetail.dossierNo))])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogError = false
      }
    }
  }, [_vm._v("Đồng ý")])], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "fab": "",
      "color": "primary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("arrow_back")])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5770123c", module.exports)
  }
}

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-3 px-2 py-0 kios-item"
  }, [_c('div', {
    staticClass: "wrap-scroll px-2 py-2",
    class: _vm.votingItems.length > 2 ? 'wrap-scroll-votting' : ''
  }, _vm._l((_vm.votingItems), function(item, index) {
    return (_vm.votingItems.length > 0) ? _c('div', {
      key: index,
      class: _vm.visible ? 'overlayActive' : ''
    }, [_c('div', {
      staticClass: "text-bold"
    }, [_vm._v("\n        " + _vm._s(index + 1) + ".  " + _vm._s(item.subject) + "\n      ")]), _vm._v(" "), _c('v-radio-group', {
      staticClass: "ml-3 pt-2",
      attrs: {
        "row": ""
      },
      model: {
        value: (item.selected),
        callback: function($$v) {
          _vm.$set(item, "selected", $$v)
        },
        expression: "item.selected"
      }
    }, _vm._l((item.choices), function(item1, index1) {
      return _c('v-radio', {
        key: index1,
        attrs: {
          "label": item1,
          "value": index1 + 1
        }
      })
    }), 1), _vm._v(" "), _c('v-layout', {
      staticClass: "ml-3",
      staticStyle: {
        "margin-top": "-10px"
      },
      attrs: {
        "wrap": ""
      }
    }, _vm._l((item.answers), function(item2, index2) {
      return _c('v-flex', {
        key: index2,
        staticStyle: {
          "margin-left": "45px"
        }
      }, [_c('span', {
        staticClass: "text-bold",
        staticStyle: {
          "color": "green"
        }
      }, [_vm._v(_vm._s(item2) + "/" + _vm._s(item.answersCount))])])
    }), 1)], 1) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    class: _vm.visible ? 'validDanhGiaCLDV' : ''
  }, [(!_vm.isSigned && _vm.votingItems.length > 0) ? _c('v-layout', {
    staticClass: "mt-4",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "text-bold",
    staticStyle: {
      "width": "110px"
    }
  }, [_vm._v("Mã hồ sơ "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "pt-0 input-border input-group input-group--placeholder input-group--text-field primary--text",
    staticStyle: {
      "width": "calc(100%-110px)"
    }
  }, [_c('div', {
    staticClass: "input-group__input"
  }, [_c('input', {
    staticClass: "kios-input",
    attrs: {
      "id": "dossierIdNoKey",
      "data-layout": "normal",
      "aria-label": "Số CMND",
      "placeholder": "Nhấn để nhập mã hồ sơ",
      "type": "text"
    },
    on: {
      "focus": _vm.show
    }
  }), _vm._v(" "), (_vm.visible) ? _c('i', {
    staticClass: "icon material-icons input-group__append-icon input-group__icon-cb input-group__icon-clearable",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.clear('dossierIdNoKey')
      }
    }
  }, [_vm._v("clear")]) : _vm._e()]), _vm._v(" "), (!_vm.validPass1) ? _c('div', {
    staticClass: "mt-2"
  }, [_c('div', {
    staticClass: "input-group__messages",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Mã hồ sơ là bắt buộc")])]) : _vm._e()])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-3",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "text-bold",
    staticStyle: {
      "width": "110px"
    }
  }, [_vm._v("Số CMND "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "pt-0 input-border input-group input-group--placeholder input-group--text-field primary--text",
    staticStyle: {
      "width": "calc(100%-110px)"
    }
  }, [_c('div', {
    staticClass: "input-group__input"
  }, [_c('input', {
    staticClass: "kios-input",
    attrs: {
      "id": "applicantIdNo",
      "data-layout": "normal",
      "aria-label": "Số CMND",
      "placeholder": "Nhấn để nhập số CMND",
      "type": "text"
    },
    on: {
      "focus": _vm.show
    }
  }), _vm._v(" "), (_vm.visible) ? _c('i', {
    staticClass: "icon material-icons input-group__append-icon input-group__icon-cb input-group__icon-clearable",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.clear('applicantIdNo')
      }
    }
  }, [_vm._v("clear")]) : _vm._e()]), _vm._v(" "), (!_vm.validPass2) ? _c('div', {
    staticClass: "mt-2"
  }, [_c('div', {
    staticClass: "input-group__messages",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Số CMND là bắt buộc")])]) : _vm._e()])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center mt-4"
  }, [_c('v-btn', {
    staticClass: "kios-btn",
    attrs: {
      "color": "primary",
      "loading": _vm.loadingAction,
      "disabled": _vm.loadingAction
    },
    on: {
      "click": _vm.submitVoting
    }
  }, [_vm._v("Gửi kết quả")])], 1)], 1), _vm._v(" "), (_vm.votingItems.length > 0) ? _c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "fab": "",
      "color": "primary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("arrow_back")])], 1) : _vm._e(), _vm._v(" "), (_vm.visible) ? _c('div', {
    staticClass: "virtual-keyboard"
  }, [(_vm.visible) ? _c('vue-touch-keyboard', {
    attrs: {
      "layout": _vm.layout,
      "cancel": _vm.hide,
      "accept": _vm.accept,
      "input": _vm.input,
      "next": _vm.next
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-632aa9ac", module.exports)
  }
}

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-0 kios-item"
  }, [_c('div', [_c('v-card', {
    staticClass: "mb-0",
    attrs: {
      "flat": ""
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#ffffff"
    }
  }, [(_vm.agencies.length === 1) ? _c('h4', {
    staticClass: "py-1 text-xs-center",
    staticStyle: {
      "color": "green",
      "text-transform": "uppercase"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.agencies[0]['administrationName']) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "py-2 mx-3 text-xs-center"
  }, [_c('span', {
    staticStyle: {
      "color": "#065694"
    }
  }, [_vm._v("DANH SÁCH HỒ SƠ TIẾP NHẬN NGÀY " + _vm._s(_vm.fromDate()) + " \n            "), (_vm.dossierList.length > 0) ? _c('span', [_vm._v("(Tổng số: " + _vm._s(_vm.dossierList.length) + " hồ sơ)")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "py-3 mx-3"
  }, [_c('v-layout', {
    staticClass: "mb-3",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm6": ""
    }
  }, [_c('div', {
    staticClass: "input-custom"
  }, [_c('input', {
    attrs: {
      "id": "dossierNoKey",
      "type": "text",
      "required": "required"
    },
    on: {
      "focus": _vm.show,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchKeyword($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "dossierNoKey"
    }
  }, [_vm._v("Mã hồ sơ, tên chủ hồ sơ")]), _vm._v(" "), _c('v-icon', {
    staticClass: "icon-prepend text-bold",
    attrs: {
      "size": "18"
    },
    on: {
      "click": _vm.searchKeyword
    }
  }, [_vm._v("search")])], 1)])], 1), _vm._v(" "), (_vm.loading) ? _c('content-placeholders', {
    staticClass: "mt-3"
  }, [_c('content-placeholders-text', {
    attrs: {
      "lines": 10
    }
  })], 1) : _c('div', [(_vm.dossierList.length > 0) ? _c('div', [_c('v-data-table', {
    staticClass: "table-bordered",
    attrs: {
      "headers": _vm.headerTable,
      "items": _vm.dossierList,
      "pagination": _vm.pagination,
      "hide-actions": "",
      "light": ""
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: {
            'active': props.index % 2 == 1
          }
        }, [_c('td', {
          staticClass: "text-xs-center"
        }, [_c('span', [_vm._v(_vm._s(_vm.pagination.page * _vm.pagination.rowsPerPage - _vm.pagination.rowsPerPage + props.index + 1))]), _c('br')]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('span', [_vm._v(_vm._s(props.item.dossierNo))]), _c('br')]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('span', [_vm._v(_vm._s(props.item.applicantName))])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [(props.item.online) ? _c('span', [_vm._v(_vm._s(props.item.submitDate))]) : _c('span', [_vm._v(_vm._s(props.item.receiveDate))])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('span', [_vm._v(_vm._s(props.item.receiveDate))])])])]
      }
    }], null, false, 2223194711)
  })], 1) : _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "mt-3",
    attrs: {
      "value": true,
      "outline": "",
      "color": "blue",
      "icon": "priority_high"
    }
  }, [_vm._v("\n                Không có hồ sơ tiếp nhận ngày " + _vm._s(_vm.fromDate()) + "\n              ")])], 1), _vm._v(" "), (_vm.dossierList.length > 10) ? _c('div', {
    staticClass: "text-xs-center layout wrap mt-2",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "flex pagging-table px-2"
  }, [_c('tiny-pagination', {
    attrs: {
      "total": _vm.dossierList.length,
      "page": _vm.pagination.page,
      "custom-class": "custom-tiny-class"
    },
    on: {
      "tiny:change-page": _vm.paggingData
    }
  })], 1)]) : _vm._e()], 1)], 1)]), _vm._v(" "), (!_vm.isMobile) ? _c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "fab": "",
      "color": "primary"
    },
    on: {
      "click": _vm.changeScreen
    }
  }, [(!_vm.fullScreen) ? _c('v-icon', {
    attrs: {
      "size": "20",
      "dark": ""
    }
  }, [_vm._v("fullscreen")]) : _vm._e(), _vm._v(" "), (_vm.fullScreen) ? _c('v-icon', {
    attrs: {
      "size": "20",
      "dark": ""
    }
  }, [_vm._v("fullscreen_exit")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.visible && !_vm.isMobile) ? _c('div', {
    staticClass: "virtual-keyboard"
  }, [_c('v-btn', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "0"
    },
    attrs: {
      "small": "",
      "fab": "",
      "color": "#383533"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#fff"
    }
  }, [_vm._v("clear")])], 1), _vm._v(" "), (_vm.visible) ? _c('vue-touch-keyboard', {
    attrs: {
      "layout": _vm.layout,
      "cancel": _vm.hide,
      "accept": _vm.accept,
      "input": _vm.input,
      "next": _vm.next,
      "options": _vm.options
    }
  }) : _vm._e()], 1) : _vm._e()], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-709cea0a", module.exports)
  }
}

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("Kéo thả các ô vuông để cho đúng thứ tự")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-chip', {
    staticStyle: {
      "background-color": "#81D4FA"
    },
    attrs: {
      "label": "",
      "text-color": "white"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.captcha) + "\n    ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "drag-and-drop",
      rawName: "v-drag-and-drop:options",
      value: (_vm.options),
      expression: "options",
      arg: "options"
    }],
    staticClass: "drag-wrapper text-xs-center mt-3"
  }, [_c('ul', {
    attrs: {
      "id": "captcha"
    }
  }, _vm._l((_vm.arrCaptcha), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "item-captcha",
      staticStyle: {
        "padding": "10px 15px",
        "background-color": "#81D4FA",
        "margin-right": "2px",
        "color": "#fff",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-738ec94e", module.exports)
  }
}

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "text-align": "left",
      "position": "absolute",
      "line-height": "46px"
    }
  }, [_vm._v("Tổng số "), _c('span', {
    staticClass: "text-bold primary--text"
  }, [_vm._v(_vm._s(_vm.total))]), _vm._v(" thủ tục. ")]), _vm._v(" "), (_vm.total > 0) ? _c('div', {
    staticClass: "vue-tiny-pagination pagination layout"
  }, [_c('div', {
    staticClass: "pr-3 xs4 flex"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.totalPagesData,
      "item-text": "text",
      "item-value": "value",
      "autocomplete": ""
    },
    on: {
      "input": _vm.goToPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1), _vm._v(" "), _c('ul', {
    staticClass: "tiny-pagination",
    class: _vm.customClass
  }, [_c('li', {
    staticClass: "page-item",
    class: _vm.classFirstPage
  }, [_c('button', {
    staticClass: "pagination__navigation",
    class: _vm.classFirstPage,
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.lastPageLast($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("first_page")])])]), _vm._v(" "), _c('li', {
    staticClass: "page-item",
    class: _vm.classFirstPage
  }, [_c('button', {
    staticClass: "pagination__navigation",
    class: _vm.classFirstPage,
    staticStyle: {
      "border-left": "0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.lastPage($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("chevron_left")])])]), _vm._v(" "), _c('li', {
    staticClass: "page-item",
    staticStyle: {
      "margin-right": "0"
    }
  }, [_c('button', {
    staticClass: "pagination__navigation pagination__navigation--disabled text-bold primary--text",
    staticStyle: {
      "border-right": "0",
      "border-left": "0"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.titlePage) + "\n        ")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item",
    class: _vm.classLastPage,
    staticStyle: {
      "margin-right": "0"
    }
  }, [_c('button', {
    staticClass: "pagination__navigation",
    class: _vm.classLastPage,
    staticStyle: {
      "border-left": "0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.nextPage($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("chevron_right")])])]), _vm._v(" "), _c('li', {
    staticClass: "page-item",
    class: _vm.classLastPage
  }, [_c('button', {
    staticClass: "pagination__navigation",
    class: _vm.classLastPage,
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.nextPageLast($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("last_page")])])])])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7907e2b6", module.exports)
  }
}

/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-2 py-0 kios-item"
  }, [(_vm.loading) ? _c('content-placeholders', {
    staticClass: "mt-3"
  }, [_c('content-placeholders-text', {
    attrs: {
      "lines": 10
    }
  })], 1) : _c('div', [_c('v-layout', {
    staticClass: "wrap pb-3"
  }, [_c('div', {
    staticClass: "pb-2",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('v-chip', {
    staticClass: "mx-0 my-0",
    staticStyle: {
      "height": "px"
    },
    attrs: {
      "label": "",
      "color": _vm.getColor(_vm.serviceDetail.maxLevel),
      "text-color": "white"
    }
  }, [_vm._v("\n          Mức độ " + _vm._s(_vm.serviceDetail.maxLevel) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "calc(100% - 100px)"
    }
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.serviceDetail.serviceName))])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-0"
  }, [_c('v-tabs', {
    attrs: {
      "color": "cyan",
      "dark": "",
      "slider-color": "yellow"
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-tab', {
    key: "1",
    staticClass: "mr-2",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v(" Thông tin chung ")]), _vm._v(" "), _c('v-tab', {
    key: "2",
    staticClass: "mr-2",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v(" Trình tự thực hiện")]), _vm._v(" "), _c('v-tab', {
    key: "3",
    staticClass: "mr-2",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v(" Thành phần hồ sơ ")]), _vm._v(" "), _c('v-tab', {
    key: "4",
    staticClass: "mr-2",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v(" Yêu cầu điều kiện ")]), _vm._v(" "), _c('v-tab-item', {
    key: "1",
    staticClass: "wrap-scroll wrap-scroll-sevice"
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "px-0 py-0"
  }, [_c('div', {
    staticClass: "table-detail-domain table-bordered"
  }, [_c('div', {
    staticClass: "table__overflow"
  }, [_c('table', {
    staticClass: "datatable table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Mã thủ tục")])]), _vm._v(" "), _c('td', {
    staticClass: "pt-2"
  }, [_c('span', [_vm._v(_vm._s(_vm.serviceDetail.serviceCode))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Cơ quan quản lý")])]), _vm._v(" "), _c('td', {
    staticClass: "pt-2"
  }, [_c('span', [_vm._v(_vm._s(_vm.serviceDetail.administrationName))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Lĩnh vực")])]), _vm._v(" "), _c('td', {
    staticClass: "pt-2"
  }, [_c('span', [_vm._v(_vm._s(_vm.serviceDetail.domainName))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Cách thực hiện")])]), _vm._v(" "), _c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.serviceDetail.methodText)
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Thời gian giải quyết")])]), _vm._v(" "), _c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.serviceDetail.durationText)
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Đối tượng")])]), _vm._v(" "), _c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.serviceDetail.applicantText)
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Kết quả giải quyết")])]), _vm._v(" "), _c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.serviceDetail.resultText)
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Lệ phí")])]), _vm._v(" "), _c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.serviceDetail.feeText)
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Căn cứ pháp lý")])]), _vm._v(" "), _c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.serviceDetail.regularText)
    }
  })])])])])])])])], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: "2",
    staticClass: "wrap-scroll wrap-scroll-sevice"
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.serviceDetail.processText)
    }
  })])], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: "3",
    staticClass: "wrap-scroll wrap-scroll-sevice"
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.serviceDetail.dossierText)
    }
  })])], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: "4",
    staticClass: "wrap-scroll wrap-scroll-sevice"
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.serviceDetail.conditionText)
    }
  })])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7e6cf8a8", module.exports)
  }
}

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.total > _vm.currentLimit) ? _c('div', {
    staticClass: "vue-tiny-pagination pagination layout",
    staticStyle: {
      "justify-content": "center",
      "-webkit-justify-content": "center"
    }
  }, [_c('ul', {
    staticClass: "tiny-pagination",
    class: _vm.customClass
  }, [_c('li', {
    staticClass: "page-item",
    class: _vm.classFirstPage
  }, [_c('button', {
    staticClass: "pagination__navigation primary",
    class: _vm.classFirstPage,
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.lastPage($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("arrow_left")])])]), _vm._v(" "), _c('li', {
    staticClass: "page-item ml-4",
    class: _vm.classLastPage,
    staticStyle: {
      "margin-right": "0"
    }
  }, [_c('button', {
    staticClass: "pagination__navigation primary",
    class: _vm.classLastPage,
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.nextPage($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("arrow_right")])])])])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-96f97b52", module.exports)
  }
}

/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-0 kios-item"
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('h4', {
    staticClass: "pt-2 ml-2"
  }, [_c('span', {
    staticStyle: {
      "color": "#065694"
    }
  }, [_vm._v("TRA CỨU THỦ TỤC HÀNH CHÍNH ")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "box": "",
      "items": _vm.govAgencyList,
      "label": "Cơ quan",
      "item-text": "administrationName",
      "item-value": "administrationCode",
      "hide-selected": true,
      "color": "primary",
      "clearable": "",
      "height": "48"
    },
    on: {
      "change": _vm.changeAdministration
    },
    model: {
      value: (_vm.govAgencySelected),
      callback: function($$v) {
        _vm.govAgencySelected = $$v
      },
      expression: "govAgencySelected"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "box": "",
      "items": _vm.listLinhVuc,
      "label": "Lĩnh vực",
      "item-text": "domainName",
      "item-value": "domainCode",
      "hide-selected": true,
      "color": "primary",
      "clearable": "",
      "height": "48"
    },
    on: {
      "change": _vm.changeDomain
    },
    model: {
      value: (_vm.linhVucSelected),
      callback: function($$v) {
        _vm.linhVucSelected = $$v
      },
      expression: "linhVucSelected"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "input-custom"
  }, [_c('input', {
    attrs: {
      "id": "serviceNameKey",
      "type": "text",
      "required": "required"
    },
    on: {
      "focus": _vm.show,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterServiceinfos('keyword')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "serviceNameKey"
    }
  }, [_vm._v("Tên thủ tục hành chính")]), _vm._v(" "), _c('v-icon', {
    staticClass: "icon-prepend text-bold",
    attrs: {
      "size": "18"
    },
    on: {
      "click": function($event) {
        return _vm.filterServiceinfos('keyword')
      }
    }
  }, [_vm._v("search")])], 1)])], 1), _vm._v(" "), (_vm.loading) ? _c('content-placeholders', {
    staticClass: "mt-3"
  }, [_c('content-placeholders-text', {
    attrs: {
      "lines": 10
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.activeDetailService && !_vm.showListThuTuc && _vm.govAgencyList && !_vm.govAgencySelected && _vm.govAgencyList.length > 0) ? _c('div', {
    staticClass: "mt-4 ml-1",
    class: _vm.visible ? 'overlayActive' : ''
  }, [_c('v-layout', {
    staticClass: "wrap"
  }, _vm._l((_vm.govAgencyList), function(item, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "pr-3",
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-select",
      staticStyle: {
        "width": "100%",
        "background-color": "#b3d4fc5c!important"
      },
      attrs: {
        "outline": "",
        "flat": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.filterAdministration(item)
        }
      }
    }, [_vm._v(_vm._s(item.administrationName))])], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.activeDetailService && !_vm.showListThuTuc && _vm.listLinhVuc && _vm.govAgencySelected && !_vm.linhVucSelected && _vm.listLinhVuc.length > 0) ? _c('div', {
    staticClass: "mt-4 pb-2 mx-2",
    class: _vm.visible ? 'overlayActive' : ''
  }, [_c('div', {
    staticClass: "wrap-scroll wrap-scroll-domain list-domain"
  }, [_c('v-list', {
    staticClass: "py-0"
  }, [_vm._l((_vm.listLinhVuc), function(item, index) {
    return [_c('v-list-tile', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.filterDomain(item)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.domainName)
      }
    })], 1)], 1)]
  })], 2)], 1), _vm._v(" "), (_vm.totalPaggingLinhVuc > 10) ? _c('div', {
    staticClass: "text-xs-center layout wrap mt-2",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "flex pagging-table px-2"
  }, [_c('tiny-pagination', {
    attrs: {
      "total": _vm.totalPaggingLinhVuc,
      "page": _vm.pageListLinhVuc,
      "custom-class": "custom-tiny-class"
    },
    on: {
      "tiny:change-page": _vm.paggingData
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.activeDetailService && _vm.showListThuTuc) ? _c('div', {
    staticClass: "mt-4",
    class: _vm.visible ? 'overlayActive' : ''
  }, [_c('div', {
    staticClass: "wrap-scroll wrap-scroll-tableservice"
  }, [_c('v-data-table', {
    staticClass: "table-bordered table-thu-tuc ml-2",
    attrs: {
      "headers": _vm.headersTable,
      "items": _vm.listThuTuc,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: {
            'active': props.index % 2 == 1
          },
          on: {
            "click": function($event) {
              return _vm.viewDetail(props.item)
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-center"
        }, [(_vm.loading) ? _c('content-placeholders', [_c('content-placeholders-text', {
          attrs: {
            "lines": 1
          }
        })], 1) : _c('div', [_c('span', [_vm._v(_vm._s(_vm.pageListThuTuc * 10 - 10 + props.index + 1))]), _c('br')])], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [(_vm.loading) ? _c('content-placeholders', [_c('content-placeholders-text', {
          attrs: {
            "lines": 1
          }
        })], 1) : _c('div', [_c('span', [_vm._v(_vm._s(props.item.serviceName))])])], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [(_vm.loading) ? _c('content-placeholders', [_c('content-placeholders-text', {
          attrs: {
            "lines": 1
          }
        })], 1) : _c('div', [_c('span', [_c('span', [_vm._v(_vm._s(props.item.domainName))])])])], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [(_vm.loading) ? _c('content-placeholders', [_c('content-placeholders-text', {
          attrs: {
            "lines": 1
          }
        })], 1) : _c('div', [_c('span', [_c('v-chip', {
          staticClass: "mx-0 my-0",
          staticStyle: {
            "height": "25px"
          },
          attrs: {
            "label": "",
            "color": _vm.getColor(props.item.maxLevel),
            "text-color": "white"
          }
        }, [_vm._v("\n                      Mức độ " + _vm._s(props.item.maxLevel) + "\n                    ")])], 1)])], 1)])]
      }
    }], null, false, 1336454382)
  }, [_vm._v(" "), _c('template', {
    slot: "no-data"
  }, [_c('div', {
    staticClass: "text-xs-center mt-2"
  }, [_vm._v("\n              Không có thủ tục nào được tìm thấy\n            ")])])], 2)], 1), _vm._v(" "), (_vm.totalPaggingThuTuc > 10) ? _c('div', {
    staticClass: "text-xs-center layout wrap mt-2",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "flex pagging-table px-2"
  }, [_c('tiny-pagination', {
    attrs: {
      "total": _vm.totalPaggingThuTuc,
      "page": _vm.pageListThuTuc,
      "custom-class": "custom-tiny-class"
    },
    on: {
      "tiny:change-page": _vm.paggingData
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.activeDetailService) ? _c('div', {
    staticClass: "mt-4"
  }, [_c('chi-tiet-thu-tuc', {
    attrs: {
      "index": _vm.serviceId
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.visible && !_vm.isMobile) ? _c('div', {
    staticClass: "virtual-keyboard"
  }, [_c('v-btn', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "0"
    },
    attrs: {
      "small": "",
      "fab": "",
      "color": "#383533"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#fff"
    }
  }, [_vm._v("clear")])], 1), _vm._v(" "), (_vm.visible) ? _c('vue-touch-keyboard', {
    attrs: {
      "layout": _vm.layout,
      "cancel": _vm.hide,
      "accept": _vm.accept,
      "input": _vm.input,
      "next": _vm.next,
      "options": _vm.options
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isMobile) ? _c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "fab": "",
      "color": "primary"
    },
    on: {
      "click": _vm.changeScreen
    }
  }, [(!_vm.fullScreen) ? _c('v-icon', {
    attrs: {
      "size": "20",
      "dark": ""
    }
  }, [_vm._v("fullscreen")]) : _vm._e(), _vm._v(" "), (_vm.fullScreen) ? _c('v-icon', {
    attrs: {
      "size": "20",
      "dark": ""
    }
  }, [_vm._v("fullscreen_exit")]) : _vm._e()], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-97b0229c", module.exports)
  }
}

/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kios-item"
  }, [(_vm.loading) ? _c('content-placeholders', {
    staticClass: "mt-3"
  }, [_c('content-placeholders-text', {
    attrs: {
      "lines": 10
    }
  })], 1) : _c('div', {
    staticClass: "mt-3"
  }, [_c('v-layout', {
    staticClass: "wrap"
  }, [_c('v-flex', {
    staticClass: "pr-2 pb-2"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Tên hồ sơ: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dossierDetail.serviceName))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('v-tabs', {
    attrs: {
      "color": "cyan",
      "dark": "",
      "slider-color": "yellow"
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-tab', {
    key: "1",
    staticClass: "mx-2",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v(" Thông tin chung ")]), _vm._v(" "), _c('v-tab', {
    key: "2",
    staticClass: "mx-2",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v(" Tiến trình thụ lý ")]), _vm._v(" "), (_vm.dossierDetail['dossierStatus'] === 'done') ? _c('v-tab', {
    key: "3",
    staticClass: "mx-2",
    attrs: {
      "ripple": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadVoting()
      }
    }
  }, [_vm._v(" Đánh giá ")]) : _vm._e(), _vm._v(" "), _c('v-tab-item', {
    key: "1",
    staticClass: "wrap-scroll wrap-scroll-dossier"
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "px-0 py-0"
  }, [_c('v-layout', {
    staticClass: "px-2 py-2",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pr-2"
  }, [_vm._v("Mã hồ sơ: ")]), _vm._v(" "), _c('span', {
    staticClass: "pl-0 text-bold "
  }, [_vm._v("  " + _vm._s(_vm.dossierDetail.dossierNo) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pr-2"
  }, [_vm._v("Cơ quan: ")]), _vm._v(" "), _c('span', {
    staticClass: "pl-0 text-bold "
  }, [_vm._v("  " + _vm._s(_vm.dossierDetail.govAgencyName) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pr-2"
  }, [_vm._v("Trạng thái: ")]), _vm._v(" "), _c('span', {
    staticClass: "pl-0 text-bold "
  }, [_vm._v(" " + _vm._s(_vm.dossierDetail.dossierStatusText) + " ")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pr-2"
  }, [_vm._v("Ngày gửi: ")]), _vm._v(" "), (_vm.dossierDetail.online) ? _c('span', {
    staticClass: "pl-0 text-bold"
  }, [_vm._v(" " + _vm._s(_vm.dossierDetail.submitDate) + " ")]) : _c('span', {
    staticClass: "pl-0 text-bold"
  }, [_vm._v(" Một cửa ")])]), _vm._v(" "), _c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pr-2"
  }, [_vm._v("Ngày tiếp nhận: ")]), _vm._v(" "), _c('span', {
    staticClass: "pl-0 text-bold "
  }, [_vm._v(" " + _vm._s(_vm.dossierDetail.receiveDate))])]), _vm._v(" "), _c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pr-2"
  }, [_vm._v("Ngày hẹn trả: ")]), _vm._v(" "), _c('span', {
    staticClass: "pl-0 text-bold "
  }, [_vm._v(" " + _vm._s(_vm.dossierDetail.dueDate))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [(_vm.dossierDetail.dossierNote && _vm.dossierDetail.dossierNote !== 'null' && _vm.dossierDetail.dossierNote.indexOf('<br/>') < 0) ? _c('div', {
    staticClass: "xs12 sm12 pb-1",
    staticStyle: {
      "color": "#0b72ba"
    }
  }, [_vm._v("Ghi chú:")]) : _vm._e(), _vm._v(" "), (_vm.dossierDetail.dossierNote && _vm.dossierDetail.dossierNote !== 'null' && _vm.dossierDetail.dossierNote.indexOf('<br/>') < 0) ? _c('div', {
    staticClass: "xs12 sm12 pb-1 overHidden"
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('span', {
    staticClass: "text-bold ",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v(_vm._s(_vm.dossierDetail.dossierNote) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "pl-0",
    domProps: {
      "innerHTML": _vm._s(_vm.dossierDetail.dossierNote)
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.dossierDetail.extendDate) ? _c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pl-0 text-bold"
  }, [_vm._v("Hẹn lại: " + _vm._s(_vm.dossierDetail.extendDate))])]) : _vm._e()])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: "2",
    staticClass: "wrap-scroll wrap-scroll-dossier"
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "px-0 py-0"
  }, [_c('div', [_c('v-data-table', {
    staticClass: "table-landing table-bordered",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.dossierActions,
      "hide-actions": "",
      "no-data-text": "Không có dữ liệu"
    },
    scopedSlots: _vm._u([{
      key: "headerCell",
      fn: function(props) {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('span', {
          attrs: {
            "slot": "activator"
          },
          slot: "activator"
        }, [_vm._v("\n                        " + _vm._s(props.header.text) + "\n                      ")]), _vm._v(" "), _c('span', [_vm._v("\n                        " + _vm._s(props.header.text) + "\n                      ")])])]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.index + 1))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.sequenceRole))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.sequenceName))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.durationCount) + " ngày")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("dateTimeView")(props.item.startDate)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, _vm._l((props.item.assignUsers), function(itemUser) {
          return _c('div', {
            key: itemUser.userId
          }, [_vm._v("\n                        " + _vm._s(itemUser.userName) + " "), _c('br')])
        }), 0), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._l((props.item.actions), function(itemAction, index) {
          return _c('div', {
            key: index
          }, [_vm._v("\n                        " + _vm._s(_vm._f("dateTimeView")(itemAction.createDate)) + " : "), _c('span', {
            staticStyle: {
              "color": "#0b72ba"
            }
          }, [_vm._v(_vm._s(itemAction.actionName))])])
        }), _vm._v(" "), (props.item.statusText) ? _c('div', [_c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v(_vm._s(props.item.statusText))])]) : _vm._e()], 2)]
      }
    }])
  })], 1)])], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: "3",
    staticClass: "wrap-scroll wrap-scroll-dossier"
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "px-0 py-0"
  }, [_c('div', {
    staticClass: "px-2 py-2"
  }, [_vm._l((_vm.votingItems), function(item, index) {
    return (_vm.votingItems.length > 0) ? _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "text-bold"
    }, [_vm._v("\n                    " + _vm._s(index + 1) + ".  " + _vm._s(item.subject) + "\n                  ")]), _vm._v(" "), _c('v-radio-group', {
      staticClass: "ml-3 pt-2",
      attrs: {
        "row": ""
      },
      model: {
        value: (item.selected),
        callback: function($$v) {
          _vm.$set(item, "selected", $$v)
        },
        expression: "item.selected"
      }
    }, _vm._l((item.choices), function(item1, index1) {
      return _c('v-radio', {
        key: index1,
        attrs: {
          "label": item1,
          "value": index1 + 1
        }
      })
    }), 1), _vm._v(" "), _c('v-layout', {
      staticClass: "ml-3",
      staticStyle: {
        "margin-top": "-10px"
      },
      attrs: {
        "wrap": ""
      }
    }, _vm._l((item.answers), function(item2, index2) {
      return _c('v-flex', {
        key: index2,
        staticStyle: {
          "margin-left": "45px"
        }
      }, [_c('span', {
        staticClass: "text-bold",
        staticStyle: {
          "color": "green"
        }
      }, [_vm._v(_vm._s(item2) + "/" + _vm._s(item.answersCount))])])
    }), 1)], 1) : _vm._e()
  }), _vm._v(" "), (_vm.votingItems.length === 0) ? _c('div', {
    staticClass: "mx-3"
  }, [_c('v-alert', {
    attrs: {
      "outline": "",
      "color": "warning",
      "icon": "priority_high",
      "value": true
    }
  }, [_vm._v("\n                    Không có đánh giá\n                  ")])], 1) : _vm._e(), _vm._v(" "), (_vm.votingItems.length > 0) ? _c('div', {
    staticClass: "ml-3"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.loadingVoting,
      "disabled": _vm.loadingVoting
    },
    on: {
      "click": _vm.submitVoting
    }
  }, [_vm._v("Gửi đánh giá")])], 1) : _vm._e()], 2)])], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: "4",
    staticClass: "wrap-scroll wrap-scroll-dossier"
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "px-0 py-0"
  }, _vm._l((_vm.listHistoryProcessing), function(item, index) {
    return _c('div', {
      key: item.dossierLogId,
      staticClass: "list_history_style"
    }, [_c('td', {
      staticClass: "px-2 pt-2",
      class: index % 2 !== 0 ? 'col-tien-trinh-1' : 'col-tien-trinh-2'
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-left px-2 py-2"
    }, [_c('p', {
      staticClass: "mb-1"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("dateTimeView")(item.createDate)))]), _vm._v(" - "), _c('b', [_vm._v(_vm._s(item.author))]), _vm._v(" \n                    : "), _c('span', {
      staticStyle: {
        "color": "#0b72ba"
      }
    }, [_vm._v(_vm._s(item.payload.stepName))])]), _vm._v(" "), (item.content !== '' && item.content !== null) ? _c('p', {
      staticClass: "mb-1"
    }, [_vm._v("Ý kiến: "), _c('span', {
      staticStyle: {
        "color": "green"
      },
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })]) : _vm._e()])])
  }), 0)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "fab": "",
      "color": "primary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("arrow_back")])], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a934592c", module.exports)
  }
}

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-0 mt-3 text-center"
  }, [_c('div', {
    staticClass: "kios-wrapper kios-home"
  }, [_c('div', {
    staticClass: "custom-row",
    on: {
      "click": _vm.goTraCuuHoSo
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "custom-row",
    on: {
      "click": _vm.goTraCuuThuTuc
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "custom-row",
    on: {
      "click": _vm.goDanhGiaCanBo
    }
  }, [_vm._m(4), _vm._v(" "), _vm._m(5)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-7"
  }, [_c('p', [_vm._v("Hệ thống hỗ trợ người dùng tra cứu thông tin hồ sơ, người dùng sử dụng máy quét mã vạch để tra cứu nhanh thông tin hồ sơ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-5"
  }, [_c('span', [_vm._v("Tra cứu"), _c('br'), _vm._v("hồ sơ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-5"
  }, [_c('span', [_vm._v("Tra cứu"), _c('br'), _vm._v("thủ tục")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-7"
  }, [_c('p', [_vm._v("Hỗ trợ người sử dụng tra cứu, tìm hiểu thông tin thành phần hồ sơ, cách thức thực hiện của các thủ tục hành chính một cách nhanh chóng nhằm tạo điều kiện thuận lợi cho quá trình nộp hồ sơ ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-7"
  }, [_c('p', [_vm._v("Đánh giá chất lượng dịch vụ"), _c('br'), _vm._v(" tại đơn vị hành chính công")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-5"
  }, [_c('span', [_vm._v("Đánh giá chất lượng dịch vụ")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b8c38714", module.exports)
  }
}

/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: !_vm.isPermission ? 'pt-2' : ''
  }, [(!_vm.isPermission && !_vm.loading) ? _c('v-flex', {
    staticClass: "mx-2 mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "outline": "",
      "color": "warning",
      "icon": "priority_high",
      "value": true
    }
  }, [_vm._v("\n      Bạn không có quyền truy cập hồ sơ này\n    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isPermission && !_vm.loading) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "detailQR_desktop"
  }, [_c('h4', {
    staticClass: "pt-2 ml-2"
  }, [_c('span', {
    staticStyle: {
      "color": "#065694"
    }
  }, [_vm._v("TRA CỨU THÔNG TIN HỒ SƠ ")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "wrap"
  }, [_c('v-flex', {
    staticClass: "px-2 py-2 mt-2"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.dossierDetail.serviceName))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-4"
  }, [_c('v-tabs', {
    attrs: {
      "color": "cyan",
      "dark": "",
      "slider-color": "yellow"
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-tab', {
    key: "1",
    staticClass: "mx-2",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v(" Thông tin chung ")]), _vm._v(" "), _c('v-tab', {
    key: "2",
    staticClass: "mx-2",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v(" Tiến trình thụ lý ")]), _vm._v(" "), _c('v-tab-item', {
    key: "1",
    staticClass: "wrap-scroll wrap-scroll-dossier"
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "px-0 py-0"
  }, [_c('v-layout', {
    staticClass: "px-2 py-2",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pr-2"
  }, [_vm._v("Mã hồ sơ: ")]), _vm._v(" "), _c('span', {
    staticClass: "pl-0 text-bold "
  }, [_vm._v("  " + _vm._s(_vm.dossierDetail.dossierNo) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pr-2"
  }, [_vm._v("Cơ quan: ")]), _vm._v(" "), _c('span', {
    staticClass: "pl-0 text-bold "
  }, [_vm._v("  " + _vm._s(_vm.dossierDetail.govAgencyName) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pr-2"
  }, [_vm._v("Trạng thái: ")]), _vm._v(" "), _c('span', {
    staticClass: "pl-0 text-bold "
  }, [_vm._v(" " + _vm._s(_vm.dossierDetail.dossierStatusText) + " ")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pr-2"
  }, [_vm._v("Ngày gửi: ")]), _vm._v(" "), (_vm.dossierDetail.online) ? _c('span', {
    staticClass: "pl-0 text-bold"
  }, [_vm._v(" " + _vm._s(_vm.dossierDetail.submitDate) + " ")]) : _c('span', {
    staticClass: "pl-0 text-bold"
  }, [_vm._v(" Một cửa ")])]), _vm._v(" "), _c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pr-2"
  }, [_vm._v("Ngày tiếp nhận: ")]), _vm._v(" "), _c('span', {
    staticClass: "pl-0 text-bold "
  }, [_vm._v(" " + _vm._s(_vm.dossierDetail.receiveDate))])]), _vm._v(" "), _c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pr-2"
  }, [_vm._v("Ngày hẹn trả: ")]), _vm._v(" "), _c('span', {
    staticClass: "pl-0 text-bold "
  }, [_vm._v(" " + _vm._s(_vm.dossierDetail.dueDate))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [(_vm.dossierDetail.dossierNote && _vm.dossierDetail.dossierNote !== 'null' && _vm.dossierDetail.dossierNote.indexOf('<br/>') < 0) ? _c('div', {
    staticClass: "xs12 sm12 pb-1",
    staticStyle: {
      "color": "#0b72ba"
    }
  }, [_vm._v("Ghi chú:")]) : _vm._e(), _vm._v(" "), (_vm.dossierDetail.dossierNote && _vm.dossierDetail.dossierNote !== 'null' && _vm.dossierDetail.dossierNote.indexOf('<br/>') < 0) ? _c('div', {
    staticClass: "xs12 sm12 pb-1 overHidden"
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('span', {
    staticClass: "text-bold ",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v(_vm._s(_vm.dossierDetail.dossierNote) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "pl-0",
    domProps: {
      "innerHTML": _vm._s(_vm.dossierDetail.dossierNote)
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.dossierDetail.extendDate) ? _c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pl-0 text-bold"
  }, [_vm._v("Hẹn lại: " + _vm._s(_vm.dossierDetail.extendDate))])]) : _vm._e()])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: "2"
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "px-0 py-0"
  }, [_c('div', [_c('v-data-table', {
    staticClass: "table-landing table-bordered",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.dossierActions,
      "hide-actions": "",
      "no-data-text": "Không có dữ liệu"
    },
    scopedSlots: _vm._u([{
      key: "headerCell",
      fn: function(props) {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('span', {
          attrs: {
            "slot": "activator"
          },
          slot: "activator"
        }, [_vm._v("\n                          " + _vm._s(props.header.text) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(props.header.text) + "\n                        ")])])]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.index + 1))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.sequenceRole))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.sequenceName))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.durationCount) + " ngày")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("dateTimeView")(props.item.startDate)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, _vm._l((props.item.assignUsers), function(itemUser) {
          return _c('div', {
            key: itemUser.userId
          }, [_vm._v("\n                          " + _vm._s(itemUser.userName) + " "), _c('br')])
        }), 0), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._l((props.item.actions), function(itemAction, index) {
          return _c('div', {
            key: index
          }, [_vm._v("\n                          " + _vm._s(_vm._f("dateTimeView")(itemAction.createDate)) + " : "), _c('span', {
            staticStyle: {
              "color": "#0b72ba"
            }
          }, [_vm._v(_vm._s(itemAction.actionName))])])
        }), _vm._v(" "), (props.item.statusText) ? _c('div', [_c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v(_vm._s(props.item.statusText))])]) : _vm._e()], 2)]
      }
    }], null, false, 2384702216)
  })], 1)])], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: "3",
    staticClass: "wrap-scroll wrap-scroll-dossier"
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "px-0 py-0"
  }, _vm._l((_vm.listHistoryProcessing), function(item, index) {
    return _c('div', {
      key: item.dossierLogId,
      staticClass: "list_history_style"
    }, [_c('td', {
      staticClass: "px-2 pt-2",
      class: index % 2 !== 0 ? 'col-tien-trinh-1' : 'col-tien-trinh-2'
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-left px-2 py-2"
    }, [_c('p', {
      staticClass: "mb-1"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("dateTimeView")(item.createDate)))]), _vm._v(" - "), _c('b', [_vm._v(_vm._s(item.author))]), _vm._v(" \n                      : "), _c('span', {
      staticStyle: {
        "color": "#0b72ba"
      }
    }, [_vm._v(_vm._s(item.payload.stepName))])]), _vm._v(" "), (item.content !== '' && item.content !== null) ? _c('p', {
      staticClass: "mb-1"
    }, [_vm._v("Ý kiến: "), _c('span', {
      staticStyle: {
        "color": "green"
      },
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })]) : _vm._e()])])
  }), 0)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "detailQR_mobile"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "transition": "slide-x-transition"
    }
  }, [_c('v-toolbar-side-icon', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.detailInfo = true;
        _vm.detailSync = false;
        _vm.detailVoting = false
      }
    }
  }, [_vm._v("Thông tin hồ sơ")]), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.detailSync = true;
        _vm.detailInfo = false;
        _vm.detailVoting = false
      }
    }
  }, [_vm._v("Tiến trình thụ lý")]), _vm._v(" "), (_vm.dossierDetail['dossierStatus'] === 'done') ? _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.loadVoting()
      }
    }
  }, [_vm._v("Đánh giá")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.detailInfo) ? _c('v-toolbar-title', {
    staticClass: "mobile mx-2"
  }, [_vm._v("THÔNG TIN HỒ SƠ")]) : _vm._e(), _vm._v(" "), (_vm.detailVoting) ? _c('v-toolbar-title', {
    staticClass: "mobile mx-2"
  }, [_vm._v("ĐÁNH GIÁ")]) : _vm._e(), _vm._v(" "), (_vm.detailSync) ? _c('v-toolbar-title', {
    staticClass: "mobile mx-2"
  }, [_vm._v("TIẾN TRÌNH THỤ LÝ")]) : _vm._e()], 1), _vm._v(" "), (_vm.detailInfo) ? _c('v-layout', {
    staticClass: "mx-2 my-3",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-1",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0 text-header"
  }, [_vm._v("Thủ tục: ")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-1",
    attrs: {
      "xs8": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0 header-text-field text-header text-bold"
  }, [_vm._v("  " + _vm._s(_vm.dossierDetail.serviceName) + " ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0 text-header"
  }, [_vm._v("Cơ quan: ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0 header-text-field text-header text-bold"
  }, [_vm._v("  " + _vm._s(_vm.dossierDetail.govAgencyName) + " ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0 text-header"
  }, [_vm._v("Mã hồ sơ: ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0 header-text-field text-header text-bold"
  }, [_vm._v("  " + _vm._s(_vm.dossierDetail.dossierNo) + " ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0 text-header"
  }, [_vm._v("Chủ hồ sơ: ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0 header-text-field text-header text-bold"
  }, [_vm._v("  " + _vm._s(_vm.dossierDetail.applicantName) + " ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0 text-header"
  }, [_vm._v("Ngày gửi: ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0 header-text-field text-header text-bold"
  }, [_vm._v("  " + _vm._s(_vm.dossierDetail.submitDate) + " ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0 text-header"
  }, [_vm._v("Ngày tiếp nhận: ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0 header-text-field text-header text-bold"
  }, [_vm._v("  " + _vm._s(_vm.dossierDetail.receiveDate) + " ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0 text-header"
  }, [_vm._v("Ngày hẹn trả: ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0 header-text-field text-header text-bold"
  }, [_vm._v("  " + _vm._s(_vm.dossierDetail.dueDate) + " ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0 text-header"
  }, [_vm._v("Trạng thái: ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0 header-text-field text-header text-bold"
  }, [_vm._v("  " + _vm._s(_vm.dossierDetail.dossierStatusText) + " ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0 text-header",
    staticStyle: {
      "color": "#0b72ba"
    }
  }, [_vm._v("Ghi chú: ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [(_vm.dossierDetail.dossierNote && _vm.dossierDetail.dossierNote !== 'null') ? _c('div', [_c('div', {
    staticClass: "pl-0 text-header text-bold",
    domProps: {
      "innerHTML": _vm._s(_vm.dossierDetail.dossierNote)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.dossierDetail.extendDate) ? _c('div', [_c('div', {
    staticClass: "pl-0 text-header text-bold",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Hẹn lại:  " + _vm._s(_vm.dossierDetail.extendDate) + " ")])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.detailVoting) ? _c('v-layout', {
    staticClass: "mx-2 my-3",
    attrs: {
      "wrap": ""
    }
  }, [_c('div', [_vm._l((_vm.votingItems), function(item, index) {
    return (_vm.votingItems.length > 0) ? _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "text-bold"
    }, [_vm._v("\n                    " + _vm._s(index + 1) + ".  " + _vm._s(item.subject) + "\n                  ")]), _vm._v(" "), _c('v-radio-group', {
      staticClass: "ml-3 pt-2",
      attrs: {
        "row": ""
      },
      model: {
        value: (item.selected),
        callback: function($$v) {
          _vm.$set(item, "selected", $$v)
        },
        expression: "item.selected"
      }
    }, _vm._l((item.choices), function(item1, index1) {
      return _c('v-radio', {
        key: index1,
        attrs: {
          "label": item1,
          "value": index1 + 1
        }
      })
    }), 1), _vm._v(" "), _c('v-layout', {
      staticClass: "ml-3",
      staticStyle: {
        "margin-top": "-10px"
      },
      attrs: {
        "wrap": ""
      }
    }, _vm._l((item.answers), function(item2, index2) {
      return _c('v-flex', {
        key: index2,
        staticStyle: {
          "margin-left": "45px"
        }
      }, [_c('span', {
        staticClass: "text-bold",
        staticStyle: {
          "color": "green"
        }
      }, [_vm._v(_vm._s(item2) + "/" + _vm._s(item.answersCount))])])
    }), 1)], 1) : _vm._e()
  }), _vm._v(" "), (_vm.votingItems.length === 0) ? _c('div', {
    staticClass: "mx-3"
  }, [_c('v-alert', {
    attrs: {
      "outline": "",
      "color": "warning",
      "icon": "priority_high",
      "value": true
    }
  }, [_vm._v("\n                    Không có đánh giá\n                  ")])], 1) : _vm._e(), _vm._v(" "), (_vm.votingItems.length > 0) ? _c('div', {
    staticClass: "ml-3"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.loadingVoting,
      "disabled": _vm.loadingVoting
    },
    on: {
      "click": _vm.submitVoting
    }
  }, [_vm._v("Gửi đánh giá")])], 1) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.detailSync) ? _c('v-layout', {
    staticClass: "mx-2 my-3",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "px-0 py-0"
  }, [_c('div', [_c('v-data-table', {
    staticClass: "table-landing table-bordered",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.dossierActions,
      "hide-actions": "",
      "no-data-text": "Không có dữ liệu"
    },
    scopedSlots: _vm._u([{
      key: "headerCell",
      fn: function(props) {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('span', {
          attrs: {
            "slot": "activator"
          },
          slot: "activator"
        }, [_vm._v("\n                            " + _vm._s(props.header.text) + "\n                          ")]), _vm._v(" "), _c('span', [_vm._v("\n                            " + _vm._s(props.header.text) + "\n                          ")])])]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.index + 1))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.sequenceRole))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.sequenceName))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.durationCount) + " ngày")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("dateTimeView")(props.item.startDate)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, _vm._l((props.item.assignUsers), function(itemUser) {
          return _c('div', {
            key: itemUser.userId
          }, [_vm._v("\n                            " + _vm._s(itemUser.userName) + " "), _c('br')])
        }), 0), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._l((props.item.actions), function(itemAction, index) {
          return _c('div', {
            key: index
          }, [_vm._v("\n                            " + _vm._s(_vm._f("dateTimeView")(itemAction.createDate)) + " : "), _c('span', {
            staticStyle: {
              "color": "#0b72ba"
            }
          }, [_vm._v(_vm._s(itemAction.actionName))])])
        }), _vm._v(" "), (props.item.statusText) ? _c('div', [_c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v(_vm._s(props.item.statusText))])]) : _vm._e()], 2)]
      }
    }], null, false, 503963400)
  })], 1)])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ba460eea", module.exports)
  }
}

/***/ }),

/***/ 540:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('content-placeholders', {
    staticClass: "mt-3"
  }, [_c('content-placeholders-text', {
    attrs: {
      "lines": 10
    }
  })], 1) : _c('div', [_c('v-layout', {
    staticClass: "wrap"
  }, [_c('v-flex', {
    staticClass: "pr-2 pb-2"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Tên thủ tục: " + _vm._s(_vm.dossierDetail.serviceName))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('v-tabs', {
    attrs: {
      "color": "#0a72ba",
      "dark": "",
      "slider-color": "yellow"
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-tab', {
    key: "1",
    staticClass: "mx-2",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v(" Thông tin chung ")]), _vm._v(" "), _c('v-tab', {
    key: "2",
    staticClass: "mx-2",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v(" Tiến trình thụ lý ")]), _vm._v(" "), (_vm.dossierDetail['dossierStatus'] === 'done') ? _c('v-tab', {
    key: "3",
    staticClass: "mx-2",
    attrs: {
      "ripple": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadVoting()
      }
    }
  }, [_vm._v(" Đánh giá ")]) : _vm._e(), _vm._v(" "), _c('v-tab-item', {
    key: "1"
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "px-0 py-0"
  }, [_c('v-layout', {
    staticClass: "px-2 py-2",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pr-2"
  }, [_vm._v("Mã hồ sơ: ")]), _vm._v(" "), _c('span', {
    staticClass: "pl-0 text-bold "
  }, [_vm._v("  " + _vm._s(_vm.dossierDetail.dossierNo) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pr-2"
  }, [_vm._v("Cơ quan: ")]), _vm._v(" "), _c('span', {
    staticClass: "pl-0 text-bold "
  }, [_vm._v("  " + _vm._s(_vm.dossierDetail.govAgencyName) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pr-2"
  }, [_vm._v("Trạng thái: ")]), _vm._v(" "), _c('span', {
    staticClass: "pl-0 text-bold "
  }, [_vm._v(" " + _vm._s(_vm.dossierDetail.dossierStatusText) + " ")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pr-2"
  }, [_vm._v("Ngày gửi: ")]), _vm._v(" "), (_vm.dossierDetail.online) ? _c('span', {
    staticClass: "pl-0 text-bold"
  }, [_vm._v(" " + _vm._s(_vm.dossierDetail.submitDate) + " ")]) : _c('span', {
    staticClass: "pl-0 text-bold"
  }, [_vm._v(" Một cửa ")])]), _vm._v(" "), _c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pr-2"
  }, [_vm._v("Ngày tiếp nhận: ")]), _vm._v(" "), _c('span', {
    staticClass: "pl-0 text-bold "
  }, [_vm._v(" " + _vm._s(_vm.dossierDetail.receiveDate))])]), _vm._v(" "), _c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pr-2"
  }, [_vm._v("Ngày hẹn trả: ")]), _vm._v(" "), _c('span', {
    staticClass: "pl-0 text-bold "
  }, [_vm._v(" " + _vm._s(_vm.dossierDetail.dueDate))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [(_vm.dossierDetail.dossierNote && _vm.dossierDetail.dossierNote !== 'null' && _vm.dossierDetail.dossierNote.indexOf('<br/>') < 0) ? _c('div', {
    staticClass: "xs12 sm12 pb-1",
    staticStyle: {
      "color": "#0b72ba"
    }
  }, [_vm._v("Ghi chú:")]) : _vm._e(), _vm._v(" "), (_vm.dossierDetail.dossierNote && _vm.dossierDetail.dossierNote !== 'null' && _vm.dossierDetail.dossierNote.indexOf('<br/>') < 0) ? _c('div', {
    staticClass: "xs12 sm12 pb-1 overHidden"
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('span', {
    staticClass: "text-bold ",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v(_vm._s(_vm.dossierDetail.dossierNote) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "pl-0",
    domProps: {
      "innerHTML": _vm._s(_vm.dossierDetail.dossierNote)
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.dossierDetail.extendDate) ? _c('div', {
    staticClass: "xs12 sm12 pb-1"
  }, [_c('span', {
    staticClass: "pl-0 text-bold"
  }, [_vm._v("Hẹn lại: " + _vm._s(_vm.dossierDetail.extendDate))])]) : _vm._e()])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: "2"
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "px-0 py-0"
  }, [_c('div', [_c('v-data-table', {
    staticClass: "table-landing table-bordered",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.dossierActions,
      "hide-actions": "",
      "no-data-text": "Không có dữ liệu"
    },
    scopedSlots: _vm._u([{
      key: "headerCell",
      fn: function(props) {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('span', {
          attrs: {
            "slot": "activator"
          },
          slot: "activator"
        }, [_vm._v("\n                        " + _vm._s(props.header.text) + "\n                      ")]), _vm._v(" "), _c('span', [_vm._v("\n                        " + _vm._s(props.header.text) + "\n                      ")])])]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.index + 1))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.sequenceRole))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.sequenceName))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.durationCount) + " ngày")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("dateTimeView")(props.item.startDate)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, _vm._l((props.item.assignUsers), function(itemUser) {
          return _c('div', {
            key: itemUser.userId
          }, [_vm._v("\n                        " + _vm._s(itemUser.userName) + " "), _c('br')])
        }), 0), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._l((props.item.actions), function(itemAction, index) {
          return _c('div', {
            key: index
          }, [_vm._v("\n                        " + _vm._s(_vm._f("dateTimeView")(itemAction.createDate)) + " : "), _c('span', {
            staticStyle: {
              "color": "#0b72ba"
            }
          }, [_vm._v(_vm._s(itemAction.actionName))])])
        }), _vm._v(" "), (props.item.statusText) ? _c('div', [_c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v(_vm._s(props.item.statusText))])]) : _vm._e()], 2)]
      }
    }])
  })], 1)])], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: "3"
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "px-2 py-2"
  }, [_c('div', [_vm._l((_vm.votingItems), function(item, index) {
    return (_vm.votingItems.length > 0) ? _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "text-bold"
    }, [_vm._v("\n                    " + _vm._s(index + 1) + ".  " + _vm._s(item.subject) + "\n                  ")]), _vm._v(" "), _c('v-radio-group', {
      staticClass: "ml-3 pt-2",
      attrs: {
        "row": ""
      },
      model: {
        value: (item.selected),
        callback: function($$v) {
          _vm.$set(item, "selected", $$v)
        },
        expression: "item.selected"
      }
    }, _vm._l((item.choices), function(item1, index1) {
      return _c('v-radio', {
        key: index1,
        attrs: {
          "label": item1,
          "value": index1 + 1
        }
      })
    }), 1), _vm._v(" "), _c('v-layout', {
      staticClass: "ml-3",
      staticStyle: {
        "margin-top": "-10px"
      },
      attrs: {
        "wrap": ""
      }
    }, _vm._l((item.answers), function(item2, index2) {
      return _c('v-flex', {
        key: index2,
        staticStyle: {
          "margin-left": "45px"
        }
      }, [_c('span', {
        staticClass: "text-bold",
        staticStyle: {
          "color": "green"
        }
      }, [_vm._v(_vm._s(item2) + "/" + _vm._s(item.answersCount))])])
    }), 1)], 1) : _vm._e()
  }), _vm._v(" "), (_vm.votingItems.length === 0) ? _c('div', {
    staticClass: "mx-3"
  }, [_c('v-alert', {
    attrs: {
      "outline": "",
      "color": "warning",
      "icon": "priority_high",
      "value": true
    }
  }, [_vm._v("\n                    Không có đánh giá\n                  ")])], 1) : _vm._e(), _vm._v(" "), (_vm.votingItems.length > 0) ? _c('div', {
    staticClass: "ml-3"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.loadingVoting,
      "disabled": _vm.loadingVoting
    },
    on: {
      "click": _vm.submitVoting
    }
  }, [_vm._v("Gửi đánh giá")])], 1) : _vm._e()], 2)])], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: "4"
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "px-0 py-0"
  }, _vm._l((_vm.listHistoryProcessing), function(item, index) {
    return _c('div', {
      key: item.dossierLogId,
      staticClass: "list_history_style"
    }, [_c('td', {
      staticClass: "px-2 pt-2",
      class: index % 2 !== 0 ? 'col-tien-trinh-1' : 'col-tien-trinh-2'
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-left px-2 py-2"
    }, [_c('p', {
      staticClass: "mb-1"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("dateTimeView")(item.createDate)))]), _vm._v(" - "), _c('b', [_vm._v(_vm._s(item.author))]), _vm._v(" \n                    : "), _c('span', {
      staticStyle: {
        "color": "#0b72ba"
      }
    }, [_vm._v(_vm._s(item.payload.stepName))])]), _vm._v(" "), (item.content !== '' && item.content !== null) ? _c('p', {
      staticClass: "mb-1"
    }, [_vm._v("Ý kiến: "), _c('span', {
      staticStyle: {
        "color": "green"
      },
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })]) : _vm._e()])])
  }), 0)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e68a7ad0", module.exports)
  }
}

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.total > _vm.currentLimit) ? _c('div', {
    staticClass: "vue-tiny-pagination pagination layout",
    staticStyle: {
      "justify-content": "center",
      "-webkit-justify-content": "center"
    }
  }, [_c('ul', {
    staticClass: "tiny-pagination",
    class: _vm.customClass
  }, [_c('li', {
    staticClass: "page-item",
    class: _vm.classFirstPage
  }, [_c('button', {
    staticClass: "pagination__navigation primary",
    class: _vm.classFirstPage,
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.lastPage($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("arrow_left")])])]), _vm._v(" "), _c('li', {
    staticClass: "page-item ml-4",
    class: _vm.classLastPage,
    staticStyle: {
      "margin-right": "0"
    }
  }, [_c('button', {
    staticClass: "pagination__navigation primary",
    class: _vm.classLastPage,
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.nextPage($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("arrow_right")])])])])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ec1a172a", module.exports)
  }
}

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    on: {
      "mousemove": function($event) {
        return _vm.stopInterval()
      },
      "click": function($event) {
        return _vm.stopInterval()
      }
    }
  }, [(_vm.isMobile) ? _c('v-btn', {
    staticClass: "elevation-0",
    staticStyle: {
      "top": "70px",
      "width": "56px",
      "height": "56px",
      "right": "0px",
      "border-radius": "6px",
      "border-bottom-right-radius": "0",
      "border-top-right-radius": "0",
      "background-color": "#002c46d4!important"
    },
    attrs: {
      "color": "grey",
      "dark": "",
      "fab": "",
      "fixed": "",
      "top": "",
      "right": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "32"
    }
  }, [_vm._v("list")])], 1) : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('v-navigation-drawer', {
    staticStyle: {
      "background": "#002c46d4",
      "position": "fixed",
      "top": "0px",
      "left": "0px"
    },
    attrs: {
      "dark": "",
      "temporary": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.image,
      "height": "100%"
    }
  }, [_c('v-layout', {
    staticClass: "fill-height",
    attrs: {
      "tag": "v-list",
      "column": ""
    }
  }, _vm._l((_vm.kiosItems), function(item, index) {
    return _c('v-list-tile', {
      key: index,
      staticClass: "v-list-item",
      class: _vm.active === index ? 'active_drawer' : '',
      attrs: {
        "avatar": ""
      },
      on: {
        "click": function($event) {
          return _vm.goPage(item.route, index)
        }
      }
    }, [_c('v-list-tile-action', {
      staticClass: "mx-2"
    }, [_c('v-icon', {
      attrs: {
        "size": "26"
      }
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      staticStyle: {
        "font-size": "16px"
      },
      domProps: {
        "textContent": _vm._s(item.text)
      }
    })], 1)
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('v-content', [_c('router-view')], 1) : _c('v-content', [_c('v-card', {
    staticStyle: {
      "font-family": "'Times New Roman', Times, serif",
      "height": "130px"
    },
    attrs: {
      "flat": "",
      "color": "#0f66dd"
    }
  }, [_c('v-flex', {
    staticClass: "header_dhxh text-xs-center pt-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "logo d-inline-block"
  }, [_c('div', {
    staticClass: "d-inline-block px-3 pt-2",
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "0"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "src": '/documents/' + _vm.groupId + '/0/logo.png'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center mt-3",
    staticStyle: {
      "font-size": "16px",
      "color": "#e5e0e0"
    }
  }, [_vm._v("BỘ NGOẠI GIAO")])]), _vm._v(" "), _c('div', {
    staticClass: "d-inline-block px-2 pt-2",
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "right": "0"
    }
  }, [_c('img', {
    staticClass: "img-slogan mb-3",
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "src": '/documents/' + _vm.groupId + '/0/ct.png'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center",
    staticStyle: {
      "font-size": "14px",
      "color": "#e5e0e0"
    }
  }, [_vm._v("CHUNG TAY CẢI CÁCH")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center mt-1",
    staticStyle: {
      "font-size": "14px",
      "color": "#e5e0e0"
    }
  }, [_vm._v("THỦ TỤC HÀNH CHÍNH")])]), _vm._v(" "), _c('div', {
    staticClass: "mb-1 mt-2",
    staticStyle: {
      "font-size": "26px",
      "color": "#e5e0e0"
    }
  }, [_vm._v("BỘ PHẬN TIẾP NHẬN HỒ SƠ VÀ TRẢ KẾT QUẢ")]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "line-height": "5px"
    }
  }, [_c('div', {
    staticClass: "underline-white",
    staticStyle: {
      "width": "350px",
      "height": "2px"
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center pt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "32px",
      "color": "#f7d900",
      "height": "50px"
    }
  }, [_vm._v("\n              TRA CỨU THÔNG TIN\n            ")])])], 1)])], 1), _vm._v(" "), _c('section', {
    class: _vm.isKios && _vm.wrapStyle ? 'kios-content-wrapper' : '',
    on: {
      "mousemove": function($event) {
        return _vm.stopInterval()
      },
      "click": function($event) {
        return _vm.stopInterval()
      }
    }
  }, [_c('div', {
    class: _vm.isKios ? 'tab-item' : ''
  }, [(!_vm.fullScreen) ? _c('div', {
    staticClass: "left",
    class: _vm.fullScreen ? 'smallScreen' : ''
  }, [_c('a', {
    staticClass: "active",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.goPage('ketquahoso')
      }
    }
  }, [_c('p', {
    staticClass: "icon px-2"
  }, [_c('img', {
    attrs: {
      "src": "/o/opencps-store/js/kios/img/icons-document.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ml-2 my-0"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Hồ sơ đã có kết quả")])])]), _vm._v(" "), _c('a', {
    staticClass: "active",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.goPage('tiepnhanhoso')
      }
    }
  }, [_c('p', {
    staticClass: "icon px-2"
  }, [_c('img', {
    attrs: {
      "src": "/o/opencps-store/js/kios/img/icons8-open-file-50.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ml-2 my-0"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Hồ sơ đã tiếp nhận")])])]), _vm._v(" "), _c('a', {
    staticClass: "active",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.goPage('tracuuhoso')
      }
    }
  }, [_c('p', {
    staticClass: "icon px-2"
  }, [_c('img', {
    attrs: {
      "src": "/o/opencps-store/js/kios/img/icons-search-50.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ml-2 my-0"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Tra cứu hồ sơ")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.goPage('tracuuthutuc')
      }
    }
  }, [_c('p', {
    staticClass: "icon px-2"
  }, [_c('img', {
    attrs: {
      "src": "/o/opencps-store/js/kios/img/icon-search-dc-50.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ml-2 my-0"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Tra cứu thủ tục")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.goPage('danhgia')
      }
    }
  }, [_c('p', {
    staticClass: "icon pl-1 pr-2"
  }, [_c('img', {
    attrs: {
      "src": "/o/opencps-store/js/kios/img/icon-evaluation.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ml-2 my-0"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Đánh giá cán bộ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "right",
    class: _vm.fullScreen ? 'fullScreen' : ''
  }, [_c('div', {
    staticClass: "right-content"
  }, [_c('router-view')], 1)])])])], 1), _vm._v(" "), (_vm.enableToTop) ? _c('v-btn', {
    staticStyle: {
      "width": "56px",
      "height": "56px"
    },
    attrs: {
      "fab": "",
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "color": "#002c46d4"
    },
    on: {
      "click": function($event) {
        return _vm.$vuetify.goTo(0)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "size": "40"
    }
  }, [_vm._v("keyboard_arrow_up")])], 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f79fe98e", module.exports)
  }
}

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

module.exports = {"renderURLInit":"?p_p_id=FrontendWebKios&p_p_lifecycle=2&p_p_state=exclusive&p_p_mode=view&p_p_resource_id=renderURLInit","initData":{"dataEmployee":[{"fullName":"Nguyễn Quốc Bảo","jobPos":"Phó Chánh văn phòng Giám đốc trung tâm","workingUnit":"Văn phòng UBND tỉnh","telNo":"0913.556.849","userId":"001","userType":"0"},{"fullName":"Nguyễn Xuân Long","jobPos":"Phó Giám đốc trung tâm","workingUnit":"Văn phòng UBND tỉnh","telNo":"0986.673.397","userId":"002","userType":"0"},{"fullName":"Nguyễn Thị Lệ Thủy","jobPos":"Chuyên viên","workingUnit":"Văn phòng UBND tỉnh","telNo":"0983.280.476","userId":"003","userType":"0"},{"fullName":"Bùi Tú Quỳnh","jobPos":"Chuyên viên","workingUnit":"Văn phòng UBND tỉnh","telNo":"0944.903.699","userId":"004","userType":"0"},{"fullName":"Chu Thị Hà Vân","jobPos":"Chuyên viên","workingUnit":"Văn phòng UBND tỉnh","telNo":"0982.818.890","userId":"005","userType":"0"},{"fullName":"Nguyễn Nữ Phương Thảo","jobPos":"Chuyên viên","workingUnit":"Văn phòng UBND tỉnh","telNo":"0986.380.686","userId":"006","userType":"0"},{"fullName":"Nguyễn Đình Tú","jobPos":"Chuyên viên","workingUnit":"Văn phòng UBND tỉnh","telNo":"0944.629.788","userId":"007","userType":"0"},{"fullName":"Đặng Xuân Thắng","jobPos":"Chuyên viên","workingUnit":"Văn phòng UBND tỉnh","telNo":"0969.438.305","userId":"008","userType":"0"},{"fullName":"Phạm Thị Bích Ngọc","jobPos":"Chuyên viên","workingUnit":"Sở Công Thương","telNo":"0973.444.463","userId":"009","userType":"1"},{"fullName":"Dương Thị Hằng","jobPos":"Chuyên viên","workingUnit":"Sở Công Thương","telNo":"0977.397.198","userId":"010","userType":"1"},{"fullName":"Đào Thị Thu Lan","jobPos":"Chuyên viên","workingUnit":"Sở Giáo dục và Đào tạo","telNo":"0984.724.829","userId":"011","userType":"1"},{"fullName":"Ngô Xuân Ban","jobPos":"Chuyên viên","workingUnit":"Sở Giáo dục và Đào tạo","telNo":"0912.937.289","userId":"012","userType":"1"},{"fullName":"Bế Xuân Hưng","jobPos":"Chuyên viên","workingUnit":"Sở Giao thông vận tải","telNo":"0984.210.940","userId":"013","userType":"1"},{"fullName":"Hà Quốc Khánh","jobPos":"Chuyên viên","workingUnit":"Sở Giao thông vận tải","telNo":"0866.628.629","userId":"014","userType":"1"},{"fullName":"Nguyễn Thị Út Bình","jobPos":"Chuyên viên","workingUnit":"Sở Tư pháp","telNo":"0989.122.655","userId":"015","userType":"1"},{"fullName":"Nguyễn Thị Ngọc Bích","jobPos":"Chuyên viên","workingUnit":"Sở Tư pháp","telNo":"0979.858.458","userId":"016","userType":"1"},{"fullName":"Nguyễn Thị Vân Anh","jobPos":"Chuyên viên","workingUnit":"Sở Y tế","telNo":"0979.852.991","userId":"017","userType":"1"},{"fullName":"Hoàng Cẩm Việt","jobPos":"Chuyên viên","workingUnit":"Sở Y tế","telNo":"0977.137.888","userId":"018","userType":"1"},{"fullName":"Nguyễn Thị Vân","jobPos":"Phó Chánh văn phòng","workingUnit":"Sở Tài nguyên và Môi trường","telNo":"0982.021.378","userId":"019","userType":"1"},{"fullName":"Dương Hồng Văn","jobPos":"Chuyên viên","workingUnit":"Sở Tài nguyên và Môi trường","telNo":"0919.625.648","userId":"020","userType":"1"},{"fullName":"Nguyễn Mạnh Tuấn","jobPos":"Chuyên viên","workingUnit":"Sở Ngoại vụ","telNo":"0944.020.368","userId":"021","userType":"1"},{"fullName":"Lê Phương Thảo","jobPos":"Chuyên viên","workingUnit":"Sở Ngoại vụ","telNo":"0988.193.287","userId":"022","userType":"1"},{"fullName":"Nguyễn Kim Ngọc","jobPos":"Chuyên viên","workingUnit":"Sở Xây dựng","telNo":"0915.324.555","userId":"023","userType":"1"},{"fullName":"Tạ Đình Anh","jobPos":"Chuyên viên","workingUnit":"Sở Xây dựng","telNo":"0915.801.289","userId":"024","userType":"1"},{"fullName":"Trần Thị Kim Phương","jobPos":"Chuyên viên","workingUnit":"Sở Nông nghiệp và phát triển nông thôn","telNo":"0982.838.169","userId":"025","userType":"1"},{"fullName":"Lương Thế Cường","jobPos":"Chuyên viên","workingUnit":"Sở Nông nghiệp và phát triển nông thôn","telNo":"0987.482.725","userId":"026","userType":"1"},{"fullName":"Phan Thành Nguyên","jobPos":"Phó Trưởng phòng","workingUnit":"Sở Thông tin và Truyền thông","telNo":"0975.322.668","userId":"027","userType":"1"},{"fullName":"Bùi Thị Tường","jobPos":"Chuyên viên","workingUnit":"Sở Thông tin và Truyền thông","telNo":"0912.201.087","userId":"028","userType":"1"},{"fullName":"Nguyễn Thị Bích Liên","jobPos":"Phó Trưởng phòng","workingUnit":"Sở Kế hoạch và đầu tư","telNo":"0916.515.656","userId":"029","userType":"1"},{"fullName":"Nguyễn Tiến Dũng","jobPos":"Phó Chánh văn phòng","workingUnit":"Sở Kế hoạch và đầu tư","telNo":"0936.282.207","userId":"030","userType":"1"},{"fullName":"Lê Anh Dũng","jobPos":"Chuyên viên","workingUnit":"Sở Lao động, Thương binh và Xã hội","telNo":"0913.225.468","userId":"031","userType":"1"},{"fullName":"Nguyễn Minh Cường","jobPos":"Chuyên viên","workingUnit":"Sở Lao động, Thương binh và Xã hội","telNo":"0985.333.898","userId":"032","userType":"1"},{"fullName":"Nguyễn Thị Bạch Tuyết","jobPos":"Trưởng phòng","workingUnit":"Sở Văn hóa, Thể thao và Du lịch","telNo":"0936.417.568","userId":"033","userType":"1"},{"fullName":"Lê Thị Thu Lan","jobPos":"Chuyên viên","workingUnit":"Sở Văn hóa, Thể thao và Du lịch","telNo":"0915.171.131","userId":"034","userType":"1"},{"fullName":"Đỗ Tuấn Anh","jobPos":"Chuyên viên","workingUnit":"Sở Khoa học và Công nghệ","telNo":"0948.648.785","userId":"035","userType":"1"},{"fullName":"Hứa Thị Thanh Huyền","jobPos":"Chuyên viên","workingUnit":"Sở Khoa học và Công nghệ","telNo":"0986.699.786","userId":"036","userType":"1"},{"fullName":"Nguyễn Mạnh Tuấn","jobPos":"Chuyên viên","workingUnit":"Sở Nội vụ","telNo":"0914.223.001","userId":"037","userType":"1"},{"fullName":"Đặng Văn Nam","jobPos":"Chuyên viên","workingUnit":"Sở Nội vụ","telNo":"0978.098.588","userId":"038","userType":"1"}]}}

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(541),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "D:\\FDS\\frontend-opencps-v2.1\\onegate_21_kios_bng\\src\\components\\pagination.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] pagination.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ec1a172a", Component.options)
  } else {
    hotAPI.reload("data-v-ec1a172a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ })

},[229]);


// WEBPACK FOOTER //
// o/opencps-frontend/kios_bng/js/app.js